/**
 * @author monitour
 * created on 27.07.2017
 */
(function() {
  'use strict';

  angular.module('Monitour.pages', [
      'ui.router',
      'Monitour.pages.main',
      'Monitour.pages.dashboard',
      'Monitour.pages.profile',
      'Monitour.pages.login',
      'Monitour.pages.register',
	  'Monitour.pages.password',
    'Monitour.pages.invoice',
    'Monitour.pages.payment',
    'Monitour.pages.mobile',
	

    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($urlRouterProvider, baSidebarServiceProvider) {
    $urlRouterProvider.otherwise('/login');


  }

})();
/**
 * @author monitour
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('Monitour.theme', [
      'toaster',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'Monitour.theme.components',
      'Monitour.theme.inputs'
      
  ]);

})();

/**
 * @author monitour
 * created on 27.07.2017
 */
(function() {
  'use strict';

  angular.module('Monitour.pages.charts', [
      'Monitour.pages.charts.amCharts',
      'Monitour.pages.charts.chartJs',
      'Monitour.pages.charts.chartist',
      'Monitour.pages.charts.morris'
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts', {
        url: '/charts',
        abstract: true,
        template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
        title: 'Charts',
        sidebarMeta: {
          icon: 'ion-stats-bars',
          order: 150,
        },
        authenticate: true
      });
  }

})();
(function() {
  'use strict';

  angular.module('Monitour.pages.login', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('login', {
        url: '/login',
        templateUrl: 'app/pages/login/login.html',
        title: 'My Page',
        controller: 'loginCtrl',
		controllerAs: 'vm',
        sidebarMeta: {
          order: 800,
        },
        authenticate: false
      });
  }

})();
/**
 * @author monitour
 * created on 27.07.2017
 */
(function() {
    'use strict';
  
    angular.module('Monitour.pages.invoice', [])
      .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
      $stateProvider
           .state('main.invoices', {
            url: '/invoices',  	 
            templateUrl: 'app/pages/invoices/invoices.html',        
            title: 'Invoice',		
            controller: 'InvoicesCtrl',
            controllerAs: 'vm',
            sidebarMeta: {
              icon: "ion-document",
            order: 0,
             },
            authenticate: true
          })
          .state('main.invoices.view', {
            url: '/view/:id',
            title: 'View Invoice',
            controller: 'InvoiceCtrl',
            controllerAs: 'vm',
            templateUrl: 'app/pages/invoices/view/invoice.html',
            authenticate: true
        })
         
           //$urlRouterProvider.when('/', '/');
    }
  
  })();


 
/**
 * @author l.azevedo
 * created on 29.07.2017
 */
(function() {
  'use strict';

  angular.module('Monitour.pages.main', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main', {
        url: '/main',
        templateUrl: 'app/pages/main/main.html',
        redirectTo: 'main.dashboardmap',
        authenticate: true,
        abstract: true,
          controller: 'mainCtrl',
          controllerAs: 'vm'


      });
  }

})();
/**
 * @author monitour
 * created on 27.07.2017
 */
(function() {
  'use strict';

  angular.module('Monitour.pages.dashboard', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
         .state('main.dashboard', {
          url: '/dashboard',  	 
		  templateUrl: 'app/pages/dashboard/dashboard.html',        
          title: 'Dashboard',		
		  controller: 'DashboardMapCtrl',
		  controllerAs: 'vm',
      sidebarMeta: {
        icon: 'ion-android-home',
        order: 0,
      },
		  authenticate: true
        })
		
		 //$urlRouterProvider.when('/', '/');
  }

})();
/**
 * @author monitour
 * created on 27.07.2017
 */
(function() {
  'use strict';

  angular.module('Monitour.pages.profile', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.profile', {
        url: '/profile',
        title: 'Profile',
        templateUrl: 'app/pages/profile/profile.html',
        controller: 'ProfilePageCtrl',
        controllerAs: 'vm',
        sidebarMeta: {
          icon: 'ion-gear-a',
          order: 100,
        },
        authenticate: true
      })
      .state('main.profile.edit', {
            url: '/prole/edit/:id',
            title: 'Edit client',
            controller: 'editCtrl',
            controllerAs: 'vm',
            templateUrl: 'app/pages/profile/edit/edit.html',
            authenticate: true

        })

        .state('main.profile.plans', {
          url: '/plans',
          templateUrl: 'app/pages/profile/plans/plans.html',
          title: 'Plans',
          controller: 'plansCtrl',
          controllerAs: 'vm',
          authenticate: true
      })
 .state('main.profile.purchase', {
          url: '/purchase/:id',
          title: 'Purchase',
          controller: 'purchaseCtrl',
          controllerAs: 'vm',
          templateUrl: 'app/pages/profile/purchase/purchase.html',
          authenticate: true
      });

  }

})();
(function() {
  'use strict';

  angular.module('Monitour.pages.password', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('password', {
        url: '/password',
        templateUrl: 'app/pages/password/password.html',
        title: 'My Page',
        controller: 'passwordCtrl',
		controllerAs: 'vm',       
        authenticate: false
      })
	  .state('pin', {
          url: '/pin',  	 
		  templateUrl: 'app/pages/password/pin.html',
          title: 'Enter Pin',
		  controller: 'pinCtrl',
		  controllerAs: 'vm',
	       params: {
             'user': null
            },
		 authenticate: false
        })
		  .state('confirm', {
          url: '/confirm',
		  templateUrl: 'app/pages/password/confirm-password.html',
          title: 'Confirm Password',
		  controller: 'confirmCtrl',
		  controllerAs: 'vm',
		  params: {
			'pin': null,
            'user': null
            },
		 authenticate: false
        })
		 .state('success', {
          url: '/password/success',
		  templateUrl: 'app/pages/password/success.html',
          title: 'Password Change Success',
		  controller: 'authSuccessCtrl',
		  controllerAs: 'vm',
		  authenticate: false
        });
  }

})();
(function() {
  'use strict';

  angular.module('Monitour.pages.register', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('register', {
        url: '/register',
        templateUrl: 'app/pages/register/register.html',
        title: 'My Page',
        controller: 'registerCtrl',
        sidebarMeta: {
          order: 800,
        },
        authenticate: false
      });
  }

})();
/**
 * @author monitour
 * created on 27.07.2017
 */
(function() {
    'use strict';
  
    angular.module('Monitour.pages.payment', [])
      .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
      $stateProvider
           .state('main.payments', {
            url: '/payments',  	 
            templateUrl: 'app/pages/payments/payments.html',        
            title: 'Payment History',		
            controller: 'PaymentsCtrl',
            controllerAs: 'vm',
            sidebarMeta: {
              icon:"ion-calendar",
            order: 0,
             },
            authenticate: true
          })
          .state('main.payments.view', {
            url: '/payments/:id',
            title: 'payment',
            controller: 'PaymentCtrl',
            controllerAs: 'vm',
            templateUrl: 'app/pages/payments/view/payment.html',
            authenticate: true
        });
           //$urlRouterProvider.when('/', '/');
    }
  
  })();
/**
 * @author monitour
 * created on 27.07.2017
 */
(function() {
    'use strict';

    angular.module('Monitour.pages.settings', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.settings', {
                url: '/settings',
                title: 'Settings',
                templateUrl: 'app/pages/settings/settings.html',
                controller: 'settingsCtrl',
                controllerAs: 'vm',
                authenticate: true
            });

    }

})();
/**
 * @author monitour
 * created on 27.07.2017
 */
(function() {
  'use strict';

  angular.module('Monitour.pages.tables', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('main.tables', {
        url: '/tables',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        controller: 'TablesPageCtrl',
        title: 'Tables',
        sidebarMeta: {
          icon: 'ion-grid',
          order: 300,
        },
        authenticate: true
      }).state('main.tables.basic', {
        url: '/basic',
        templateUrl: 'app/pages/tables/basic/tables.html',
        title: 'Basic Tables',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      }).state('main.tables.smart', {
        url: '/smart',
        templateUrl: 'app/pages/tables/smart/tables.html',
        title: 'Smart Tables',
        sidebarMeta: {
          order: 100,
        },
        authenticate: true
      });
    $urlRouterProvider.when('/main/tables', '/main/tables/basic');
  }

})();
/**
 * @author monitour
 * created on 27.07.2017
 */
(function() {
    'use strict';

    angular.module('Monitour.pages.sites', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.sites', {
                url: '/sites',
                templateUrl: 'app/pages/sites/sites.html',
                title: 'Sites',
                abstract: true,
                sidebarMeta: {
                    icon: 'ion-gear-a',
                    order: 100,
                },
                authenticate: true
            })
            .state('main.sites.list', {
                url: '/sites/list',
                templateUrl: 'app/pages/sites/list/list.html',
                title: 'List',
                controller: 'sitesListCtrl',
                controllerAs: 'vm',
                sidebarMeta: {
                    icon: 'ion-stats-bars',
                    order: 150,
                },
                authenticate: true
            })
            .state('main.sites.new', {
                url: '/sites/new',
                templateUrl: 'app/pages/sites/new/new.html',
                title: 'Add',
                controller: 'sitesNewCtrl',
                controllerAs: 'vm',
                sidebarMeta: {
                    icon: 'ion-stats-bars',
                    order: 150,
                },
                authenticate: true
            })
            .state('main.sites.view', {
                url: '/sites/view/:id',
                title: 'View',
                controller: 'sitesViewCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/pages/sites/view/view.html',

            })
            .state('main.sites.edit', {
                url: '/sites/edit/:id',
                title: 'Edit',
                controller: 'sitesEditCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/pages/sites/edit/edit.html',

            });


    }

})();
/**
 * @author monitour
 * created on 27.07.2017
 */
(function() {
    'use strict';

    angular.module('Monitour.pages.user', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.user', {
                url: '/user',
                templateUrl: 'app/pages/user/user.html',
                title: 'Users',
                abstract: true,
                sidebarMeta: {
                    icon: 'ion-gear-a',
                    order: 100,
                },
                authenticate: true
            })
            .state('main.user.list', {
                url: '/list',
                templateUrl: 'app/pages/user/list/list.html',
                title: 'List users',
                controller: 'userListCtrl',
                controllerAs: 'vm',
                sidebarMeta: {
                    icon: 'ion-stats-bars',
                    order: 150,
                },
                authenticate: true
            })
            .state('main.user.view', {
                url: '/view/:id',
                title: 'View',
                controller: 'userViewCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/pages/user/view/view.html',
                authenticate: true
            })
		   .state('main.user.new', {
                url: '/new',
                templateUrl: 'app/pages/user/new/new.html',
                title: 'Add user',
                controller: 'userNewCtrl',
                controllerAs: 'vm',
                sidebarMeta: {
                    icon: 'ion-stats-bars',
                    order: 150,
                },
                authenticate: true
            })
            .state('main.user.edit', {
                url: '/edit/:id',
                title: 'Edit',
                controller: 'userEditCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/pages/user/edit/edit.html',
                authenticate: true
            });
         


    }

})();
/**
 * @author k.danovsky
 * created on 12.01.2016
 */
(function() {
  'use strict';

  angular.module('Monitour.pages.ui', [
      'Monitour.pages.ui.typography',
      'Monitour.pages.ui.buttons',
      'Monitour.pages.ui.icons',
      'Monitour.pages.ui.modals',
      'Monitour.pages.ui.grid',
      'Monitour.pages.ui.alerts',
      'Monitour.pages.ui.progressBars',
      'Monitour.pages.ui.notifications',
      'Monitour.pages.ui.tabs',
      'Monitour.pages.ui.slider',
      'Monitour.pages.ui.panels',
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui', {
        url: '/ui',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'UI Features',
        sidebarMeta: {
          icon: 'ion-android-laptop',
          order: 200,
        },
        authenticate: true
      });
  }

})();
/**
 * @author v.lugovksy
 * created on 27.07.2017
 */
/**
 * @author monitour
 * created on 27.07.2017
 */
(function () {
  'use strict';

  angular.module('Monitour.theme.components', []);

})();

/**
 * @author monitour
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('Monitour.theme.inputs', []);

})();

/**
 * @author monitour
 * created on 27.07.2017
 */
(function() {
  'use strict';

  angular.module('Monitour.pages.charts.amCharts', [])
    .config(routeConfig).config(amChartConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts.amCharts', {
        url: '/amCharts',
        templateUrl: 'app/pages/charts/amCharts/charts.html',
        title: 'amCharts',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      });
  }

  function amChartConfig(baConfigProvider) {
    var layoutColors = baConfigProvider.colors;
    AmCharts.themes.blur = {

      themeName: "blur",

      AmChart: {
        color: layoutColors.defaultText,
        backgroundColor: "#FFFFFF"
      },

      AmCoordinateChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmStockChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmSlicedChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark],
        labelTickColor: "#FFFFFF",
        labelTickAlpha: 0.3
      },

      AmRectangularChart: {
        zoomOutButtonColor: '#FFFFFF',
        zoomOutButtonRollOverAlpha: 0.15,
        zoomOutButtonImage: "lens.png"
      },

      AxisBase: {
        axisColor: "#FFFFFF",
        axisAlpha: 0.3,
        gridAlpha: 0.1,
        gridColor: "#FFFFFF"
      },

      ChartScrollbar: {
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.12,
        graphFillAlpha: 0.5,
        graphLineAlpha: 0,
        selectedBackgroundColor: "#FFFFFF",
        selectedBackgroundAlpha: 0.4,
        gridAlpha: 0.15
      },

      ChartCursor: {
        cursorColor: layoutColors.primary,
        color: "#FFFFFF",
        cursorAlpha: 0.5
      },

      AmLegend: {
        color: "#FFFFFF"
      },

      AmGraph: {
        lineAlpha: 0.9
      },
      GaugeArrow: {
        color: "#FFFFFF",
        alpha: 0.8,
        nailAlpha: 0,
        innerRadius: "40%",
        nailRadius: 15,
        startWidth: 15,
        borderAlpha: 0.8,
        nailBorderAlpha: 0
      },

      GaugeAxis: {
        tickColor: "#FFFFFF",
        tickAlpha: 1,
        tickLength: 15,
        minorTickLength: 8,
        axisThickness: 3,
        axisColor: '#FFFFFF',
        axisAlpha: 1,
        bandAlpha: 0.8
      },

      TrendLine: {
        lineColor: layoutColors.danger,
        lineAlpha: 0.8
      },

      // ammap
      AreasSettings: {
        alpha: 0.8,
        color: layoutColors.info,
        colorSolid: layoutColors.primaryDark,
        unlistedAreasAlpha: 0.4,
        unlistedAreasColor: "#FFFFFF",
        outlineColor: "#FFFFFF",
        outlineAlpha: 0.5,
        outlineThickness: 0.5,
        rollOverColor: layoutColors.primary,
        rollOverOutlineColor: "#FFFFFF",
        selectedOutlineColor: "#FFFFFF",
        selectedColor: "#f15135",
        unlistedAreasOutlineColor: "#FFFFFF",
        unlistedAreasOutlineAlpha: 0.5
      },

      LinesSettings: {
        color: "#FFFFFF",
        alpha: 0.8
      },

      ImagesSettings: {
        alpha: 0.8,
        labelColor: "#FFFFFF",
        color: "#FFFFFF",
        labelRollOverColor: layoutColors.primaryDark
      },

      ZoomControl: {
        buttonFillAlpha: 0.8,
        buttonIconColor: layoutColors.defaultText,
        buttonRollOverColor: layoutColors.danger,
        buttonFillColor: layoutColors.primaryDark,
        buttonBorderColor: layoutColors.primaryDark,
        buttonBorderAlpha: 0,
        buttonCornerRadius: 0,
        gridColor: "#FFFFFF",
        gridBackgroundColor: "#FFFFFF",
        buttonIconAlpha: 0.6,
        gridAlpha: 0.6,
        buttonSize: 20
      },

      SmallMap: {
        mapColor: "#000000",
        rectangleColor: layoutColors.danger,
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.7,
        borderThickness: 1,
        borderAlpha: 0.8
      },

      // the defaults below are set using CSS syntax, you can use any existing css property
      // if you don't use Stock chart, you can delete lines below
      PeriodSelector: {
        color: "#FFFFFF"
      },

      PeriodButton: {
        color: "#FFFFFF",
        background: "transparent",
        opacity: 0.7,
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        boxSizing: "border-box"
      },

      PeriodButtonSelected: {
        color: "#FFFFFF",
        backgroundColor: "#b9cdf5",
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        opacity: 1,
        boxSizing: "border-box"
      },

      PeriodInputField: {
        color: "#FFFFFF",
        background: "transparent",
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      },

      DataSetSelector: {
        color: "#FFFFFF",
        selectedBackgroundColor: "#b9cdf5",
        rollOverBackgroundColor: "#a8b0e4"
      },

      DataSetCompareList: {
        color: "#FFFFFF",
        lineHeight: "100%",
        boxSizing: "initial",
        webkitBoxSizing: "initial",
        border: "1px solid rgba(0, 0, 0, .3)"
      },

      DataSetSelect: {
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      }

    };
  }

})();
/**
 * @author a.demeshko
 * created on 12/17/15
 */
(function() {
  'use strict';

  angular.module('Monitour.pages.charts.chartist', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts.chartist', {
        url: '/chartist',
        templateUrl: 'app/pages/charts/chartist/chartist.html',
        title: 'Chartist',
        sidebarMeta: {
          order: 100,
        },
        authenticate: true
      });
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function() {
  'use strict';

  angular.module('Monitour.pages.charts.chartJs', [])
    .config(routeConfig).config(chartJsConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts.chartJs', {
        url: '/chartJs',
        templateUrl: 'app/pages/charts/chartJs/chartJs.html',
        title: 'Chart.js',
        sidebarMeta: {
          order: 200
        },
        authenticate: true
      });
  }

  function chartJsConfig(ChartJsProvider, baConfigProvider) {
    var layoutColors = baConfigProvider.colors;
    // Configure all charts
    ChartJsProvider.setOptions({
      chartColors: [
        layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.default, layoutColors.primaryDark, layoutColors.successDark, layoutColors.warningLight, layoutColors.successLight, layoutColors.primaryLight
      ],
      responsive: true,
      maintainAspectRatio: false,
      animation: {
        duration: 2500
      },
      scale: {
        gridLines: {
          color: layoutColors.border
        },
        scaleLabel: {
          fontColor: layoutColors.defaultText
        },
        ticks: {
          fontColor: layoutColors.defaultText,
          showLabelBackdrop: false
        }
      }
    });
    // Configure all line charts
    ChartJsProvider.setOptions('Line', {
      datasetFill: false
    });
    // Configure all radar charts
    ChartJsProvider.setOptions('radar', {
      scale: {
        pointLabels: {
          fontColor: layoutColors.defaultText
        },
        ticks: {
          maxTicksLimit: 5,
          display: false
        }
      }
    });
    // Configure all bar charts
    ChartJsProvider.setOptions('bar', {
      tooltips: {
        enabled: false
      }
    });
  }

})();
/**
 * @author a.demeshko
 * created on 12/18/15
 */
(function() {
  'use strict';

  angular.module('Monitour.pages.charts.morris', [])
    .config(routeConfig).config(function(baConfigProvider) {
      var layoutColors = baConfigProvider.colors;
      Morris.Donut.prototype.defaults.backgroundColor = 'transparent';
      Morris.Donut.prototype.defaults.labelColor = layoutColors.defaultText;
      Morris.Grid.prototype.gridDefaults.gridLineColor = layoutColors.borderDark;
      Morris.Grid.prototype.gridDefaults.gridTextColor = layoutColors.defaultText;
    });

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.charts.morris', {
        url: '/morris',
        templateUrl: 'app/pages/charts/morris/morris.html',
        title: 'Morris',
        sidebarMeta: {
          order: 300,
        },
        authenticate: true
      });
  }

})();
/**
 * @author monitour
 * created on 27.07.2017
 */
(function() {
  'use strict';

  angular.module('Monitour.pages.ui.alerts', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.alerts', {
        url: '/alerts',
        templateUrl: 'app/pages/ui/alerts/alerts.html',
        title: 'Alerts',
        sidebarMeta: {
          order: 500,
        },
        authenticate: true
      });
  }

})();
/**
 * @author monitour
 * created on 27.07.2017
 */
(function() {
  'use strict';

  angular.module('Monitour.pages.ui.buttons', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.buttons', {
        url: '/buttons',
        templateUrl: 'app/pages/ui/buttons/buttons.html',
        controller: 'ButtonPageCtrl',
        title: 'Buttons',
        sidebarMeta: {
          order: 100,
        },
        authenticate: true
      });
  }

})();
/**
 * @author monitour
 * created on 27.07.2017
 */
(function() {
  'use strict';

  angular.module('Monitour.pages.ui.grid', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.grid', {
        url: '/grid',
        templateUrl: 'app/pages/ui/grid/grid.html',
        title: 'Grid',
        sidebarMeta: {
          order: 400,
        },
        authenticate: true
      });
  }

})();
/**
 * @author monitour
 * created on 27.07.2017
 */
(function() {
  'use strict';

  angular.module('Monitour.pages.ui.modals', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.modals', {
        url: '/modals',
        templateUrl: 'app/pages/ui/modals/modals.html',
        controller: 'ModalsPageCtrl',
        title: 'Modals',
        sidebarMeta: {
          order: 300,
        },
        authenticate: true
      });
  }

})();
/**
 * @author monitour
 * created on 27.07.2017
 */
(function() {
  'use strict';

  angular.module('Monitour.pages.ui.icons', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.icons', {
        url: '/icons',
        templateUrl: 'app/pages/ui/icons/icons.html',
        controller: 'IconsPageCtrl',
        title: 'Icons',
        sidebarMeta: {
          order: 200,
        },
        authenticate: true
      });
  }

})();
/**
 * @author monitour
 * created on 27.07.2017
 */
(function() {
  'use strict';

  angular.module('Monitour.pages.ui.progressBars', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.progressBars', {
        url: '/progressBars',
        templateUrl: 'app/pages/ui/progressBars/progressBars.html',
        title: 'Progress Bars',
        sidebarMeta: {
          order: 600,
        },
        authenticate: true
      });
  }

})();
/**
 * @author monitour
 * created on 27.07.2017
 */
(function() {
  'use strict';

  angular.module('Monitour.pages.ui.notifications', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.notifications', {
        url: '/notifications',
        templateUrl: 'app/pages/ui/notifications/notifications.html',
        controller: 'NotificationsPageCtrl',
        title: 'Notifications',
        sidebarMeta: {
          order: 700,
        },
        authenticate: true
      });
  }

})();
/**
 * @author monitour
 * created on 21.12.2015
 */
(function() {
  'use strict';

  angular.module('Monitour.pages.ui.tabs', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.tabs', {
        url: '/tabs',
        templateUrl: 'app/pages/ui/tabs/tabs.html',
        title: 'Tabs & Accordions',
        sidebarMeta: {
          order: 800,
        },
        authenticate: true
      });
  }

})();
/**
 * @author monitour
 * created on 23.12.2015
 */
(function() {
  'use strict';

  angular.module('Monitour.pages.ui.panels', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.panels', {
        url: '/panels',
        templateUrl: 'app/pages/ui/panels/panels.html',
        controller: 'NotificationsPageCtrl',
        title: 'Panels',
        sidebarMeta: {
          order: 1100,
        },
        authenticate: true
      });
  }

})();
/**
 * @author a.demeshko
 * created on 12/22/15
 */
(function() {
  'use strict';

  angular.module('Monitour.pages.ui.slider', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.slider', {
        url: '/slider',
        templateUrl: 'app/pages/ui/slider/slider.html',
        title: 'Sliders',
        sidebarMeta: {
          order: 1000,
        },
        authenticate: true
      });
  }

})();
/**
 * @author monitour
 * created on 27.07.2017
 */
(function() {
  'use strict';

  angular.module('Monitour.pages.ui.typography', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('main.ui.typography', {
        url: '/typography',
        templateUrl: 'app/pages/ui/typography/typography.html',
        title: 'Typography',
        sidebarMeta: {
          order: 0,
        },
        authenticate: true
      });
  }

})();
'use strict';

angular.module('Monitour', [
  'ngAnimate',
  'ui.bootstrap',
  'ui.sortable',
  'ui.router',
  'ngTouch',
  'toastr',
  'smart-table',
  'ui.slimscroll',
  'angular-progress-button-styles',
  'ngStorage',
  'oitozero.ngSweetAlert',
  'angular-loading-bar',
  'nya.bootstrap.select',
  'ngAutocomplete',
  'nemLogging',
  'btford.socket-io',
  'ngDropdowns',
  'daterangepicker',
  'ngMessages',
  'pageslide-directive',
  'ngImgCrop',
  'ngFileUpload',
  'angularUtils.directives.dirPagination',
  'ngMap',
  'ngAutocomplete',
  'vsGoogleAutocomplete',
  'angucomplete-alt',
  'ui.sortable',
  'ngCookies',
  'pascalprecht.translate',
  'angular-timezone-selector',
  'ngCountryStateSelect',
  'angular-progress-arc',
  'angular-owl-carousel-2',
  'AngularPrint',



  









  'Monitour.theme',
  'Monitour.pages'
]);
/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('Monitour.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, $translateProvider, $httpProvider, $locationProvider, colorHelper, $provide, cfpLoadingBarProvider) {
      $locationProvider.html5Mode(true);
      $translateProvider
          .useLocalStorage()
          .useStaticFilesLoader({
              prefix: 'assets/language/',
              suffix: '.json'
          })
          .useSanitizeValueStrategy('sanitize')
          .preferredLanguage('en_US')
          .fallbackLanguage(['en_US',  'ar'])
          .determinePreferredLanguage();
      $translateProvider.forceAsyncReload(true);

      // remember language
      $translateProvider.useLocalStorage();

	  $httpProvider.defaults.useXDomain = true;

	  delete $httpProvider.defaults.headers.common['X-Requested-With'];



     $provide.decorator('$uiViewScroll', uiViewScrollDecorator);


    cfpLoadingBarProvider.includeSpinner = false;
    cfpLoadingBarProvider.latencyThreshold = 1;
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#394454',
    warning: '#00ccbe',
    danger: '#2fbe9b',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('Monitour.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author monitour
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('Monitour.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

(function() {
  'use strict';
  angular.module('Monitour.theme')
    .run(stateChangeStart);


  /** @ngInject */
  function stateChangeStart($rootScope, $state, $localStorage, $http, $location) {
   
     // keep user logged in after page refresh
        if ($localStorage.currentUser) {
			console.log( $localStorage.currentUser);
		    $http.defaults.headers.common.Authorization = $localStorage.currentUser.token;
			
			 //you probably don't need this line.  This lets me connect to my server on a different domain
        }
 	   $http.defaults.headers.common['Authorization'] = $localStorage.currentUser;
	 //$http.defaults.headers.common = {"Access-Control-Request-Headers": "accept, origin, authorization"}; 
        // redirect to login page if not logged in and trying to access a restricted page
        $rootScope.$on('$locationChangeStart', function (event, next, current) {
			
                 // redirect to login page if not logged in and trying to access a restricted page
            var restrictedPage = $.inArray($location.path(), ['/login', '/register' , '/password' , '/pin', '/confirm']) === -1;
		    var loggedIn = $localStorage.currentUser;
			
            if (restrictedPage && !loggedIn) {
                $location.path('/login');
            }
          
        });
		
	

	
	
  }

})();
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('Monitour.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, $localStorage, $state,  $http, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('Monitour.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function () {
    'use strict';
 
    angular
      angular.module('Monitour.pages.login')
        .factory('AuthenticationService', AuthenticationService);
 
    function AuthenticationService($http, $localStorage, $translate) {
      var service = {};
 
        service.Login = Login;
        service.Logout = Logout;
 
        return service;
   
        function Login(username, password, callback) {
		var domain  = 'https://api.callio.com.au/public/';
		var path = 'login';
		var baseurl = domain + path;
		var datastring =  { email: username, password: password };
	
            $http.post(baseurl, datastring).then(function successCallback(response)  {
					
					console.log(response.data);
                    // login successful if there's a token in the response
                    if (response.data.access_token) {
						
						
                        // store username and token in local storage to keep user logged in between page refreshes
                        $localStorage.currentUser = response.data.access_token;

                        $localStorage.lang = response.data.language;
						$localStorage.currentUserid = response.data.id;

                        //$translate.use($localStorage.lang);
                        // add jwt token to auth header for all requests made by the $http service
                        $http.defaults.headers.common.Authorization = response.data.access_token;
 
                        // execute callback with true to indicate successful login
                        callback(response);
                    } else {
                        // execute callback with false to indicate failed login
                        callback(response);
                    }
                });
        }
 
        function Logout() {
            // remove user from local storage and clear http auth header
            delete $localStorage.currentUser; 
			 $localStorage.currentOwner;
            $localStorage.lang;
            $localStorage.currentUserid;
             $http.defaults.headers.common.Authorization = '';
			 $localStorage.currentUserCompany;
		     $localStorage.currentOwnerid;
		     $localStorage.currentClient ;
		     $localStorage.currentfirstname;
		     $localStorage.currentlastname;
		     $localStorage.url;
			 $localStorage.lang;
   
        }
    }
})();
(function() {
  'use strict';

  angular.module('Monitour.pages.login')
    .controller('loginCtrl', loginCtrl);

  /** @ngInject */
  function loginCtrl($scope,   AuthenticationService, $localStorage, $state) {
    var vm = this;
    vm.sentence = {static: 'Your total platrom management needs for'};
    
    // should be resolved by the router, and injected in this controller
    // that way, words are ready when the controller is instantiated
    // and when the link function of the directive is triggered
    vm.sentence.options = ['Calls', 'Programable Voice', 'Call Flows'];
   
        vm.login = login;
 
        initController();
 
        function initController() {
            // reset login status
            AuthenticationService.Logout();
        };
 
        function login() {
            vm.loading = true;
            AuthenticationService.Login(vm.username, vm.password, function (result) {
				
				vm.result = result;
				console.log(vm.result.data.data);
				console.log(vm.result.data.success);
		     vm.data = vm.result.data.data;
			  if (vm.result.data.access_token) {
			console.log($localStorage.currentUser);


                  swal({
						title: 'Succesfully logged in',
						text: vm.result.data.data
						});
				     $state.go('main.dashboard');
                } else {

                  swal({title: 'Your login details were incorrect!',
				    text:  vm.data
                  });
       
                }
            });
        };
    }

})();
/**
 * @author monitour
 * created on 27.07.2017
 */
(function() {
	'use strict';
	angular.module('Monitour.pages.invoice').controller('InvoicesCtrl', InvoicesCtrl);
	/** @ngInject */
	function InvoicesCtrl($scope, baConfig, $filter, colorHelper,  $http, $localStorage , $state,  SweetAlert,  $translate, $stateParams, InvoiceService) {
        var vm = this;
        vm.currentPage = 1;
        vm.itemsPerPage = 10; // Set a default value for items per page
       
        vm.smartTablePageSize = 10;
       
        InvoiceService.GetAll()
        .then(function (response) {
            vm.invoices = response.data[0].result;
            vm.totalinvoices = response.data[0].count;
    
            // Counting unpaid (false status) invoices
            vm.unpaidInvoicesCount = vm.invoices.filter(function(invoice) {
                return invoice.status === "false"; // or just `false` if it's a boolean
            }).length;
    
            console.log("Unpaid Invoices Count: ", vm.unpaidInvoicesCount);
            // Rest of your code...
        }, function (error) {
            vm.status = 'Unable to load customer data: ' + error.message;
        });
    
        vm.owner = $localStorage.currentUser;
     
       
      
         
          $scope.transparent = baConfig.theme.blur;
	}
})();

(function () {
    'use strict';
    angular.module('Monitour.pages.invoice')
        .factory('InvoiceService', InvoiceService);


    function InvoiceService($http, $localStorage) {
        var service = {};
        service.GetAll = GetAll;
        service.GetById = GetById;
        service.Update = Update;
        service.Count = Count;
        service.Delete = Delete;
        service.GetFilters = GetFilters;
        service.GetSubById = GetSubById;
        service.Renewal = Renewal;
        service.Payinvoice =Payinvoice;

        var domain = 'https://api.callio.com.au/public/';
        return service;

        function Count() {
            return $http.get(domain + 'invoices/count');
        }
        function Me() {
			return $http.get(domain + '/users/me');
		}

        function GetAll(pagenumber, itemsPerPage) {
            return $http.get(domain + 'invoices?page=' + pagenumber + '&limit=' + itemsPerPage);
        }

        function GetFilters(client, site, pagenumber, itemsPerPage) {
            return $http.get(domain + 'invoices?client=' + client + '&site_id=' + site + '&page=' + pagenumber + '&limit=' + itemsPerPage);
        }

        function GetById(id) {
            return $http.get(domain + 'invoices/' + id);
        }

        function GetSubById(id) {
            return $http.get(domain + 'invoices/' + id);
        }

        function Update(renewal) {
            return $http.patch(domain + 'renewal', renewal);
        }
        function Renewal(renewal) {
            return $http.patch(domain + 'renewal', renewal);
        }
      
        function Payinvoice(payment, id) {
            return $http.patch(domain + 'invoice/' + id, payment)
                .then(function(response) {
                    // Directly handle the success response here
                    return response.data;
                }, handleError('Error updating profile'));
        }
        function Delete(id) {
            return $http.delete(domain + 'invoice/' + id);
        }

        function handleError(errorMsg) {
            return function(response) {
                console.error('Error: ' + errorMsg, response);
                return { success: false, message: errorMsg };
            };
        }
        
        // private functions
    }
})();
/**
 * @author monitour
 * created on 27.07.2017
 */
(function () {
    'use strict';

    angular.module('Monitour.pages.main')
        .controller('mainCtrl', mainCtrl);

    /** @ngInject */
    function mainCtrl($scope, MainService,$localStorage) {
        var vm = this;


        MainService.GetAll().then(function(response) {
            $localStorage.currentOwnerid = response.owner;
            $localStorage.currentClient = response.client;
            $localStorage.langid = response.LanguageId;
            


    }, function() {
        $scope.error = 'unable to get the clients';
    });

    }

})();


(function () {
    'use strict';
    angular.module('Monitour.pages.main')
        .factory('MainService', MainService);


    function MainService($http, $localStorage) {

        var service = {};
        service.GetAll = GetAll;


        var domain = 'https://api.callio.com.au/public/';

        return service;


        function GetAll() {
            return $http.get(domain + 'users/me').then(handleSuccess, handleError('Error getting all details'));
        }



        // private functions

        function handleSuccess(res) {
            return res.data;
        }

        function handleError(error) {
            return function () {
                return { success: false, message: error };
            };
        }
    }

})();
/**
 * @author v.lugovksy
 * created on 27.07.2017
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.dashboard')
      .controller('DashboardCtrl', DashboardCtrl);

  /** @ngInject */
  function DashboardCtrl($scope) {
	  
  }
})();
/**
 * @author monitour
 * created on 27.07.2017
 */
(function() {
    'use strict';
  
    angular.module('Monitour.pages.mobile', [])
      .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
        .state('main.mobile', {
          url: '/mobile',
          title: 'mobile',
          templateUrl: 'app/pages/mobile/mobile.html',
          controller: 'MobilePageCtrl',
          controllerAs: 'vm',
         
          authenticate: true
        })
        
  
    }
  
  })();
/**
 * @author monitour
 * created on 27.07.2017
 */
(function () {
    'use strict';
  
    angular.module('Monitour.pages.mobile')
      .controller('MobilePageCtrl', MobilePageCtrl);
  
    /** @ngInject */
    function MobilePageCtrl($scope,$http, $localStorage, ProfileService, $state, SweetAlert, $stateParams, $timeout) {
      var vm = this;
      
      ProfileService.GetAll().then(function(response) {
        vm.details = response;
        console.log(response);
        console.log('hello');
     


    }, function(error) {
        $scope.status = 'Unable to load customer data: ' + error.message;
    });
  
    }
  
  })();
  
/**
 * @author monitour
 * created on 27.07.2017
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.profile')
    .controller('ProfilePageCtrl', ProfilePageCtrl);

  /** @ngInject */
  function ProfilePageCtrl($scope,$http, $localStorage, ProfileService, $state, SweetAlert, $stateParams, $timeout) {
    var vm = this;
    
    $scope.options = {
      componentRestrictions: { country: 'AU' }
    }

    $scope.slider = { min: 0, max: 0, from: 0, disable: true };

    function getDifferenceInDays(date1, date2) {
      var diffInTime = date2.getTime() - date1.getTime();
      return Math.floor(diffInTime / (1000 * 3600 * 24));
    }

$scope.$watchGroup(['vm.details.subscriptionStartDate', 'vm.details.subscriptionExpiryDate'], function(newValues) {
  if (newValues[0] && newValues[1]) {
      var startDate = new Date(newValues[0]);
      var expiryDate = new Date(newValues[1]);
      var currentDate = new Date();

      // Total period in days
      var totalPeriod = getDifferenceInDays(startDate, expiryDate);

      // Days elapsed since the start date
      var daysElapsed = getDifferenceInDays(startDate, currentDate);

      // Days remaining
      var daysRemaining = totalPeriod - daysElapsed;

      vm.daysLeft = daysRemaining;

      // Update the slider or display element
      $timeout(function() {
          $scope.slider.max = totalPeriod;
          $scope.slider.from = daysRemaining; // Position the slider to represent days elapsed
          console.log("Total Period: ", totalPeriod);
          console.log("Days Elapsed: ", daysElapsed);
          console.log("Days Remaining: ", daysRemaining);
      });
  }
});

$scope.unsubscribe = function() {
  console.log("Unsubscribe button clicked");

  swal({
      title: "Are you sure?",
      text: "You will not be able to recover this account or number!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, cancel my account!",
      cancelButtonText: "No, don't cancel my account",
      closeOnConfirm: false,
      closeOnCancel: false
  }, function(isConfirm) {
      if (isConfirm) {
          ProfileService.Delete().then(function successCallback(response) {           

              // Check if response indicates success
              if (response.data.success === true) {
                  swal("Deleted!", "Your account and number has been deleted.", "success");
                  $state.go('login');
              } else {
                  swal("Update was Unsuccessful", "Please check the details you entered.", "error");
              }
          }, function errorCallback(response) {
              // Handle error scenario
              swal("Error", "An error occurred during the process.", "error");
          });
      } else {
          swal("Cancelled", "Your account and number is safe :)", "error");
      }
  });

  // Other actions if necessary
};
vm.new = {
  streetNumber: '',
  street: '',
  city: '',
  state: '',
  country: '',
  postcode: ''
};


// Function to patch the recurring value
vm.patchRecurringBool = function() {
  var renewal = { renewal: vm.details.recurring };
  ProfileService.Renewal(renewal).then(function successCallback(response) {
    // Response handling
    var message = vm.details.recurring ? 
                  "Your account is on auto renewal." : 
                  "Your account is not on auto renewal.";

    if (response) {
      swal("Successfully Updated Your Account", "You have updated your account, " + message, "success");
      vm.initialRecurringValue = vm.details.recurring; // Update the initial value
    } else {
      swal("Update was Unsuccessful", "Please check the details you entered.", "error");
    }
  });
};

// Watch for changes in the recurring field
$scope.$watch('vm.details.recurring', function(newVal) {
  if (newVal !== vm.initialRecurringValue) {
    vm.patchRecurringBool();
  }
});

// Other code...


      function initializeAddress() {
        vm.details.place = [
            vm.details.address, 
            vm.details.city, 
            vm.details.state, 
            vm.details.country, 
            vm.details.postcode
        ].filter(Boolean).join(", ");
    }
    
      ProfileService.GetAll().then(function(response) {
        vm.details = response;
        initializeAddress();
        console.log(vm.details );
        vm.initialRecurringValue = vm.details.recurring;
        $localStorage.currentUserCompany = response.owner;


     


      }, function(error) {
          $scope.status = 'Unable to load customer data: ' + error.message;
      });

  
      vm.Update = Update;

      function Update () {
   // Construct the address string only if both streetNumber and street have values
   var address = '';
   if (vm.new.streetNumber && vm.new.street) {
       address = vm.new.streetNumber + ' ' + vm.new.street;
   }
      
  
        var profile  =  {lastname: vm.details.lastname, firstname: vm.details.firstname, email: vm.details.email, phone: vm.details.phone,
        address: address,
        city: vm.new.city,
        state: vm.new.state,
        country: vm.new.country,
        postcode: vm.new.postcode,
         passwordhash: vm.password, labelXref: vm.details.id, userXref: vm.details.id, power: '100' };
         console.log(profile);
         var id =  vm.details.id;
         console.log(id);

                vm.loading = true;
                ProfileService.Update(profile, id).then(function successCallback(response)  {

                  
                  
                  if (response) {

                    console.log(response);
           
                    swal({
                      title: 'Succesfully Updated your account',
                      text: 'you have updated your Profile'
                  });
    } else {
      swal({
        title: 'Updated was unsuccessful',
        text: 'please check your details you entered in'
    });
    }
                  
                });

                
            };

  }

})();

(function () {
    'use strict';

    angular.module('Monitour.pages.profile')
        .factory('ProfileService', ProfileService);

    /** @ngInject */
    function ProfileService($http, $localStorage) {
        var service = {
            GetAll: GetAll,
            GetById: GetById,
            Update: Update,
            Renewal: Renewal,
            Pay: Pay,
            Delete: Delete,
            MediaUpload: MediaUpload,
            MediaDownload: MediaDownload,
            MediaDownloadId: MediaDownloadId,
            MediaDeleteId: MediaDeleteId,
            Labels: Labels,
            GetLabels: GetLabels,
            UpdateLabels: UpdateLabels,
            Products: Products,
            ProductsById: ProductsById
        };

        var domain = 'https://api.callio.com.au/public/';

        console.log("ProfileService initialized");

        return service;

        function GetAll() {
            console.log("Fetching profile with GetAll");
            return $http.get(domain + 'users/me').then(handleSuccess, handleError('Error getting your profile by id'));
        }

        function GetById(id) {
            console.log("Fetching profile by id:", id);
            return $http.get(domain + 'users' + id).then(handleSuccess, handleError('Error getting your profile by id'));
        }

        function MediaUpload(picture) {
            console.log("Uploading media:", picture);
            return $http.post(domain + 'image/upload', picture).then(handleSuccess, handleError('Error getting your media by picture'));
        }

        function MediaDownload() {
            console.log("Downloading media");
            return $http.get(domain + 'image/download').then(handleSuccess, handleError('Error getting your media by picture'));
        }

        function MediaDownloadId(id) {
            console.log("Downloading media by id:", id);
            return $http.get(domain + 'image/download/' + id).then(handleSuccess, handleError('Error getting your media by picture'));
        }

        function Labels(label) {
            console.log("Posting label:", label);
            return $http.post(domain + 'labels', label).then(handleSuccess, handleError('Error posting your label'));
        }

        function GetLabels() {
            console.log("Fetching labels");
            return $http.get(domain + 'labels').then(handleSuccess, handleError('Error getting your profile by id'));
        }

        function UpdateLabels(data, id) {
            console.log("Updating labels for id:", id, "with data:", data);
            return $http.patch(domain + 'labels/' + id, data).then(handleSuccess, handleError('Error updating profile'));
        }

        function Update(profile) {
            console.log("Updating profile:", profile);
            return $http.patch(domain + 'userupdate', profile);
        }

        function Pay(payment, id) {
            console.log("Processing payment for id:", id, "with payment data:", payment);
            return $http.patch(domain + 'pay/' + id, payment).then(handleSuccess, handleError('Error updating profile'));
        }

        function Delete() {
            console.log("Deleting user");
            return $http.delete(domain + 'userdelete').then(handleSuccess, handleError('Error deleting route'));
        }

        function Renewal(renewal) {
            console.log("Processing renewal:", renewal);
            return $http.patch(domain + 'renewal', renewal);
        }

        function Products() {
            console.log("Fetching products from API");
            return $http.get(domain + 'products')
                .then(function(response) {
                    console.log("Products fetched successfully:", response);
                    return response;
                })
                .catch(function(error) {
                    console.error("Error fetching products:", error);
                    return handleError('Error fetching products')(error);
                });
        }

        function ProductsById(id) {
            console.log("Fetching product by id:", id);
            return $http.get(domain + 'products/' + id).then(handleSuccess, handleError('Error updating profile'));
        }

        function MediaDeleteId(id) {
            console.log("Deleting media by id:", id);
            return $http.delete(domain + 'media/' + id).then(handleSuccess, handleError('Error deleting route'));
        }

        function handleSuccess(res) {
            return res.data;
        }

        function handleError(error) {
            return function () {
                return { success: false, message: error };
            };
        }
    }
})();

(function () {
    'use strict';
 
    angular.module('Monitour.pages.profile')
        .factory('UserService', UserService);
 
    function UserService($http, $localStorage) {
	    
		var service = {}; 
		
        service.GetAll = GetAll;
		 service.Me = Me;
		service.GetAllPage = GetAllPage;
        service.GetById = GetById;
		service.Count = Count;
        service.GetByUsername = GetByUsername;
        service.Create = Create;
        service.Update = Update;
        service.Delete = Delete;
		service.userlabels = userlabels;
        service.labels = labels;
 
 
        var domain  = 'https://api.callio.com.au/public/';
        return service;
   
		
        function GetAll() {
            return $http.get(domain + 'users');
        }
		function Me() {
			return $http.get(domain + '/users/me');
		}
				
        function Count() {
            return $http.get(domain + 'users/count');
        }
        	
        function GetAllPage(itemsper, pager) {
            return $http.get(domain + 'users?page=' + pager + '&limit=' + itemsper);
        }
		  		
        function GetById(id) {
            return $http.get(domain + 'users/' + id);
        }
 
        function GetByUsername(username) {
            return $http.get(domain + 'users' + username);
        }
 
        function Create(user) {
            return $http.post(domain + 'usernew', user);
        }
 
        function Update(user, id) {
            return $http.patch(domain + 'userupdate/' + id, user);
        }
		
		function userlabels(id) {
			 return $http.get(domain + 'userlabels');
		}
		
		function labels() {
			
			return $http.get(domain + 'labels');
		}
 
        function Delete(id) {
            return $http.delete(domain + 'users/' + id);
        }
		
    
 
        // private functions
 
 
      
    }
 
})();
(function() {
    'use strict';
  
    angular.module('Monitour.pages.password')
      .controller('confirmCtrl', confirmCtrl);
  
    /** @ngInject */
    function confirmCtrl($scope, $location, ForgotpasswordService, $translate, SweetAlert, $state, $stateParams) {
          
          var vm = this;
          vm.resetPassword = resetPassword; // Renamed function to avoid naming conflict
         // Properly assign email and pin from $stateParams
       vm.email = $stateParams.user;
       vm.pin = $stateParams.pin;
    
    console.log('Email:', vm.email, 'PIN:', vm.pin);
         

        
  
          // Renamed function to resetPassword to differentiate from vm.password property
          function resetPassword() {
              vm.dataLoading = true;
              
              var password = { password: vm.confirm_password, email:  vm.email, pin: vm.pin };
              console.log(password);
              ForgotpasswordService.Password(password)
                  .then(function(response) {
                      console.log(response.data.status);
                      if (response.data.status == 1) {
                          SweetAlert.swal({
                              title: 'Success! Your Pin details were correct!',
                              text: '<span style="text-align:left; padding-bottom:15px; font-size:10px;">Please enter a new<span style="color:#08c"> password</span> for your account.</span>',
                              html: true
                          });
                          $state.go('success');      
                      } else {
                          vm.pindiv = true;
                          vm.emaildiv = true;
                          SweetAlert.swal({
                              title: 'Your Email details were incorrect!',
                              text: '<span style="text-align:left; padding-bottom:15px; font-size:10px;">Please try again, <span style="color:#08c"> with the correct </span> email address and password.</span>',
                              html: true
                          });
                          vm.dataLoading = false;
                      }
                  });
          }
      }
  })();
  
(function() {
    'use strict';
      angular.module('Monitour.pages.password')
          .factory('ForgotpasswordService', ForgotpasswordService);

    function ForgotpasswordService($http, $localStorage) {
        var service = {};        
        service.Forgot = Forgot;
        service.Pin = Pin;
		service.Password  = Password;
		
       
        var domain = 'https://api.callio.com.au/public/';
        return service;

      
        
		
        function Forgot(forgotpassword) {
            return $http.post(domain + 'forgotpassword', forgotpassword);
        }
		
		 function Pin(pin) {
            return $http.post(domain + 'pin', pin);
        }
		
		
		 function Password(password) {
            return $http.patch(domain + 'changepassword', password);
        }


            // private functions
    }
})();
(function() {
  'use strict';

  angular.module('Monitour.pages.password')
    .controller('passwordCtrl', passwordCtrl);

  /** @ngInject */
  function passwordCtrl($scope, ForgotpasswordService, $translate, $state, SweetAlert) {
        
		var vm = this;

        vm.forgot = forgot;

      
		
 
        function forgot() {
            vm.dataLoading = true;
			console.log(vm.email);
			var forgotpassword =  { user: vm.email};
            ForgotpasswordService.Forgot(forgotpassword)
                .then(function (response) {
					console.log(response.data.status);
                    if (response.data.status == 1) {
						  SweetAlert.swal({
            title: 'Success your Email details were correct!',
            text: '<span style="text-align:left; padding-bottom:15px; font-size:10px;">Please check your email<span style="color:#08c"> for the pin </span> to reset your password.</span>',
            html: true
        });
		
		
                $state.go('pin', { 'user':  vm.email });        
            
				 
                    } else {
						 vm.pindiv  = false;
                        SweetAlert.swal({
            title: 'Your Email details were incorrect!',
            text: '<span style="text-align:left; padding-bottom:15px; font-size:10px;">Please try again,<span style="color:#08c">with the correct </span> email address and password.</span>',
            html: true
        });
                        vm.dataLoading = 2;
                    }
                });
        }
		
		
		
    }

})();
(function() {
  'use strict';

  angular.module('Monitour.pages.password')
    .controller('pinCtrl', pinCtrl);

  /** @ngInject */
  function pinCtrl($scope, ForgotpasswordService, $translate, SweetAlert, $state, $stateParams) {
 
		var vm = this; 
   
	
		vm.pinnumber = pinnumber;
	
	   var user = $stateParams.user;
		
       console.log(user);		
		  function pinnumber() {
            vm.dataLoading = true;
			
			var pin =  { pin: vm.pin};
            ForgotpasswordService.Pin(pin)
                .then(function (response) {
					console.log(response.data.status);
                    if (response.data.status == 1) {
						  SweetAlert.swal({
            title: 'Success your Pin  details were correct!',
            text: '<span style="text-align:left; padding-bottom:15px; font-size:10px;">Please enter a new<span style="color:#08c"> password</span> for your account.</span>',
            html: true
        });
                      
        $state.go('confirm', { 'user':  user, 'pin': vm.pin });      
					   
                  	  
					  
                    } else {
						
						
						
                        SweetAlert.swal({
            title: 'Your Email details were incorrect!',
            text: '<span style="text-align:left; padding-bottom:15px; font-size:10px;">Please try again,<span style="color:#08c">with the correct </span> email address and password.</span>',
            html: true
        });
                        vm.dataLoading = 2;
                    }
                });
        }
		
		
	
    }

})();
(function() {
  'use strict';

  angular.module('Monitour.pages.register')
    .controller('registerCtrl', registerCtrl);

  /** @ngInject */
  function registerCtrl($scope,$state, $timeout,  $translate, RegisterService, $filter, $window, stripeService ) {

    var vm = this;
  if ($window.googleMapsApiLoaded) {
    // Initialize Google Maps dependent code here
  } else {
    $window.initMap = function() {
      // Now that Google Maps API is loaded, initialize the map
    };

  }

  var stripe = stripeService.getStripe();

        // Initialize the card element
   vm.cardElement = null;


  vm.handleCardReady = function(card) {
    vm.cardElement = card;
  };
 
  vm.sentence = {static: 'Your total platrom needs for'};

      // should be resolved by the router, and injected in this controller
      // that way, words are ready when the controller is instantiated
      // and when the link function of the directive is triggered
      vm.sentence.options = ['Calls', 'Programable Voice', 'Call Flows'];

      vm.languages = [
          {name:'English', id:'1'}
      ];
	  console.log( vm.languages.id );
    
      $scope.$watch(function() {
          $('#languages').selectpicker('refresh');
      });
  vm.formParams = {};
  
  $scope.options = {
    componentRestrictions: { country: 'AU' }
  }

  $scope.stage = "";
  $scope.formValidation = false;
 


  vm.standardSelectItems = [
    { label: 'Option 1', value: 1 },
    { label: 'Option 2', value: 2 },
    { label: 'Option 3', value: 3 },
    { label: 'Option 4', value: 4 },
  ];
	  vm.standardItem = {};
	  vm.states = [  
         {  
            "Id":'02',
            "Description":"NSW",
            "City": "Sydney"
         },
         {  
            "Id":'03',
            "Description":"VIC",
            "City": "Melbourne"
         },
         {  
            "Id":'07',
            "Description":"QLD",
            "City": "Brisbane"
         },
		   {  
            "Id":'08',
            "Description":"WA",
            "City": "Perth"
         },
		   {  
            "Id":'08',
            "Description":"NT",
            "City": "Darwin"
         },
		   {  
            "Id":'02',
            "Description":"ACT",
            "City": "Canberra"
         },
         {  
          "Id":'03',
          "Description":"TAS",
          "City": "Hobart"
       }
		  
      ];
		  
 console.log($scope.selectedCity);
 $scope.selectedCity = null; // This will hold the selected cit

	  $scope.checkselection = function () {

if ($scope.userSelect != "" && $scope.userSelect != undefined)

$scope.msg = 'Selected Value: '+$scope.userSelect;

else

$scope.msg = 'Please Select Dropdown Value';

}

  // Navigation functions
  $scope.next = function (stage) {
    //$scope.direction = 1;
    //$scope.stage = stage;
    
    $scope.formValidation = true;
    
    if ($scope.multiStepForm.$valid) {
      $scope.direction = 1;
      $scope.stage = stage;
      $scope.formValidation = false;
    }
  };

  $scope.back = function (stage) {
    $scope.direction = 0;
    $scope.stage = stage;
  };
  vm.heading = 'callio calling solution';

	  



    $scope.today = new Date();

		$scope.addMonths = function(months) {
			var result = new Date($scope.today);
			var day = result.getDate(); // Store the current day
		
			result.setMonth(result.getMonth() + months); // Add months
		
			// If the day has changed (we've rolled over to the next month), set it to the last day of the previous month
			if (result.getDate() != day) {
				result.setDate(0); // Setting the date to 0 goes to the last day of the previous month
			}
		
			return result;
		};

// Assuming vm is part of the controller and $filter and $scope are injected properly

vm.selectPlan = function(planId) {
    switch (planId) {
        case 1:
            vm.selectedPlan = {
                id: 1,
                heading: $filter('translate')('purchase.titlebronze'),
                monthlyCost: '19.99',
                price: '19.99',
                plan: 'Per Month',
                month: $scope.addMonths(1)
            };
            break;
        
        default:
            console.error("Invalid planId:", planId);
            return null; // Or handle the error as needed
    }

    console.log("Selected plan:", vm.selectedPlan.id);
    $scope.stage = "stage2";
    console.log(vm.selectedPlan.month);
    return vm.selectedPlan; // Optionally return the selected plan
};

  
  $scope.goBack = function() {
    if ($scope.stage === 'stage3') {
        $scope.stage = 'stage2';
    } else if ($scope.stage === 'stage2') {
        $scope.stage = 'stage1';
    } else if ($scope.stage === 'stage1') {
        $scope.stage = ''; // Assuming '' is your initial stage
    }
};

vm.radioValue = 'recurring'; 
$scope.items = [1, 2, 3, 4, 5, 6, 7, 8];

    $scope.properties = {
      items: 1,
      loop:true,
      margin:5,
      nav:true,
      responsiveClass: true,
      responsive:{
        0:{
            items:1
        },
        600:{
            items:2
        },
        1000:{
            items:2
        }
      },
        onChange: function () {
            console.dir(arguments);
        }
    };

  

    vm.register = register;

    function register() {
  
      if (vm.cardElement) {
        stripe.createToken(vm.cardElement).then(function(result) {
          if (result.error) {
            // Handle error here
            console.error(result.error.message);
          } else {
            console.log('Token received:', result.token.id);
            
            var registerData = {
              plan: vm.selectedPlan.price,
              amount: vm.selectedPlan.price,
              contactfirstname: vm.formParams.firstName,
              contactlastname: vm.formParams.lastname,
              language_id: '1',
              email: vm.formParams.email,
              password: vm.formParams.password,
              companyphone: vm.formParams.companyphone,
              address: vm.formParams.components.streetNumber + ' ' + vm.formParams.components.street,
              city: vm.formParams.components.city,
              state: vm.formParams.components.state,
              country: vm.formParams.components.country,
              postcode: vm.formParams.components.postCode,
              companystate: vm.formParams.components.state,
              areaCode: vm.formParams.City,
              token: result.token.id,  // Use the token ID instead of card details
              productid: vm.selectedPlan.id,
              expiry: vm.selectedPlan.month,
              recurring: vm.radioValue,
              userlimit: '0'
            };
         
            console.log(registerData);
            vm.dataLoading = true;
  
     
            RegisterService.Create(registerData).then(function(response) {
              vm.dataLoading = false; // Always hide the loading screen regardless of success/failure
          
              // Added console.log to inspect the exact structure of the response object
              console.log("Response received:", response);
          
              // Ensure that we're checking the string "true" correctly
              if (response && (response.success === "true" || response.success === true)) {
                swal({
                  title: 'Registration Successful',
                  text: response.data
                  });
                  console.log("Navigating to login state");
                  $state.go('login', {}, {reload: true});
              } else {
                  console.log("Error with registration:", response.data); // More detailed logging on error
                  swal({
                      title: 'Registration was unsuccessful',
                      text: response.data
                  });
              }
          });

          }
        });
      }
    };

    }
  })();
(function () {
    'use strict';

    angular.module('Monitour.pages.register')
        .factory('RegisterService', RegisterService);

    function RegisterService($http, $localStorage) {
        var service = {};

        service.Create = Create;




        var domain  = 'https://api.callio.com.au/public/';
        return service;



        function Create(register) {
            return $http.post(domain + 'register', register).then(handleSuccess, handleError('Error registering '));
        }




        // private functions


        function handleSuccess(res) {
            return res.data;
        }

        function handleError(error) {
            return function () {
                return { success: false, message: error };
            };
        }



    }

})();
/**
 * @author monitour
 * created on 27.07.2017
 */
(function() {
	'use strict';
	angular.module('Monitour.pages.payment').controller('PaymentsCtrl', PaymentsCtrl);
	/** @ngInject */
	function PaymentsCtrl($scope, baConfig, $filter, colorHelper,  $http, $localStorage , $state,  SweetAlert,  $translate, $stateParams, PaymentService) {
		var vm = this;
        
        vm.currentPage = 1;
        vm.itemsPerPage = 10; // Set a default value for items per page
        vm.smartTablePageSize = 10;
       
        PaymentService.GetAll()
        .then(function (response) {
            vm.invoices = response.data[0].result;
            vm.totalinvoices = response.data[0].count;
    
            // Counting unpaid (false status) invoices
            vm.unpaidInvoicesCount = vm.invoices.filter(function(invoice) {
                return invoice.status === "false"; // or just `false` if it's a boolean
            }).length;
    
            console.log("Unpaid Invoices Count: ", vm.unpaidInvoicesCount);
            // Rest of your code...
        }, function (error) {
            vm.status = 'Unable to load customer data: ' + error.message;
        });
    
        vm.owner = $localStorage.currentUser;
     
       
      
         
          $scope.transparent = baConfig.theme.blur;
	}
})();

(function () {
    'use strict';
    angular.module('Monitour.pages.payment')
        .factory('PaymentService', PaymentService);


    function PaymentService($http, $localStorage) {
        var service = {};
        service.GetAll = GetAll;
        service.GetById = GetById;

        service.Count = Count;
        service.Delete = Delete;
        service.GetFilters = GetFilters;

        var domain = 'https://api.callio.com.au/public/';
        return service;

        function Count() {
            return $http.get(domain + 'payments/count');
        }
        function Me() {
			return $http.get(domain + '/users/me');
		}

        function GetAll(pagenumber, itemsPerPage) {
            return $http.get(domain + 'payments?page=' + pagenumber + '&limit=' + itemsPerPage);
        }

        function GetFilters(client, site, pagenumber, itemsPerPage) {
            return $http.get(domain + 'payments?client=' + client + '&site_id=' + site + '&page=' + pagenumber + '&limit=' + itemsPerPage);
        }

        function GetById(id) {
            return $http.get(domain + 'payments/' + id);
        }

  


        function Delete(id) {
            return $http.delete(domain + 'invoice/' + id);
        }
        // private functions
    }
})();
/**
 * @author monitour
 * created on 27.07.2017
 */
(function () {
    'use strict';

    angular.module('Monitour.pages.settings')
        .controller('settingsCtrl', settingsCtrl);

    /** @ngInject */
    function settingsCtrl($scope) {
        var vm = this;


    }

})();

/**
 * @author monitour
 * created on 27.07.2017
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.tables')
      .controller('TablesPageCtrl', TablesPageCtrl);

  /** @ngInject */
  function TablesPageCtrl($scope, $filter, editableOptions, editableThemes) {

    $scope.smartTablePageSize = 10;

    $scope.smartTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30'
      },
      {
        id: 6,
        firstName: 'Ann',
        lastName: 'Smith',
        username: '@ann',
        email: 'ann@gmail.com',
        age: '21'
      },
      {
        id: 7,
        firstName: 'Barbara',
        lastName: 'Black',
        username: '@barbara',
        email: 'barbara@yandex.ru',
        age: '43'
      },
      {
        id: 8,
        firstName: 'Sevan',
        lastName: 'Bagrat',
        username: '@sevan',
        email: 'sevan@outlook.com',
        age: '13'
      },
      {
        id: 9,
        firstName: 'Ruben',
        lastName: 'Vardan',
        username: '@ruben',
        email: 'ruben@gmail.com',
        age: '22'
      },
      {
        id: 10,
        firstName: 'Karen',
        lastName: 'Sevan',
        username: '@karen',
        email: 'karen@yandex.ru',
        age: '33'
      },
      {
        id: 11,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mark',
        email: 'mark@gmail.com',
        age: '38'
      },
      {
        id: 12,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@jacob',
        email: 'jacob@yandex.ru',
        age: '48'
      },
      {
        id: 13,
        firstName: 'Haik',
        lastName: 'Hakob',
        username: '@haik',
        email: 'haik@outlook.com',
        age: '48'
      },
      {
        id: 14,
        firstName: 'Garegin',
        lastName: 'Jirair',
        username: '@garegin',
        email: 'garegin@gmail.com',
        age: '40'
      },
      {
        id: 15,
        firstName: 'Krikor',
        lastName: 'Bedros',
        username: '@krikor',
        email: 'krikor@yandex.ru',
        age: '32'
      },
      {
        "id": 16,
        "firstName": "Francisca",
        "lastName": "Brady",
        "username": "@Gibson",
        "email": "franciscagibson@comtours.com",
        "age": 11
      },
      {
        "id": 17,
        "firstName": "Tillman",
        "lastName": "Figueroa",
        "username": "@Snow",
        "email": "tillmansnow@comtours.com",
        "age": 34
      },
      {
        "id": 18,
        "firstName": "Jimenez",
        "lastName": "Morris",
        "username": "@Bryant",
        "email": "jimenezbryant@comtours.com",
        "age": 45
      },
      {
        "id": 19,
        "firstName": "Sandoval",
        "lastName": "Jacobson",
        "username": "@Mcbride",
        "email": "sandovalmcbride@comtours.com",
        "age": 32
      },
      {
        "id": 20,
        "firstName": "Griffin",
        "lastName": "Torres",
        "username": "@Charles",
        "email": "griffincharles@comtours.com",
        "age": 19
      },
      {
        "id": 21,
        "firstName": "Cora",
        "lastName": "Parker",
        "username": "@Caldwell",
        "email": "coracaldwell@comtours.com",
        "age": 27
      },
      {
        "id": 22,
        "firstName": "Cindy",
        "lastName": "Bond",
        "username": "@Velez",
        "email": "cindyvelez@comtours.com",
        "age": 24
      },
      {
        "id": 23,
        "firstName": "Frieda",
        "lastName": "Tyson",
        "username": "@Craig",
        "email": "friedacraig@comtours.com",
        "age": 45
      },
      {
        "id": 24,
        "firstName": "Cote",
        "lastName": "Holcomb",
        "username": "@Rowe",
        "email": "coterowe@comtours.com",
        "age": 20
      },
      {
        "id": 25,
        "firstName": "Trujillo",
        "lastName": "Mejia",
        "username": "@Valenzuela",
        "email": "trujillovalenzuela@comtours.com",
        "age": 16
      },
      {
        "id": 26,
        "firstName": "Pruitt",
        "lastName": "Shepard",
        "username": "@Sloan",
        "email": "pruittsloan@comtours.com",
        "age": 44
      },
      {
        "id": 27,
        "firstName": "Sutton",
        "lastName": "Ortega",
        "username": "@Black",
        "email": "suttonblack@comtours.com",
        "age": 42
      },
      {
        "id": 28,
        "firstName": "Marion",
        "lastName": "Heath",
        "username": "@Espinoza",
        "email": "marionespinoza@comtours.com",
        "age": 47
      },
      {
        "id": 29,
        "firstName": "Newman",
        "lastName": "Hicks",
        "username": "@Keith",
        "email": "newmankeith@comtours.com",
        "age": 15
      },
      {
        "id": 30,
        "firstName": "Boyle",
        "lastName": "Larson",
        "username": "@Summers",
        "email": "boylesummers@comtours.com",
        "age": 32
      },
      {
        "id": 31,
        "firstName": "Haynes",
        "lastName": "Vinson",
        "username": "@Mckenzie",
        "email": "haynesmckenzie@comtours.com",
        "age": 15
      },
      {
        "id": 32,
        "firstName": "Miller",
        "lastName": "Acosta",
        "username": "@Young",
        "email": "milleryoung@comtours.com",
        "age": 55
      },
      {
        "id": 33,
        "firstName": "Johnston",
        "lastName": "Brown",
        "username": "@Knight",
        "email": "johnstonknight@comtours.com",
        "age": 29
      },
      {
        "id": 34,
        "firstName": "Lena",
        "lastName": "Pitts",
        "username": "@Forbes",
        "email": "lenaforbes@comtours.com",
        "age": 25
      },
      {
        "id": 35,
        "firstName": "Terrie",
        "lastName": "Kennedy",
        "username": "@Branch",
        "email": "terriebranch@comtours.com",
        "age": 37
      },
      {
        "id": 36,
        "firstName": "Louise",
        "lastName": "Aguirre",
        "username": "@Kirby",
        "email": "louisekirby@comtours.com",
        "age": 44
      },
      {
        "id": 37,
        "firstName": "David",
        "lastName": "Patton",
        "username": "@Sanders",
        "email": "davidsanders@comtours.com",
        "age": 26
      },
      {
        "id": 38,
        "firstName": "Holden",
        "lastName": "Barlow",
        "username": "@Mckinney",
        "email": "holdenmckinney@comtours.com",
        "age": 11
      },
      {
        "id": 39,
        "firstName": "Baker",
        "lastName": "Rivera",
        "username": "@Montoya",
        "email": "bakermontoya@comtours.com",
        "age": 47
      },
      {
        "id": 40,
        "firstName": "Belinda",
        "lastName": "Lloyd",
        "username": "@Calderon",
        "email": "belindacalderon@comtours.com",
        "age": 21
      },
      {
        "id": 41,
        "firstName": "Pearson",
        "lastName": "Patrick",
        "username": "@Clements",
        "email": "pearsonclements@comtours.com",
        "age": 42
      },
      {
        "id": 42,
        "firstName": "Alyce",
        "lastName": "Mckee",
        "username": "@Daugherty",
        "email": "alycedaugherty@comtours.com",
        "age": 55
      },
      {
        "id": 43,
        "firstName": "Valencia",
        "lastName": "Spence",
        "username": "@Olsen",
        "email": "valenciaolsen@comtours.com",
        "age": 20
      },
      {
        "id": 44,
        "firstName": "Leach",
        "lastName": "Holcomb",
        "username": "@Humphrey",
        "email": "leachhumphrey@comtours.com",
        "age": 28
      },
      {
        "id": 45,
        "firstName": "Moss",
        "lastName": "Baxter",
        "username": "@Fitzpatrick",
        "email": "mossfitzpatrick@comtours.com",
        "age": 51
      },
      {
        "id": 46,
        "firstName": "Jeanne",
        "lastName": "Cooke",
        "username": "@Ward",
        "email": "jeanneward@comtours.com",
        "age": 59
      },
      {
        "id": 47,
        "firstName": "Wilma",
        "lastName": "Briggs",
        "username": "@Kidd",
        "email": "wilmakidd@comtours.com",
        "age": 53
      },
      {
        "id": 48,
        "firstName": "Beatrice",
        "lastName": "Perry",
        "username": "@Gilbert",
        "email": "beatricegilbert@comtours.com",
        "age": 39
      },
      {
        "id": 49,
        "firstName": "Whitaker",
        "lastName": "Hyde",
        "username": "@Mcdonald",
        "email": "whitakermcdonald@comtours.com",
        "age": 35
      },
      {
        "id": 50,
        "firstName": "Rebekah",
        "lastName": "Duran",
        "username": "@Gross",
        "email": "rebekahgross@comtours.com",
        "age": 40
      },
      {
        "id": 51,
        "firstName": "Earline",
        "lastName": "Mayer",
        "username": "@Woodward",
        "email": "earlinewoodward@comtours.com",
        "age": 52
      },
      {
        "id": 52,
        "firstName": "Moran",
        "lastName": "Baxter",
        "username": "@Johns",
        "email": "moranjohns@comtours.com",
        "age": 20
      },
      {
        "id": 53,
        "firstName": "Nanette",
        "lastName": "Hubbard",
        "username": "@Cooke",
        "email": "nanettecooke@comtours.com",
        "age": 55
      },
      {
        "id": 54,
        "firstName": "Dalton",
        "lastName": "Walker",
        "username": "@Hendricks",
        "email": "daltonhendricks@comtours.com",
        "age": 25
      },
      {
        "id": 55,
        "firstName": "Bennett",
        "lastName": "Blake",
        "username": "@Pena",
        "email": "bennettpena@comtours.com",
        "age": 13
      },
      {
        "id": 56,
        "firstName": "Kellie",
        "lastName": "Horton",
        "username": "@Weiss",
        "email": "kellieweiss@comtours.com",
        "age": 48
      },
      {
        "id": 57,
        "firstName": "Hobbs",
        "lastName": "Talley",
        "username": "@Sanford",
        "email": "hobbssanford@comtours.com",
        "age": 28
      },
      {
        "id": 58,
        "firstName": "Mcguire",
        "lastName": "Donaldson",
        "username": "@Roman",
        "email": "mcguireroman@comtours.com",
        "age": 38
      },
      {
        "id": 59,
        "firstName": "Rodriquez",
        "lastName": "Saunders",
        "username": "@Harper",
        "email": "rodriquezharper@comtours.com",
        "age": 20
      },
      {
        "id": 60,
        "firstName": "Lou",
        "lastName": "Conner",
        "username": "@Sanchez",
        "email": "lousanchez@comtours.com",
        "age": 16
      }
    ];

    $scope.editableTableData = $scope.smartTableData.slice(0, 36);

    $scope.peopleTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28',
        status: 'info'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45',
        status: 'primary'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18',
        status: 'success'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20',
        status: 'danger'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30',
        status: 'warning'
      }
    ];

    $scope.metricsTableData = [
      {
        image: 'app/browsers/chrome.svg',
        browser: 'Google Chrome',
        visits: '10,392',
        isVisitsUp: true,
        purchases: '4,214',
        isPurchasesUp: true,
        percent: '45%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/firefox.svg',
        browser: 'Mozilla Firefox',
        visits: '7,873',
        isVisitsUp: true,
        purchases: '3,031',
        isPurchasesUp: false,
        percent: '28%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/ie.svg',
        browser: 'Internet Explorer',
        visits: '5,890',
        isVisitsUp: false,
        purchases: '2,102',
        isPurchasesUp: false,
        percent: '17%',
        isPercentUp: false
      },
      {
        image: 'app/browsers/safari.svg',
        browser: 'Safari',
        visits: '4,001',
        isVisitsUp: false,
        purchases: '1,001',
        isPurchasesUp: false,
        percent: '14%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/opera.svg',
        browser: 'Opera',
        visits: '1,833',
        isVisitsUp: true,
        purchases: '83',
        isPurchasesUp: true,
        percent: '5%',
        isPercentUp: false
      }
    ];

    $scope.users = [
      {
        "id": 1,
        "name": "Esther Vang",
        "status": 4,
        "group": 3
      },
      {
        "id": 2,
        "name": "Leah Freeman",
        "status": 3,
        "group": 1
      },
      {
        "id": 3,
        "name": "Mathews Simpson",
        "status": 3,
        "group": 2
      },
      {
        "id": 4,
        "name": "Buckley Hopkins",
        "group": 4
      },
      {
        "id": 5,
        "name": "Buckley Schwartz",
        "status": 1,
        "group": 1
      },
      {
        "id": 6,
        "name": "Mathews Hopkins",
        "status": 4,
        "group": 2
      },
      {
        "id": 7,
        "name": "Leah Vang",
        "status": 4,
        "group": 1
      },
      {
        "id": 8,
        "name": "Vang Schwartz",
        "status": 4,
        "group": 2
      },
      {
        "id": 9,
        "name": "Hopkin Esther",
        "status": 1,
        "group": 2
      },
      {
        "id": 10,
        "name": "Mathews Schwartz",
        "status": 1,
        "group": 3
      }
    ];

    $scope.statuses = [
      {value: 1, text: 'Good'},
      {value: 2, text: 'Awesome'},
      {value: 3, text: 'Excellent'},
    ];

    $scope.groups = [
      {id: 1, text: 'user'},
      {id: 2, text: 'customer'},
      {id: 3, text: 'vip'},
      {id: 4, text: 'admin'}
    ];

    $scope.showGroup = function(user) {
      if(user.group && $scope.groups.length) {
        var selected = $filter('filter')($scope.groups, {id: user.group});
        return selected.length ? selected[0].text : 'Not set';
      } else return 'Not set'
    };

    $scope.showStatus = function(user) {
      var selected = [];
      if(user.status) {
        selected = $filter('filter')($scope.statuses, {value: user.status});
      }
      return selected.length ? selected[0].text : 'Not set';
    };


    $scope.removeUser = function(index) {
      $scope.users.splice(index, 1);
    };

    $scope.addUser = function() {
      $scope.inserted = {
        id: $scope.users.length+1,
        name: '',
        status: null,
        group: null
      };
      $scope.users.push($scope.inserted);
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();


(function () {
    'use strict';
    angular.module('Monitour.pages.sites')
        .factory('SitesService', SitesService);


    function SitesService($http, $localStorage) {


        var service = {};

        service.GetClientsSites = GetClientsSites;
        service.GetCheckpointsSites = GetCheckpointsSites;
        service.GetAll = GetAll;
        service.GetById = GetById;
        service.Create = Create;
        service.Update = Update;
        service.Delete = Delete;


        var domain  = 'https://api.callio.com.au/public/';

        return service;


        function GetAll(pageNumber, itemsPerPage) {
            return $http.get(domain + 'sites?page=' + pageNumber + '&limit=' + itemsPerPage);
        }
        function GetById(id) {
            return $http.get(domain + 'sites/' + id);
        }

        function GetClientsSites(id) {
            return $http.get(domain + 'sites?client=' + id);
        }

        function GetCheckpointsSites(id) {
            return $http.get(domain + 'checkpoints?site_id=' + id);
        }


        function Create(site) {
            return $http.post(domain + 'sites', site);
        }

        function Update(site, id) {
            return $http.patch(domain + 'sites/' + id, site);
        }

        function Delete(id) {
            return $http.delete(domain + 'sites/' + id);
        }


    }

})();
(function () {
    'use strict';
 
    angular.module('Monitour.pages.user')
        .factory('UserService', UserService);
 
    function UserService($http, $localStorage) {
	    
		var service = {}; 
		
        service.GetAll = GetAll;
		 service.Me = Me;
		service.GetAllPage = GetAllPage;
        service.GetById = GetById;
		service.Count = Count;
        service.GetByUsername = GetByUsername;
        service.Create = Create;
        service.Update = Update;
        service.Delete = Delete;
		service.userlabels = userlabels;
        service.labels = labels;
 
 
        var domain  = 'https://api.callio.com.au/public/';
        return service;
   
		
        function GetAll() {
            return $http.get(domain + 'users');
        }
		function Me() {
			return $http.get(domain + '/users/me');
		}
				
        function Count() {
            return $http.get(domain + 'users/count');
        }
        	
        function GetAllPage(itemsper, pager) {
            return $http.get(domain + 'users?page=' + pager + '&limit=' + itemsper);
        }
		  		
        function GetById(id) {
            return $http.get(domain + 'users/' + id);
        }
 
        function GetByUsername(username) {
            return $http.get(domain + 'users' + username);
        }
 
        function Create(user) {
            return $http.post(domain + 'usernew', user);
        }
 
        function Update(user, id) {
            return $http.patch(domain + 'userupdate/' + id, user);
        }
		
		function userlabels(id) {
			 return $http.get(domain + 'userlabels');
		}
		
		function labels() {
			
			return $http.get(domain + 'labels');
		}
 
        function Delete(id) {
            return $http.delete(domain + 'users/' + id);
        }
		
    
 
        // private functions
 
 
      
    }
 
})();
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('Monitour.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('Monitour.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('Monitour.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('Monitour.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('Monitour.theme')
      .directive('bsActiveLink', bsActiveLink);

  /** @ngInject */
  function bsActiveLink($location) {
      return {
        restrict: 'A', //use as attribute 
        replace: false,
        link: function (scope, elem) {
            //after the route has changed
            scope.$on("$routeChangeSuccess", function () {
                var hrefs = ['/#' + $location.path(),
                             '#' + $location.path(), //html5: false
                             $location.path()]; //html5: true
                angular.forEach(elem.find('a'), function (a) {
                    a = angular.element(a);
                    if (-1 !== hrefs.indexOf(a.attr('href'))) {
                        a.parent().addClass('active');
                    } else {
                        a.parent().removeClass('active');   
                    };
                });     
            });
        }
    }
  }

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('Monitour.theme')
      .directive('cardCvv', cardCvv);

  /** @ngInject */
  function cardCvv($browser ) {
    return {
     require: 'ngModel',
    link: function($scope, $element, $attrs, ngModelCtrl) {

      var formatter = function() {
          $element.val($element.val().replace(/[^\d]+/g,'').slice(0,3));
      };

      ngModelCtrl.$parsers.push(function(viewValue) {
        viewValue = viewValue.replace(/[^\d]+/g,'');

        if(viewValue.length < 3){
          ngModelCtrl.$setValidity('cvv_length', false);
        }else{
          ngModelCtrl.$setValidity('cvv_length', true);
        }

        return viewValue.slice(0,3);
      });

      ngModelCtrl.$render = function() {
        formatter();
      };

      $element.bind('change', formatter);

      $element.bind('keydown', function(event) {
        var key = event.keyCode;
        if (key == 91 || (15 < key && key < 19) || (37 <= key && key <= 40)){
          return;
        }
        
        $browser.defer(formatter);
      });

      $element.bind('paste cut', function() {
        $browser.defer(formatter);
      });
    }
    };
  }

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('Monitour.theme')
      .directive('cardDate', cardDate);

  /** @ngInject */
  function cardDate($browser) {
    return {
    require: 'ngModel',
    link: function($scope, $element, $attrs, ngModelCtrl) {

      var formatter = function() {

        var chunks = $element.val().replace(/[^\d]+/g,'').match(/\d{1,2}/g);

        if(chunks){
          $element.val(chunks.join(' / ').slice(0,7));
        }else{
          $element.val('');
        }
      };

      ngModelCtrl.$parsers.push(function(viewValue) {

        viewValue = viewValue.replace(/[^\d]+/g,'');

        var chunks = viewValue.match(/\d{1,2}/g);

        if(chunks[0] > 12 || chunks[0] == '00'){
          ngModelCtrl.$setValidity('date', false);
        }else{
          ngModelCtrl.$setValidity('date', true);
        }

        if(viewValue.length < 4){
          ngModelCtrl.$setValidity('date_length', false);
        }else{
          ngModelCtrl.$setValidity('date_length', true);
        }

        return chunks.join(' / ').slice(0,7);
      });

      ngModelCtrl.$render = function() {
        formatter();
      };

      $element.bind('change', formatter);

      $element.bind('keydown', function(event) {

        var key = event.keyCode;
        if (key == 91 || (15 < key && key < 19) || (37 <= key && key <= 40)){
          return;
        }

        $browser.defer(formatter);
      });
      $element.bind('paste cut', function() {
        $browser.defer(formatter);
      });
    }
    };
  }

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('Monitour.theme')
      .directive('cardHolder', cardHolder);

  /** @ngInject */
  function cardHolder($browser) {
    return {
      require: 'ngModel',
    link: function($scope, $element, $attrs, ngModelCtrl) {

      var capitalize = function(inputValue) {

        if(inputValue == undefined) inputValue = '';

        if(inputValue.search(/[^a-zA-Z\s]+/) === -1){
          ngModelCtrl.$setValidity('only_latin', true);
        }else{
          ngModelCtrl.$setValidity('only_latin', false);
        }

        var capitalized = inputValue.toUpperCase();
        if(capitalized !== inputValue) {
          ngModelCtrl.$setViewValue(capitalized);
          ngModelCtrl.$render();
        }

        return capitalized;
      };

      ngModelCtrl.$parsers.push(capitalize);

      capitalize($scope[$attrs.ngModel]); 

    }
    };
  }

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('Monitour.theme')
      .directive('cardNumber', cardNumber);

  /** @ngInject */
  function cardNumber($browser) {
    return {
    require: 'ngModel',
    link: function($scope, $element, $attrs, ngModelCtrl) {

      var formatter = function() {
        var chunks = $element.val().replace(/[^\d]+/g,'').match(/\d{1,4}/g);
        if(chunks){
          $element.val(chunks.join(' ').slice(0,19));
        }else{
          $element.val('');
        }
      };

      ngModelCtrl.$parsers.push(function(viewValue) {

        viewValue = viewValue.replace(/[^\d]+/g,'').slice(0,16);

        if(viewValue.charAt(0) != 4 && viewValue.charAt(0) != 5 && viewValue){
          ngModelCtrl.$setValidity('first_char', false);
        }else{
          ngModelCtrl.$setValidity('first_char', true);
        }

        if(viewValue.length < 16){
          ngModelCtrl.$setValidity('card_length', false);
        }else{
          ngModelCtrl.$setValidity('card_length', true);
        }

        return viewValue;
      });

      ngModelCtrl.$render = function() {
        formatter();
      };

      $element.bind('change', formatter);

      $element.bind('keydown', function(event) {
        var key = event.keyCode;
        if (key == 91 || (15 < key && key < 19) || (37 <= key && key <= 40)){
          return;
        }
        $browser.defer(formatter);
      });

      $element.bind('paste cut', function() {
        $browser.defer(formatter);
      });

    }
    };
  }

})();
(function () {
  'use strict';

  angular.module('Monitour.theme')
      .directive('card', card);

  /** @ngInject */
  function card() {
    return {
      restrict: 'E',
      controller: 'registerCtrl',
      templateUrl: 'app/pages/register/card/card.html'
    };
  }
})();
(function () {
    'use strict';
  
    angular.module('Monitour.theme')
        .directive('cardsinv', cardsinv);
  
    /** @ngInject */
    function cardsinv() {
      return {
        restrict: 'E',
        controller: 'InvoiceCtrl',
        templateUrl: 'app/pages/invoices/view/card.html'
      };
    }
  })();
(function () {
    'use strict';
  
    angular.module('Monitour.theme')
        .directive('cardspur', cardspur);
  
     /** @ngInject */
    function cardspur () {
      return {
        restrict: 'E',
        controller: 'purchaseCtrl',
        templateUrl: 'app/pages/profile/purchase/card.html'
      };
    }
  })();
/**
 * @author monitour
 * created on 27.07.2017
 */
(function () {
  'use strict';

  angular.module('Monitour.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

(function () {
  'use strict';

  angular.module('Monitour.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '='
      },
      link: function ($scope, $element) {
        var sliderInstance = $element.ionRangeSlider({
          min: $scope.min,
          max: $scope.max,
          type: $scope.type,
          prefix: $scope.prefix,
          maxPostfix: $scope.maxPostfix,
          prettify_enabled: $scope.prettify,
          prettify_separator: $scope.prettifySeparator,
          grid: $scope.grid,
          gridMargin: $scope.gridMargin,
          postfix: $scope.postfix,
          step: $scope.step,
          hideMinMax: $scope.hideMinMax,
          hideFromTo: $scope.hideFromTo,
          from: $scope.from,
          to: $scope.to,
          disable: $scope.disable,
          onChange: $scope.onChange,
          onFinish: $scope.onFinish,
          values: $scope.values
        }).data("ionRangeSlider");

        if (!sliderInstance) {
          console.error("ionRangeSlider instance not found");
          return;
        }

        function updateSlider(option, value) {
          var updateObject = {};
          updateObject[option] = value;

          if (sliderInstance) {
            console.log("Updating slider:", option, value);
            sliderInstance.update(updateObject);
          } else {
            console.error("Slider instance is undefined");
          }
        }

        $scope.$watch('min', function (value) {
          $timeout(function () {
            updateSlider('min', value);
          });
        }, true);
        $scope.$watch('max', function (value) {
          $timeout(function () {
            updateSlider('max', value);
          });
        });
        $scope.$watch('from', function (value) {
          $timeout(function () {
            updateSlider('from', value);
          });
        });
        $scope.$watch('to', function (value) {
          $timeout(function () {
            updateSlider('to', value);
          });
        });
        $scope.$watch('disable', function (value) {
          $timeout(function () {
            updateSlider('disable', value);
          });
        });
      }
    };
  }

})();

/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
    'use strict';

    angular.module('Monitour.theme')
        .directive('matchPassword', matchPassword);

    /** @ngInject */
    function matchPassword() {
        return {
            require: "ngModel",
            scope: {
                otherModelValue: "=matchPassword"
            },
            link: function(scope, element, attributes, ngModel) {

                ngModel.$validators.matchPassword = function(modelValue) {
                    return modelValue == scope.otherModelValue;
                };

                scope.$watch("otherModelValue", function() {
                    ngModel.$validate();
                });
            }
        };

    }

})();

(function () {
  'use strict';

  angular.module('Monitour.theme')
      .directive('mmenu', mmenu);

  /** @ngInject */
  function mmenu() {
      return {
          restrict : 'A',
          link : function($scope, element, attrs) {
              $(element).mmenu({
                  offCanvas	: false,
                  extensions	: ["theme-white"],
                  navbar		: {
                      title	: "Filter search"
                  },
                  navbars		: true,
                  onClick		: {
                      setSelected	: true
                  }});





          }
      };
    }

})();
(function () {
  'use strict';

  angular.module('Monitour.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
    'use strict';

    angular.module('Monitour.theme')
        .directive('numeric', numeric);

    /** @ngInject */
    function numeric($timeout,$compile, $rootScope) {
        return {
            require: 'ngModel',
            restrict: 'AE',
            link: function (scope, element, attrs, ngModel) {
                var numericElement = "";
                var numericNgModelName="";

                if (element.is("input")) {
                    numericElement = element;

                } else {
                    numericElement = angular.element('<input class="form-control">');
                    element.append(numericElement);
                }
                var  numericNgModelName = attrs.ngModel || "numericModel";
                numericElement.attr("ng-model", numericNgModelName);
                $compile(numericElement)(scope);
                function parseNumber(n, decimals) {
                    return (decimals) ? parseFloat(n) : parseInt(n);
                };
                // convenience properties
                var properties = ['min', 'max', 'step'];
                var options = scope.$eval(attrs.numeric) || {};
                var numberFormat = (attrs.numberFormat || options.numberFormat);
                var useDecimals = numberFormat ? (numberFormat.toLowerCase() === "c" ? true : false) : false;

                var init = function () {
                    angular.forEach(properties, function (property) {
                        if (angular.isDefined(attrs[property])) {
                            options[property] = parseNumber(attrs[property], useDecimals);
                        }
                        else if (options.hasOwnProperty(property) && angular.isUndefined(options[property])) {
                            options[property] = 0;
                        }
                    });
                    numericElement.spinner(options);
                    init = angular.noop;
                }
                // Late-bind to prevent compiler clobbering
                scope.$evalAsync(init);

                // Update spinner from model value
                ngModel.$render = function () {
                    init();
                    if (isNaN(ngModel.$viewValue) && !(ngModel.$viewValue instanceof Array)) {
                        ngModel.$viewValue = 0;
                    }
                    scope.$evalAsync(function () {
                        numericElement.spinner("value", ngModel.$viewValue);
                    });
                }
                // Update model value from spinner
                numericElement.bind('spin', function (event, ui) {
                    $timeout(function () {
                        ngModel.$setViewValue(ui.value);
                    }, 0);
                });

                // Find out if decimals are to be used for spinner
                angular.forEach(properties, function (property) {
                    // watch for updates
                    attrs.$observe(property, function (newVal) {
                        if (!!newVal) {
                            init();
                            numericElement.spinner('option', property, parseNumber(newVal, useDecimals));
                        }
                    });
                });
                scope.$watch(attrs.ngModel, function () {
                    ngModel.$render();
                }, true);

                // Watch numeric (byVal) for changes and update
                scope.$watch(attrs.numeric, function (newVal) {
                    init();
                    if (newVal != undefined) {
                        numericElement.spinner('option', newVal);
                    }
                    ngModel.$render();
                }, true);

                attrs.$observe('disabled', function (newVal) {
                    if (angular.isUndefined(newVal)) {
                        return;
                    }
                    init();
                    var newValState = angular.element.type(newVal) === "boolean" ? newVal : newVal.toLowerCase() == 'true';
                    numericElement.spinner('option', 'disabled', newValState);
                });
                //destroy jquery spinner object when directive object is destroyed
                $rootScope.$on(
                    "$destroy",
                    function( event ) {

                        numericElement.spinner('destroy');
                    })
                numericElement.bind('$destroy');
            }
        };
    }

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
    'use strict';
  
    angular.module('Monitour.theme')
        .directive('printBtn', printBtn);
  
    /** @ngInject */
    function printBtn($window,$timeout) {
      return {
        restrict: 'A',
        link: function(scope, element){
            element.on('click', function(event){
              
                $timeout(function () {
                      $window.print();
}, 0); 
            });
        }
    };
    }
  
  })();
(function () {
  'use strict';

  angular.module('Monitour.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();

(function () {
    'use strict';
  
    angular.module('Monitour.theme')
        .directive('selectpicker', selectpicker);
  
    /** @ngInject */
    function selectpicker() {
        return {
            restrict: 'A',
            require: '?ngOptions',
            priority: 1500, // make priority bigger than ngOptions and ngRepeat
            link: {
              pre: function(scope, elem, attrs) {
                elem.append('<option data-hidden="true" disabled value="">' + (attrs.title || 'Select something') + '</option>')
              },
              post: function(scope, elem, attrs) {
                function refresh() {
                  elem.selectpicker('refresh');
                }
      
                if (attrs.ngModel) {
                  scope.$watch(attrs.ngModel, refresh);
                }
      
                if (attrs.ngDisabled) {
                  scope.$watch(attrs.ngDisabled, refresh);
                }
      
                elem.selectpicker({ dropupAuto: false, hideDisabled: true });
              }
            }
          };
      }
  
  })();
// stripeCardElement.js

(function () {
    'use strict';

    angular.module('Monitour.theme')
        .directive('stripeCardElement', stripeCardElement);

    /** @ngInject */
    function stripeCardElement(stripeService) {
        return {
            restrict: 'E',
            template: '<div><div id="card-element"></div><div id="card-errors" role="alert"></div></div>',
            replace: true,
            scope: {
                onReady: '&'
            },
            link: function(scope, element, attrs) {
                var stripe = stripeService.getStripe();
                var elements = stripeService.getElements();

                // Create an instance of the card Element with postal code support.
                var card = elements.create('card', {hidePostalCode: true});

                // Mount the card Element into the `card-element` <div>.
                card.mount('#card-element');

                // Call the onReady callback when the card element is ready.
                scope.onReady({ card: card });

                // Handle real-time validation errors from the card Element.
                card.on('change', function(event) {
                    var displayError = document.getElementById('card-errors');
                    if (event.error) {
                        displayError.textContent = event.error.message;
                    } else {
                        displayError.textContent = '';
                    }
                });

                // Expose the card instance for further use
                scope.$parent.card = card;
            }
        };
    }
})();

/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('Monitour.theme')
      .directive('textRotator', textRotator);

  /** @ngInject */
  function textRotator($interval) {
        return {
        restrict: 'E',
        scope: {
        	options: '='   
        },
        template: '<span class="word" ng-repeat="item in options">{{item}}</span>',
        link: function (scope, element, attrs) {
            var i = 0;
            // TODO: animate
            stop = $interval(function () {
            	element.children().css('opacity', 0);
                element.children().eq(i++ % 5).css('opacity', 0.8);
            }, 1000)
            
            scope.$on('$destroy', function() {
          		// Make sure that the interval is destroyed too
          		$interval.cancel(stop);
        	});
        }
  }
     }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('Monitour.theme')
      .directive('toggle', toggle);

  /** @ngInject */
  function toggle() {
    return {
    restrict: 'A',
    link: function(scope, element, attrs){
      if (attrs.toggle=="tooltip"){
        $(element).tooltip();
      }
      if (attrs.toggle=="popover"){
        $(element).popover();
      }
    }
  };
  }

})();

(function () {
  'use strict';

  angular.module('Monitour.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('Monitour.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 500;

        if ($rootScope.$pageFinishedLoading) {
          delay = 10;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated fadeIn');
        }, delay);
      }
    };
  }

})();

(function () {
  'use strict';

  angular.module('Monitour.theme')
      .service('authInterceptor', authInterceptor);

  /** @ngInject */
  function authInterceptor($rootScope, $q, $localStorage) {
return {
    request: function (config) {
      config.headers = config.headers || {};
         if ($localStorage.currentUser) {
			console.log($localStorage.currentUser);
        config.headers.Authorization = 'Authorization ' + $localStorage.currentUser;
      }
      return config;
    },
    responseError: function (rejection) {
      if (rejection.status === 401) {
        // handle the case where the user is not authenticated
      }
      return $q.reject(rejection);
    }
  };
   
  }
})();

/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('Monitour.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author monitour
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('Monitour.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 27.07.2017
 */
(function () {
  'use strict';

  angular.module('Monitour.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
(function () {
  'use strict';

   angular.module('Monitour.theme')
        .factory('FlashService', FlashService);

    FlashService.$inject = ['$rootScope'];
    function FlashService($rootScope) {
        var service = {};

        service.Success = Success;
        service.Error = Error;

        initService();

        return service;

        function initService() {
            $rootScope.$on('$locationChangeStart', function () {
                clearFlashMessage();
            });

            function clearFlashMessage() {
                var flash = $rootScope.flash;
                if (flash) {
                    if (!flash.keepAfterLocationChange) {
                        delete $rootScope.flash;
                    } else {
                        // only keep for a single location change
                        flash.keepAfterLocationChange = false;
                    }
                }
            }
        }

        function Success(message, keepAfterLocationChange) {
            $rootScope.flash = {
                message: message,
                type: 'success', 
                keepAfterLocationChange: keepAfterLocationChange
            };
        }

        function Error(message, keepAfterLocationChange) {
            $rootScope.flash = {
                message: message,
                type: 'error',
                keepAfterLocationChange: keepAfterLocationChange
            };
        }
    }

})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('Monitour.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('Monitour.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
(function () {
    'use strict';

    angular.module('Monitour')
        .factory('stripeService', stripeService);

    /** @ngInject */
    function stripeService() {
       // var stripe = Stripe('pk_test_51PJOAyRq10zsYx8Wk5n9o79OaU677sZ8669ZvzSD2lTPByO1A2xQ2iRhhl02Z12A62aV0q22Mjwwti2GrK4pw96N00U7KxGSoZ');
        var stripe = Stripe('pk_live_51PJOAyRq10zsYx8WWIzfYdrDU8kLRHHyjeoVhCQaTr10N0bHDVC7kczRsGEOSVHJFBNiDX9V7iuttDVtsNCF96Bi00wnX4leFy');
        var elements = stripe.elements();

        return {
            getStripe: function() {
                return stripe;
            },
            getElements: function() {
                return elements;
            }
        };
    }
})();

/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.charts.chartist')
    .controller('chartistCtrl', chartistCtrl);

  /** @ngInject */
  function chartistCtrl($scope, $timeout, baConfig) {

    $scope.simpleLineOptions = {
      color: baConfig.colors.defaultText,
      fullWidth: true,
      height: "300px",
      chartPadding: {
        right: 40
      }
    };

    $scope.simpleLineData = {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
      series: [
        [20, 20, 12, 45, 50],
        [10, 45, 30, 14, 12],
        [34, 12, 12, 40, 50],
        [10, 43, 25, 22, 16],
        [3, 6, 30, 33, 43]
      ]
    };

    $scope.areaLineData = {
      labels: [1, 2, 3, 4, 5, 6, 7, 8],
      series: [
        [5, 9, 7, 8, 5, 3, 5, 4]
      ]
    };

    $scope.areaLineOptions = {
      fullWidth: true,
      height: "300px",
      low: 0,
      showArea: true
    };

    $scope.biLineData = {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      series: [
        [1, 2, 3, 1, -2, 0, 1],
        [-2, -1, -2, -1, -2.5, -1, -2],
        [0, 0, 0, 1, 2, 2.5, 2],
        [2.5, 2, 1, 0.5, 1, 0.5, -1]
      ]
    };

    $scope.biLineOptions = {
      height: "300px",
      high: 3,
      low: -3,
      showArea: true,
      showLine: false,
      showPoint: false,
      fullWidth: true,
      axisX: {
        showGrid: false
      }
    };

    $scope.simpleBarData = {
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      series: [
        [15, 24, 43, 27, 5, 10, 23, 44, 68, 50, 26, 8],
        [13, 22, 49, 22, 4, 6, 24, 46, 57, 48, 22, 4]
      ]
    };

    $scope.simpleBarOptions = {
      fullWidth: true,
      height: "300px"
    };

    $scope.multiBarData = {
      labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
      series: [
        [5, 4, 3, 7],
        [3, 2, 9, 5],
        [1, 5, 8, 4],
        [2, 3, 4, 6],
        [4, 1, 2, 1]
      ]
    };

    $scope.multiBarOptions = {
      fullWidth: true,
      height: "300px",
      stackBars: true,
      axisX: {
        labelInterpolationFnc: function (value) {
          return value.split(/\s+/).map(function (word) {
            return word[0];
          }).join('');
        }
      },
      axisY: {
        offset: 20
      }
    };

    $scope.multiBarResponsive = [
      ['screen and (min-width: 400px)', {
        reverseData: true,
        horizontalBars: true,
        axisX: {
          labelInterpolationFnc: Chartist.noop
        },
        axisY: {
          offset: 60
        }
      }],
      ['screen and (min-width: 700px)', {
        stackBars: false,
        reverseData: false,
        horizontalBars: false,
        seriesBarDistance: 15
      }]
    ];

    $scope.stackedBarData = {
      labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
      series: [
        [800000, 1200000, 1400000, 1300000],
        [200000, 400000, 500000, 300000],
        [100000, 200000, 400000, 600000]
      ]
    };

    $scope.stackedBarOptions = {
      fullWidth: true,
      height: "300px",
      stackBars: true,
      axisY: {
        labelInterpolationFnc: function (value) {
          return (value / 1000) + 'k';
        }
      }
    };

    $scope.simplePieData = {
      series: [5, 3, 4]
    };

    $scope.simplePieOptions = {
      fullWidth: true,
      height: "300px",
      weight: "300px",
      labelInterpolationFnc: function (value) {
        return Math.round(value / 12 * 100) + '%';
      }
    };

    $scope.labelsPieData = {
      labels: ['Bananas', 'Apples', 'Grapes'],
      series: [20, 15, 40]
    };

    $scope.labelsPieOptions = {
      fullWidth: true,
      height: "300px",
      weight: "300px",
      labelDirection: 'explode',
      labelInterpolationFnc: function (value) {
        return value[0];
      }
    };

    $scope.simpleDonutData = {
      labels: ['Bananas', 'Apples', 'Grapes'],
      series: [20, 15, 40]
    };

    $scope.simpleDonutOptions = {
      fullWidth: true,
      donut: true,
      height: "300px",
      weight: "300px",
      labelDirection: 'explode',
      labelInterpolationFnc: function (value) {
        return value[0];
      }
    };

    $scope.donutResponsive = getResponsive(5, 40);

    $scope.pieResponsive = getResponsive(20, 80);

    function getResponsive(padding, offset){
      return [
        ['screen and (min-width: 1550px)', {
          chartPadding: padding,
          labelOffset: offset,
          labelDirection: 'explode',
          labelInterpolationFnc: function (value) {
            return value;
          }
        }],
        ['screen and (max-width: 1200px)', {
          chartPadding: padding,
          labelOffset: offset,
          labelDirection: 'explode',
          labelInterpolationFnc: function (value) {
            return value;
          }
        }],
        ['screen and (max-width: 600px)', {
          chartPadding: 0,
          labelOffset: 0,
          labelInterpolationFnc: function (value) {
            return value[0];
          }
        }]
      ];
    }

    $timeout(function(){
      new Chartist.Line('#line-chart', $scope.simpleLineData, $scope.simpleLineOptions);
      new Chartist.Line('#area-chart', $scope.areaLineData, $scope.areaLineOptions);
      new Chartist.Line('#bi-chart', $scope.biLineData, $scope.biLineOptions);

      new Chartist.Bar('#simple-bar', $scope.simpleBarData, $scope.simpleBarOptions);
      new Chartist.Bar('#multi-bar', $scope.multiBarData, $scope.multiBarOptions, $scope.multiBarResponsive);
      new Chartist.Bar('#stacked-bar', $scope.stackedBarData, $scope.stackedBarOptions);

      new Chartist.Pie('#simple-pie', $scope.simplePieData, $scope.simplePieOptions, $scope.pieResponsive);
      new Chartist.Pie('#label-pie', $scope.labelsPieData, $scope.labelsPieOptions);
      new Chartist.Pie('#donut', $scope.simpleDonutData, $scope.simpleDonutOptions, $scope.donutResponsive);
    });
  }
})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.charts.chartJs')
    .controller('chartJs1DCtrl', chartJs1DCtrl);

  /** @ngInject */
  function chartJs1DCtrl($scope, baConfig) {
    var layoutColors = baConfig.colors;

    $scope.labels =["Sleeping", "Designing", "Coding", "Cycling"];
    $scope.data = [20, 40, 5, 35];
    $scope.options = {
      elements: {
        arc: {
          borderWidth: 0
        }
      },
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          fontColor: layoutColors.defaultText
        }
      }
    };

    $scope.changeData = function () {
      $scope.data = shuffle($scope.data);
    };

    function shuffle(o){
      for(var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x){}
      return o;
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.charts.chartJs')
    .controller('chartJs2DCtrl', chartJs2DCtrl);

  /** @ngInject */
  function chartJs2DCtrl($scope) {
    $scope.labels =["May", "Jun", "Jul", "Aug", "Sep"];
    $scope.data = [
      [65, 59, 90, 81, 56],
      [28, 48, 40, 19, 88]
    ];
    $scope.series = ['Product A', 'Product B'];


    $scope.changeData = function () {
      $scope.data[0] = shuffle($scope.data[0]);
      $scope.data[1] = shuffle($scope.data[1]);
    };

    function shuffle(o){
      for(var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x){}
      return o;
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.charts.chartJs')
    .controller('chartJsWaveCtrl', chartJsWaveCtrl);

  /** @ngInject */
  function chartJsWaveCtrl($scope, $interval, stopableInterval) {
    $scope.labels =["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    $scope.data = [1, 9, 3, 4, 5, 6, 7, 8, 2].map(function(e){
      return Math.sin(e) * 25 +25;
    });

    stopableInterval.start($interval, function(){
      var tempArray = [];
      var lastElement = $scope.data[$scope.data.length-1];
      for(var i = $scope.data.length-1; i > 0; i--){
       tempArray[i] = $scope.data[i-1];
      }
      tempArray[0] = lastElement;
      $scope.data = tempArray;
    }, 400)
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.charts.morris')
    .controller('morrisCtrl', morrisCtrl);

  /** @ngInject */
  function morrisCtrl($scope, $window, baConfig) {
    var layoutColors = baConfig.colors;
    $scope.colors = [layoutColors.primary, layoutColors.warning, layoutColors.danger, layoutColors.info, layoutColors.success, layoutColors.primaryDark];
    $scope.lineData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.areaData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.barData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.donutData = [
      {label: "Download Sales", value: 12},
      {label: "In-Store Sales", value: 30},
      {label: "Mail-Order Sales", value: 20}
    ];

    angular.element($window).bind('resize', function () {
      //$window.Morris.Grid.prototype.redraw();
    });
  }

})();
/**
 * @author monitour
 * created on 27.07.2017
 */
(function() {
	'use strict';
	angular.module('Monitour.pages.invoice').controller('InvoiceCtrl', InvoiceCtrl);
	/** @ngInject */
	function InvoiceCtrl($scope, baConfig, $filter, colorHelper,  $http, $localStorage ,$state, $timeout,  SweetAlert,  $translate, $stateParams, InvoiceService, ProfileService ) {
		var vm = this;
        var id = $stateParams.id;
        vm.owner = $localStorage.currentUser;

        $scope.cardType = 'visa';
     $scope.card = {};
    console.log($scope.card);
      $scope.isVisa = function(){
        if($scope.card.number && $scope.card.number.charAt(0) == 4){
          return true;
        }else{
          return false;
        }
      };
    
      $scope.isMasterCard = function(){
        if($scope.card.number && $scope.card.number.charAt(0) == 5){
          return true;
        }else{
          return false;
        }
      };
      $scope.isSectionVisible = false;

      $scope.toggleSection = function() {
        $scope.isSectionVisible = !$scope.isSectionVisible;
    };
    
    

      function getDifferenceInDays(date1, date2) {
        var diffInTime = date2.getTime() - date1.getTime();
        return Math.floor(diffInTime / (1000 * 3600 * 24));
      }
      
      $scope.$watch('vm.invoice.expires', function(newValue) {
        if (newValue) {
            var currentDate = new Date();
            var expiryDate = new Date(newValue);
    
            // Ensure the expiry date is set to the end of the day for accurate day counting
            expiryDate.setHours(23, 59, 59, 999);
    
            // Calculate the difference in days
            var daysRemaining = getDifferenceInDays(currentDate, expiryDate);

            vm.days =   daysRemaining;
    
        }
    });


// Function to patch the recurring value
vm.patchRecurringBool = function() {
  var renewal = { renewal: vm.invoice.recurring };
  InvoiceService.Renewal(renewal).then(function successCallback(response) {
    // Response handling
    var message = vm.invoice.recurring ? 
                  "Your account is on auto renewal." : 
                  "Your account is not on auto renewal.";

    if (response) {
      swal("Successfully Updated Your Account", "You have updated your account, " + message, "success");
      vm.initialRecurringValue = vm.invoice.recurring; // Update the initial value
    } else {
      swal("Update was Unsuccessful", "Please check the details you entered.", "error");
    }
  });
};

// Watch for changes in the recurring field
$scope.$watch('vm.invoice.recurring', function(newVal) {
  if (newVal !== vm.initialRecurringValue) {
    vm.patchRecurringBool();
  }
});

ProfileService.GetAll().then(function(response) {
  vm.detail = response;
console.log(vm.detail);

}, function(error) {
  $scope.status = 'Unable to load customer data: ' + error.message;
});



    

          InvoiceService.GetById(id).then(function(response) {
            vm.invoice = response.data[0];
            vm.today = new Date();   
             // Set up the watch with type coercion
             vm.initialRecurringValue = vm.invoice.recurring;

        

            function addMonthsToToday(monthsToAdd) {
                var today = new Date();
                today.setMonth(today.getMonth() + monthsToAdd);
                return today;
            }
        
            var period = parseInt(vm.invoice.period, 10); // Ensure period is an integer
            console.log("Period value: ", period); // Check the period value
        
            vm.dateInFuture = addMonthsToToday(period);
        
            console.log("Today's date: ", vm.today);
            console.log("Future date: ", vm.dateInFuture);
            console.log("Invoice data: ", vm.invoice);
             // Assuming vm.invoice.expires is a string in YYYY-MM-DD format
    var expiryDate = new Date(vm.invoice.expires);
    var tomorrow = new Date();
    tomorrow.setDate(vm.today.getDate() + 2);
    // Check if the expiry date is within one day
    //if (expiryDate.getTime() <= tomorrow.getTime()) {
      // Logic to show warning
    //  swal("Warning!", "You have an invoice that will expire in " + vm.days + " days", "warning");

 // }

        
        }, function() {
            $scope.error = 'unable to get the checkpoint details';
        });
      
        

        vm.submitForm = submitForm;

        function submitForm () {
         var date = $scope.card.date;
         var parts = date.split('/');
         vm.expiryMonth = parts[0];
         vm.year = parts[1];
        
          
          var payment  =  {
         expiryMonth: vm.expiryMonth,
         expiryYear: vm.year,
           cvv: $scope.card.cvv,
           amount: vm.invoice.amount,
          expiry:  vm.dateInFuture,
          cardholder:  $scope.card.holder,
          number: $scope.card.number,
          address: vm.invoice.address,
                 city: vm.invoice.city,
                 state: vm.invoice.state,
                 country: vm.invoice.country,
                 postcode: vm.invoice.postCode,
           phoneId: vm.detail.phoneId,
           productid: vm.invoice.productid,
   
          userlimit: '0'
        };
         console.log(payment);
       
         console.log(id);
      
         vm.loading = true;

         InvoiceService.Payinvoice(payment, id).then(function(response) {
          if (response.success) {
              swal("Successfully Payment ", "You have renewed your subscription", "success");
          } else {
              swal("Payment was Unsuccessful", "Please check the details you entered.", "error");
          }
      });
      
			

			   };
           
        
   
         
   
           
   
	}
})();
/**
 * @author v.lugovksy
 * created on 27.07.2017
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.dashboard')
      .directive('blurFeed', blurFeed);

  /** @ngInject */
  function blurFeed() {
    return {
      restrict: 'E',
      controller: 'BlurFeedCtrl',
      templateUrl: 'app/pages/dashboard/blurFeed/blurFeed.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 27.07.2017
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.dashboard')
      .controller('BlurFeedCtrl', BlurFeedCtrl);

  /** @ngInject */
  function BlurFeedCtrl($scope) {
    $scope.feed = [
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
        time: 'Today 11:55 pm',
        ago: '25 minutes ago',
        expanded: false,
      }, {
        type: 'video-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Added new video',
        text: '"Vader and Me"',
        preview: 'app/feed/vader-and-me-preview.png',
        link: 'https://www.youtube.com/watch?v=IfcpzBbbamk',
        time: 'Today 9:30 pm',
        ago: '3 hrs ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Added new image',
        text: '"My little kitten"',
        preview: 'app/feed/my-little-kitten.png',
        link: 'http://api.ning.com/files/DtcI2O2Ry7A7VhVxeiWfGU9WkHcMy4WSTWZ79oxJq*h0iXvVGndfD7CIYy-Ax-UAFCBCdqXI4GCBw3FOLKTTjQc*2cmpdOXJ/1082127884.jpeg',
        time: 'Today 2:20 pm',
        ago: '10 hrs ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'Haha lol',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'geo-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted location',
        text: '"New York, USA"',
        preview: 'app/feed/new-york-location.png',
        link: 'https://www.google.by/maps/place/New+York,+NY,+USA/@40.7201111,-73.9893872,14z',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Posted new message',
        text: "First snake: I hope I'm not poisonous. Second snake: Why? First snake: Because I bit my lip!",
        time: '12.11.2015',
        ago: '3 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Posted new message',
        text: 'How do you smuggle an elephant across the border? Put a slice of bread on each side, and call him "lunch".',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'When your hammer is C++, everything begins to look like a thumb.',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Alexander',
        surname: 'Demeshko',
        header: 'Posted new message',
        text: '“I mean, they say you die twice. One time when you stop breathing and a second time, a bit later on, when somebody says your name for the last time." ©',
        time: '15.11.2015',
        ago: '6 days ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted photo',
        text: '"Protein Heroes"',
        preview: 'app/feed/genom.png',
        link: 'https://dribbble.com/shots/2504810-Protein-Heroes',
        time: '16.11.2015',
        ago: '7 days ago',
        expanded: false,
      },
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Why did the CoffeeScript developer keep getting lost? Because he couldn\'t find his source without a map',
        time: '18.11.2015',
        ago: '9 days ago',
        expanded: false,
      }
    ];

    $scope.expandMessage = function(message){
      message.expanded = !message.expanded;
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

angular.module('Monitour.pages.dashboard')
      .directive('dashboardLineChart', dashboardLineChart);

  /** @ngInject */
  function dashboardLineChart() {
    return {
      restrict: 'E',
      controller: 'DashboardLineChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardLineChart/dashboardLineChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';
angular.module('Monitour.pages.dashboard')
      .controller('DashboardLineChartCtrl', DashboardLineChartCtrl);

  /** @ngInject */
  function DashboardLineChartCtrl(baConfig, layoutPaths, baUtil) {
    var layoutColors = baConfig.colors;
    var graphColor = baConfig.theme.blur ? '#000000' : layoutColors.primary;
    var chartData = [
      { date: new Date(2012, 11), value: 0, value0: 0 },
      { date: new Date(2013, 0), value: 15000, value0: 19000},
      { date: new Date(2013, 1), value: 30000, value0: 20000},

      { date: new Date(2013, 2), value: 25000, value0: 22000},
      { date: new Date(2013, 3), value: 21000, value0: 25000},
      { date: new Date(2013, 4), value: 24000, value0: 29000},
      { date: new Date(2013, 5), value: 31000, value0: 26000},
      { date: new Date(2013, 6), value: 40000, value0: 25000},
      { date: new Date(2013, 7), value: 37000, value0: 20000},
      { date: new Date(2013, 8), value: 18000, value0: 22000},
      { date: new Date(2013, 9), value: 5000, value0: 26000},
      { date: new Date(2013, 10), value: 40000, value0: 30000},
      { date: new Date(2013, 11), value: 20000, value0: 25000},
      { date: new Date(2014, 0), value: 5000, value0: 13000},

      { date: new Date(2014, 1), value: 3000, value0: 13000},
      { date: new Date(2014, 2), value: 1800, value0: 13000},
      { date: new Date(2014, 3), value: 10400, value0: 13000},
      { date: new Date(2014, 4), value: 25500, value0: 13000},
      { date: new Date(2014, 5), value: 2100, value0: 13000},
      { date: new Date(2014, 6), value: 6500, value0: 13000},
      { date: new Date(2014, 7), value: 1100, value0: 13000},
      { date: new Date(2014, 8), value: 17200, value0: 13000},
      { date: new Date(2014, 9), value: 26900, value0: 13000},
      { date: new Date(2014, 10), value: 14100, value0: 13000},
      { date: new Date(2014, 11), value: 35300, value0: 13000},
      { date: new Date(2015, 0), value: 54800, value0: 13000},
      { date: new Date(2015, 1), value: 49800, value0: 13000}
    ];

    var chart = AmCharts.makeChart('amchart', {
      type: 'serial',
      theme: 'blur',
      marginTop: 15,
      marginRight: 15,
      dataProvider: chartData,
      categoryField: 'date',
      categoryAxis: {
        parseDates: true,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText
      },
      valueAxes: [
        {
          minVerticalGap: 50,
          gridAlpha: 0,
          color: layoutColors.defaultText,
          axisColor: layoutColors.defaultText
        }
      ],
      graphs: [
        {
          id: 'g0',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.3),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value0',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        },
        {
          id: 'g1',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.5),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        }
      ],
      chartCursor: {
        categoryBalloonDateFormat: 'MM YYYY',
        categoryBalloonColor: '#4285F4',
        categoryBalloonAlpha: 0.7,
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5
      },
      dataDateFormat: 'MM YYYY',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      zoomOutButton: {
        backgroundColor: '#fff',
        backgroundAlpha: 0
      },
      zoomOutText: '',
      pathToImages: layoutPaths.images.amChart
    });

    function zoomChart() {
      chart.zoomToDates(new Date(2013, 3), new Date(2014, 0));
    }

    chart.addListener('rendered', zoomChart);
    zoomChart();
    if (chart.zoomChart) {
      chart.zoomChart();
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.dashboard')
      .directive('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {
    return {
      restrict: 'E',
      controller: 'DashboardPieChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardPieChart/dashboardPieChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.dashboard')
      .controller('DashboardPieChartCtrl', DashboardPieChartCtrl);

  /** @ngInject */
  function DashboardPieChartCtrl($scope, $timeout, baConfig, baUtil) {
    var pieColor = baUtil.hexToRGB(baConfig.colors.defaultText, 0.2);
    $scope.charts = [{
      color: pieColor,
      description: 'Calls',
      stats: '50',
      icon: 'person',
    }, {
      color: pieColor,
      description: 'Failed ',
      stats: '$ 89,745',
      icon: 'money',
    }, {
      color: pieColor,
      description: 'Completed',
      stats: '178,391',
      icon: 'face',
    }, {
      color: pieColor,
      description: 'Missed',
      stats: '32,592',
      icon: ' shopping-cart',
    }
    ];

    function getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    }

    function loadPieCharts() {
      $('.chart').each(function () {
        var chart = $(this);
        chart.easyPieChart({
          easing: 'easeOutBounce',
          onStep: function (from, to, percent) {
            $(this.el).find('.percent').text(Math.round(percent));
          },
          barColor: chart.attr('rel'),
          trackColor: 'rgba(0,0,0,0)',
          size: 84,
          scaleLength: 0,
          animation: 2000,
          lineWidth: 9,
          lineCap: 'round',
        });
      });

      $('.refresh-data').on('click', function () {
        updatePieCharts();
      });
    }

    function updatePieCharts() {
      $('.pie-charts .chart').each(function(index, chart) {
        $(chart).data('easyPieChart').update(getRandomArbitrary(55, 90));
      });
    }

    $timeout(function () {
      loadPieCharts();
      updatePieCharts();
    }, 1000);
  }
})();

(function () {
  'use strict';

  angular.module('Monitour.pages.dashboard')
      .directive('dashboardToolbar', dashboardToolbar);

  /** @ngInject */
  function dashboardToolbar() {
    return {
      restrict: 'EA',
      controller: 'DashboardToolbarCtrl',
      templateUrl: 'app/pages/dashboard/dashboardToolbar/dashboardToolbar.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 27.07.2017
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.dashboard')
      .controller('DashboardToolbarCtrl', DashboardToolbarCtrl);

  /** @ngInject */
  function DashboardToolbarCtrl($scope) {
$scope.ddSelectOptions = [
        {
            text: 'Option1',
            value: 'a value'
        },
        {
            text: 'Option2',
            value: 'another value',
            someprop: 'somevalue'
        },
        {
            // Any option with divider set to true will be a divider
            // in the menu and cannot be selected.
            divider: true
        },
        {
            // Any divider option with a 'text' property will
            // behave similarly to a divider and cannot be selected.
            divider: true,
            text: 'divider label'
        },
        {
            // Example of an option with the 'href' property
            text: 'Option4',
            href: '#option4'
        }
    ];

    $scope.ddSelectSelected = {}; // Must be an object
  
  
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.dashboard')
      .directive('trafficChart', trafficChart);

  /** @ngInject */
  function trafficChart() {
    return {
      restrict: 'E',
      controller: 'TrafficChartCtrl',
      templateUrl: 'app/pages/dashboard/trafficChart/trafficChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.dashboard')
      .controller('TrafficChartCtrl', TrafficChartCtrl);

  /** @ngInject */
  function TrafficChartCtrl($scope, baConfig, $filter, colorHelper) {
    $scope.smartTablePageSize = 10;
   
    $scope.smartTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28',
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45',
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18',
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20',
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30',
      },
      {
        id: 6,
        firstName: 'Ann',
        lastName: 'Smith',
        username: '@ann',
        email: 'ann@gmail.com',
        age: '21',
      },
      {
        id: 7,
        firstName: 'Barbara',
        lastName: 'Black',
        username: '@barbara',
        email: 'barbara@yandex.ru',
        age: '43',
      },
      {
        id: 8,
        firstName: 'Sevan',
        lastName: 'Bagrat',
        username: '@sevan',
        email: 'sevan@outlook.com',
        age: '13',
      },
      {
        id: 9,
        firstName: 'Ruben',
        lastName: 'Vardan',
        username: '@ruben',
        email: 'ruben@gmail.com',
        age: '22',
      },
      {
        id: 10,
        firstName: 'Karen',
        lastName: 'Sevan',
        username: '@karen',
        email: 'karen@yandex.ru',
        age: '33',
      },
      {
        id: 11,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mark',
        email: 'mark@gmail.com',
        age: '38',
      },
      {
        id: 12,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@jacob',
        email: 'jacob@yandex.ru',
        age: '48',
      },
      {
        id: 13,
        firstName: 'Haik',
        lastName: 'Hakob',
        username: '@haik',
        email: 'haik@outlook.com',
        age: '48',
      },
      {
        id: 14,
        firstName: 'Garegin',
        lastName: 'Jirair',
        username: '@garegin',
        email: 'garegin@gmail.com',
        age: '40',
      },
      {
        id: 15,
        firstName: 'Krikor',
        lastName: 'Bedros',
        username: '@krikor',
        email: 'krikor@yandex.ru',
        age: '32',
      }
    ];

   

  
  
     
      $scope.transparent = baConfig.theme.blur;
  
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.dashboard')
      .service('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {

  }
})();
(function () {
  'use strict';

  angular.module('Monitour.pages.dashboard')
      .directive('dashboardMap', dashboardMap);

  /** @ngInject */
  function dashboardMap() {
    return {
      restrict: 'E',
      controller: 'DashboardMapCtrl',
      templateUrl: 'app/pages/dashboard/dashboardMap/dashboardMap.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 27.07.2017
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.dashboard')
      .controller('DashboardMapCtrl', DashboardMapCtrl);

  /** @ngInject */
  function DashboardMapCtrl($scope, baConfig) {
    var layoutColors = baConfig.colors;
	  
    $scope.labels =["Location", "Moving", "Stoping", "Online", "Offline"];
    $scope.data = [120, 40, 15, 35];
    $scope.options = {
	  cutoutPercentage: 70,
      elements: {
		    
        arc: {
          borderWidth: 0
        }
      },
      legend: {
        display: true,
        position: 'right',
        labels: {
          fontColor: layoutColors.defaultText
        },
		   tooltipTemplate: "<%= value %>%",
    legendTemplate: "<ul><% for (var i=0; i<data.length; i++){%><li><span style=\"background-color:<%=data[i].color%>\"></span><%=data[i].label%> - <%=data[i].value%></li><%}%></ul>"
      }
    };

	  
	   $scope.date = {
        startDate: moment().subtract(1, "days"),
        endDate: moment()
    };
//Watch for date changes
    $scope.$watch('date', function(newDate) {
        console.log('New date set: ', newDate);
    }, false);
	
    $scope.checked = false;
                $scope.size = '100px';
                $scope.toggle = function() {
                    $scope.checked = !$scope.checked
                }
                $scope.mockRouteChange = function () {
                    $scope.$broadcast('$locationChangeStart');
                }
                $scope.onopen = function () {
                    alert('Open');
                    console.log(this, $scope);
                }
                $scope.onclose = function () {
                    alert('Close');
                    console.log($scope);
                }
	
	   $scope.feed = [
      {
        type: 'geo-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
        time: 'Today 11:55 pm',
        ago: '25 minutes ago',
        expanded: false,
      }, {
        type: 'video-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Added new video',
        text: '"Vader and Me"',
        preview: 'app/feed/vader-and-me-preview.png',
        link: 'https://www.youtube.com/watch?v=IfcpzBbbamk',
        time: 'Today 9:30 pm',
        ago: '3 hrs ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Added new image',
        text: '"My little kitten"',
        preview: 'app/feed/my-little-kitten.png',
        link: 'http://api.ning.com/files/DtcI2O2Ry7A7VhVxeiWfGU9WkHcMy4WSTWZ79oxJq*h0iXvVGndfD7CIYy-Ax-UAFCBCdqXI4GCBw3FOLKTTjQc*2cmpdOXJ/1082127884.jpeg',
        time: 'Today 2:20 pm',
        ago: '10 hrs ago',
        expanded: false,
      }, {
        type: 'geo-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'Haha lol',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'geo-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted location',
        text: '"New York, USA"',
        preview: 'app/feed/new-york-location.png',
        link: 'https://www.google.by/maps/place/New+York,+NY,+USA/@40.7201111,-73.9893872,14z',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
         type: 'geo-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Posted new message',
        text: "First snake: I hope I'm not poisonous. Second snake: Why? First snake: Because I bit my lip!",
        time: '12.11.2015',
        ago: '3 days ago',
        expanded: false,
      }, {
         type: 'geo-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Posted new message',
        text: 'How do you smuggle an elephant across the border? Put a slice of bread on each side, and call him "lunch".',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
       type: 'geo-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'When your hammer is C++, everything begins to look like a thumb.',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'geo-message',
        author: 'Alexander',
        surname: 'Demeshko',
        header: 'Posted new message',
        text: '“I mean, they say you die twice. One time when you stop breathing and a second time, a bit later on, when somebody says your name for the last time." ©',
        time: '15.11.2015',
        ago: '6 days ago',
        expanded: false,
      }, {
       type: 'geo-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted photo',
        text: '"Protein Heroes"',
        preview: 'app/feed/genom.png',
        link: 'https://dribbble.com/shots/2504810-Protein-Heroes',
        time: '16.11.2015',
        ago: '7 days ago',
        expanded: false,
      },
      {
        type: 'geo-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Why did the CoffeeScript developer keep getting lost? Because he couldn\'t find his source without a map',
        time: '18.11.2015',
        ago: '9 days ago',
        expanded: false,
      }
    ];

    $scope.expandMessage = function(message){
      message.expanded = !message.expanded;
    }
	  $scope.ddSelectOptions = [
        {
            text: 'Option1',
            value: 'a value'
        },
        {
            text: 'Option2',
            value: 'another value',
            someprop: 'somevalue'
        },
        {
            // Any option with divider set to true will be a divider
            // in the menu and cannot be selected.
            divider: true
        },
        {
            // Any divider option with a 'text' property will
            // behave similarly to a divider and cannot be selected.
            divider: true,
            text: 'divider label'
        },
        {
            // Example of an option with the 'href' property
            text: 'Option4',
            href: '#option4'
        }
    ];
    $scope.ddSelectSelected = {}; // Must be an object
	   $scope.markersWatchOptions = {
            doWatch: false,
            isDeep: false,
            individual: {
                doWatch: false,
                isDeep: false
            }
        };
		
		
	
	 var markers = [];
            markers.push({
                lat: 52.229676,
                lng: 21.012229,
                draggable: false,
                group: 'markers'
            });
            markers.push({
                lat: 52.219081,
                lng: 21.025386,
                draggable: false,
                group: 'markers'
            });

angular.extend($scope, {
       center: {
                    lat: 24.0391667,
                    lng: 121.525,
                    zoom: 6
                },
                markers: {
                    taipei: {
                        layer: "northTaiwan",
                        lat: 25.0391667,
                        lng: 121.525,
                    },
                    yangmei: {
                        layer: "northTaiwan",
                        lat: 24.9166667,
                        lng: 121.1333333
                    },
                    hsinchu: {
                        layer: "northTaiwan",
                        lat: 24.8047222,
                        lng: 120.9713889
                    },
                    miaoli: {
                        layer: "northTaiwan",
                        lat: 24.5588889,
                        lng: 120.8219444
                    },
                    tainan: {
                        layer: "southTaiwan",
                        lat: 22.9933333,
                        lng: 120.2036111
                    },
                    puzi: {
                        layer: "southTaiwan",
                        lat: 23.4611,
                        lng: 120.242
                    },
                    kaohsiung: {
                        layer: "southTaiwan",
                        lat: 22.6252777778,
                        lng: 120.3088888889
                    },
                    taitun: {
                        layer: "southTaiwan",
                        lat: 22.75,
                        lng: 121.15
                    }
                },
        layers: {
            baselayers: { googleRoadmap: {
                name: 'Google Streets',
                layerType: 'ROADMAP',
                type: 'google'
            },
                googleTerrain: {
                    name: 'Google Terrain',
                    layerType: 'TERRAIN',
                    type: 'google'
                },
                googleHybrid: {
                    name: 'Google Hybrid',
                    layerType: 'HYBRID',
                    type: 'google'
                },
                mapbox_light: {
                    name: 'Mapbox Light',
                    type: 'mapbox',
                    user: 'josephmarcs',
                    key: 'cj5eq1epl1m7l2ro47eq1qo7w',
                    apiKey: 'pk.eyJ1Ijoiam9zZXBobWFyY3MiLCJhIjoiY2o1YWNpdG1xMGljNzJxcDF4NG5jODBxZyJ9.Dtzqb4dzhpnpDMJNZy2B2Q'
                }
            },
			overlays: {
                        northTaiwan: {
                            name: "North cities",
                            type: "markercluster",
                            visible: true
                        },
                        southTaiwan: {
                            name: "South cities",
                            type: "markercluster",
                            visible: true
                        }
                    }
        }
		
    });
	
	       
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';
  
    angular.module('Monitour.pages.dashboard')
        .directive('topHeader', topHeader);
  
    /** @ngInject */
    function topHeader() {
      return {
        restrict: 'E',
        controller: 'topHeaderCtrl',
        templateUrl: 'app/pages/dashboard/topHeader/topHeader.html'
      };
    }
  })();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';
  
    angular.module('Monitour.pages.dashboard')
        .controller('TopHeaderCtrl', TopHeaderCtrl);
  
    /** @ngInject */
    function TopHeaderCtrl($scope, baConfig, colorHelper) {
  
  
    }
  })();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';
  
    angular.module('Monitour.pages.dashboard')
        .directive('dashboardPayment', dashboardPayment);
  
    /** @ngInject */
    function dashboardPayment() {
      return {
        restrict: 'E',
        controller: 'dashboardPaymentCtrl',
        templateUrl: 'app/pages/dashboard/dashboardPayment/dashboardPayment.html'
      };
    }
  })();
  /**
 * @author v.lugovksy
 * created on 27.07.2017
 */
(function () {
	'use strict';
  
	angular.module('Monitour.pages.dashboard')
	.controller('dashboardPaymentCtrl', dashboardPaymentCtrl);
  
	/** @ngInject */
	function dashboardPaymentCtrl($scope,  $http, $localStorage ,$state,  SweetAlert,  $translate) {
		var vm = this;
		
	
        //vm.create = create;

        vm.owner = $localStorage.currentUser;
        $scope.card = {};
		console.log($scope.card);
		  $scope.isVisa = function(){
			if($scope.card.number && $scope.card.number.charAt(0) == 4){
			  return true;
			}else{
			  return false;
			}
		  };
		
		  $scope.isMasterCard = function(){
			if($scope.card.number && $scope.card.number.charAt(0) == 5){
			  return true;
			}else{
			  return false;
			}
		  };
	}
  })();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';
  
    angular.module('Monitour.pages.dashboard')
        .directive('dashboardWelcome', dashboardWelcome);
  
    /** @ngInject */
    function dashboardWelcome() {
      return {
        restrict: 'E',
        controller: 'DashboardWelcomeCtrl',
        templateUrl: 'app/pages/dashboard/welcome/dashboardWelcome.html'
      };
    }
  })();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';
  
    angular.module('Monitour.pages.dashboard')
        .controller('DashboardWelcomeCtrl', DashboardWelcomeCtrl);
  
    /** @ngInject */
    function DashboardWelcomeCtrl($scope, baConfig, colorHelper,ProfileService, InvoiceService,PaymentService ) {
        var vm = this;
        ProfileService.GetAll().then(function(response) {
            vm.details = response;
            console.log(response);
            console.log('hello');
         
  
  
        }, function(error) {
            $scope.status = 'Unable to load customer data: ' + error.message;
        });
        InvoiceService.GetAll()
    .then(function (response) {
        vm.invoices = response.data[0].result;
        vm.totalinvoices = response.data[0].count;

        // Counting unpaid (false status) invoices
        vm.unpaidInvoicesCount = vm.invoices.filter(function(invoice) {
            return invoice.status === "false"; // or just `false` if it's a boolean
        }).length;

        console.log("Unpaid Invoices Count: ", vm.unpaidInvoicesCount);
        // Rest of your code...
    }, function (error) {
        vm.status = 'Unable to load customer data: ' + error.message;
    });
    PaymentService.GetAll()
    .then(function (response) {
        vm.payments = response.data[0].result;
        vm.totalpayments = response.data[0].count; // This already seems to hold the total count of payments
        console.log(response);
    }, function (error) {
        vm.status = 'Unable to load customer data: ' + error.message;
    });


   vm.plan = 'Test plan';
    }
  })();
/**
 * @author monitour
 * created on 27.07.2017
 */
(function() {
	'use strict';
	angular.module('Monitour.pages.profile').controller('plansCtrl', plansCtrl);
	/** @ngInject */
	function plansCtrl($scope,  $http, $localStorage ,$state,  SweetAlert,  $translate) {
		var vm = this;
		
        vm.owner = $localStorage.currentUser;
      
	}
})();
/**
 * @author a.demeshko
 * created on 21.01.2016
 */
(function () {
    'use strict';

    angular.module('Monitour.pages.profile')
        .controller('editCtrl', editCtrl);

    /** @ngInject */
    function editCtrl($scope, ProfileService,  $localStorage, fileReader, $filter, $uibModal) {
        ProfileService.GetAll().then(function(response) {
            vm.details = response;
            vm.selectedd = response.image;
            vm.selectedid = response.image;
            console.log(response);

            $localStorage.currentUserCompany = response.owner;


        }, function(error) {
            $scope.status = 'Unable to load customer data: ' + error.message;
        });


        vm.upload = function(size) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/pages/profile/gallery/upload.html',
                controller: 'UploadController',
                controllerAs: 'vm',
                size: size,
                resolve: {
                    selected: function() {
                        return vm.selected;
                    }
                }
            });
            modalInstance.result.then(function(selected) {
                vm.selected = selected.Url;
                vm.selectedd = selected;
                vm.selectedid = selected.Id;
                console.log(vm.selectedd);
            }, function() {
                $log.info('Modal dismissed at: ' + new Date());
            });
        };

        vm.open = function(size) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/pages/profile/gallery/gallery.html',
                controller: 'ImageController',
                controllerAs: 'vm',
                size: size,
                resolve: {
                    selected: function() {
                        return vm.selected;
                    }
                }
            });
            modalInstance.result.then(function(selected) {
                vm.selected = selected.Url;
                vm.selectedd = selected;
                vm.selectedid = selected.Id;
                console.log(vm.selectedd);
            }, function() {
                $log.info('Modal dismissed at: ' + new Date());
            });
        };


        var owner = $localStorage.currentUserid;

        $scope.onCategoryChange = function () {
            console.log(vm.itemSelected);


        };
        $scope.picture = $filter('profilePicture')('Nasta');

        $scope.removePicture = function () {
            $scope.picture = $filter('appImage')('theme/no-photo.png');
            $scope.noPicture = true;
        };

        $scope.uploadPicture = function () {
            var fileInput = document.getElementById('uploadFile');
            fileInput.click();

        };

        $scope.socialProfiles = [
            {
                name: 'Facebook',
                href: 'https://www.facebook.com/akveo/',
                icon: 'socicon-facebook'
            },
            {
                name: 'Twitter',
                href: 'https://twitter.com/akveo_inc',
                icon: 'socicon-twitter'
            },
            {
                name: 'Google',
                icon: 'socicon-google'
            },
            {
                name: 'LinkedIn',
                href: 'https://www.linkedin.com/company/akveo',
                icon: 'socicon-linkedin'
            },
            {
                name: 'GitHub',
                href: 'https://github.com/akveo',
                icon: 'socicon-github'
            },
            {
                name: 'StackOverflow',
                icon: 'socicon-stackoverflow'
            },
            {
                name: 'Dribbble',
                icon: 'socicon-dribble'
            },
            {
                name: 'Behance',
                icon: 'socicon-behace'
            }
        ];

        $scope.unconnect = function (item) {
            item.href = undefined;
        };

        $scope.showModal = function (item) {
            $uibModal.open({
                animation: false,
                controller: 'ProfileModalCtrl',
                templateUrl: 'app/pages/profile/profileModal.html'
            }).result.then(function (link) {
                item.href = link;
            });
        };

        $scope.getFile = function () {
            fileReader.readAsDataUrl($scope.file, $scope)
                .then(function (result) {
                    $scope.picture = result;
                });
        };

        $scope.switches = [true, true, false, true, true, false];
    }

})();
/**
 * @author a.demeshko
 * created on 21.01.2016
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.profile')
    .controller('ProfileModalCtrl', ProfileModalCtrl);

  /** @ngInject */
  function ProfileModalCtrl($scope, $uibModalInstance) {
    $scope.link = '';
    $scope.ok = function () {
      $uibModalInstance.close($scope.link);
    };
  }

})();
(function() {
    'use strict';

    angular.module('Monitour.pages.profile').controller('plansCtrl', plansCtrl);

    /** @ngInject */
    function plansCtrl($scope, $http, $localStorage, $state, SweetAlert, $stateParams, $translate, ProfileService) {
        var vm = this;

        vm.owner = $localStorage.currentUser;

        ProfileService.Products()
            .then(function(response) {
                console.log('Original Product Data:', response.data); // Log original product data

                // Only include products with Status true
                vm.plans = response.data.filter(function(product) {
                    return product.Status === true;
                });

                console.log('Filtered Product Data:', vm.plans); // Log filtered product data

            }, function(error) {
                vm.status = 'Unable to load customer data: ' + error.message;
            });
    }
})();

/**
 * @author monitour
 * created on 27.07.2017
 */
(function() {
    'use strict';
    angular.module('Monitour.pages.profile').controller('purchaseCtrl', purchaseCtrl);

    /** @ngInject */
    function purchaseCtrl($scope, $http, $localStorage, $state, SweetAlert, $translate, $stateParams, $filter, ProfileService, $timeout, stripeService) {
        var vm = this;

        vm.owner = $localStorage.currentUser;
        var id = $stateParams.id;

        vm.formParams = {};
        var stripe = stripeService.getStripe();

        // Initialize the card element
        vm.cardElement = null;

        // Function to handle the card element ready event
        vm.handleCardReady = function(card) {
            vm.cardElement = card;
        };

        // Function to create and mount the card element
        function initializeCardElement() {
            if (!vm.cardElement) {
                var elements = stripe.elements();
                var card = elements.create('card');
                card.mount('#card-element');
                vm.handleCardReady(card);
            }
        }

        // Destroy the card element when the scope is destroyed
        $scope.$on('$destroy', function() {
            if (vm.cardElement) {
                vm.cardElement.unmount();
                vm.cardElement.destroy();
                vm.cardElement = null;
            }
        });

        // Create the card element
        initializeCardElement();

        function addMonthsToDate(date, months) {
            var result = new Date(date);
            result.setMonth(result.getMonth() + months);
            return result;
        }

        ProfileService.GetAll().then(function(response) {
            vm.detail = response;
            vm.initialRecurringValue = vm.detail.recurring;
            vm.expiry = new Date(response.subscriptionExpiryDate);

            ProfileService.ProductsById(id).then(function(response) {
                vm.products = response;

                if (vm.products.Period && vm.expiry) {
                    vm.endDate = addMonthsToDate(vm.expiry, parseInt(vm.products.Period));
                }
            }, function(error) {
                $scope.error = 'Unable to get the payment details: ' + error.message;
            });

        }, function(error) {
            $scope.status = 'Unable to load customer data: ' + error.message;
        });

        $scope.isSectionVisible = false;

        $scope.toggleSection = function() {
            $scope.isSectionVisible = !$scope.isSectionVisible;
        };

        vm.patchRecurringBool = function() {
            var renewal = { renewal: vm.detail.recurring };
            ProfileService.Renewal(renewal).then(function successCallback(response) {
                var message = vm.detail.recurring ?
                    "Your account is on auto renewal." :
                    "Your account is not on auto renewal.";

                if (response) {
                    swal("Successfully Updated Your Account", "You have updated your account, " + message, "success");
                    vm.initialRecurringValue = vm.detail.recurring;
                } else {
                    swal("Update was Unsuccessful", "Please check the details you entered.", "error");
                }
            });
        };

        $scope.$watch('vm.detail.recurring', function(newVal) {
            if (newVal !== vm.initialRecurringValue) {
                vm.patchRecurringBool();
            }
        });

        vm.payment = paymentForm;

        function paymentForm() {
            if (vm.cardElement) {
                stripe.createToken(vm.cardElement).then(function(result) {
                    if (result.error) {
                        console.error(result.error.message);
                    } else {
                        var payment = {
                            amount: vm.products.Total,
                            phoneId: vm.detail.phoneId,
							productid: id,
                            expiry: vm.endDate,
                            token: result.token.id,
                            userlimit: '0'
                        };

                        vm.dataLoading = true;

                        ProfileService.Pay(payment, id).then(function successCallback(response) {
                            if (response.success) {
                                swal("Successfully Payment", "You have renewed your subscription", "success");
								
                            } else {
                                swal("Payment was Unsuccessful", "Please check the details you entered.", "error");
                            }
                        });
                    }
                });
            }
        }
    }
})();

/**
 * @author JosephMarcs
 * created on 08.07.2017
 */
(function () {
    'use strict';

    angular.module('Monitour.pages.profile')
        .controller('viewCtrl', viewCtrl);

    /** @ngInject */
    function viewCtrl($scope) {

    }

})();
(function() {
    'use strict';
    angular.module('Monitour.pages.payment').controller('PaymentCtrl', PaymentCtrl);

    /** @ngInject */
    function PaymentCtrl($scope, baConfig, $filter, colorHelper, $http, $localStorage, $state, SweetAlert, $translate, $stateParams, PaymentService, InvoiceService) {
        var vm = this;
        var id = $stateParams.id;

        console.log(id);

     
            PaymentService.GetById(id).then(function(response) {
                vm.payment = response.data[0];
                console.log(vm.payment);
            }, function(error) {
                // Handle error in getting payment details
                $scope.error = 'unable to get the payment details';
            });

      


        
    }
})();

/**
 * @author monitour
 * created on 27.07.2017
 */
(function () {
    'use strict';

    angular.module('Monitour.pages.sites')
        .controller('sitesEditCtrl', sitesEditCtrl);

    /** @ngInject */
    function sitesEditCtrl($scope) {
        var vm = this;
        var id = $stateParams.id;
        vm.types = "['geocode']";

        vm.showResults = function(){
            return (vm.results ? vm.results=false : vm.results=true)
        }

        vm.placeChanged = function() {


            vm.place = this.getPlace();
            console.log('location', vm.place.geometry.location.lat());
            $scope.markers.osloMarker = {
                lat: vm.place.geometry.location.lat(),
                lng: vm.place.geometry.location.lng(),
                focus: true,
                message: vm.place.geometry,
                draggable: true
            }

            $scope.osloCenter = {
                lat: vm.place.geometry.location.lat(),
                lng: vm.place.geometry.location.lng(),
                zoom: 16
            }

            //vm.map.setCenter(vm.place.geometry.location);
        }

        angular.extend($scope, {
            osloCenter: {},
            markers: {},
            layers: {
                baselayers: {
                    googleRoadmap: {
                        name: 'Google Streets',
                        layerType: 'ROADMAP',
                        type: 'google'
                    },
                    googleTerrain: {
                        name: 'Google Terrain',
                        layerType: 'TERRAIN',
                        type: 'google'
                    },
                    googleHybrid: {
                        name: 'Google Hybrid',
                        layerType: 'HYBRID',
                        type: 'google'
                    }

                }
            },
            events: { // or just {} //all events
                markers:{
                    enable: [ 'dragend' ]
                    //logic: 'emit'
                }
            }
        });


        $scope.$on("leafletDirectiveMarker.dragend", function(event, args){
            console.log(args.model.lat);
            console.log(args.model.lng);
        });

        ClientsService.GetAll().then(function(response) {
            vm.clients = response.data;
            console.log(vm.clients);
        }, function(error) {
            $scope.status = 'Unable to load user data: ' + error.message;
        });

        $scope.$watch(function() {
            $('#clients').selectpicker('refresh');
        });
        GetById(id);

        function GetById(id) {
            SitesService.GetById(id)
                .then(function (response) {
                    vm.details = response.data[0];
                    vm.address1 = response.data[0].address;
                    //vm.address1 = response.data.client.Address;
                    console.log(  vm.details );
                    var geocoder = new google.maps.Geocoder();
                    var address = vm.address1;
                    console.log(address);
                    geocoder.geocode({ 'address': address }, function (results, status) {
                        if (status == google.maps.GeocoderStatus.OK) {

                            vm.address = results[0];
                            console.log(vm.address );

                            $scope.markers.osloMarker = {
                                lat: JSON.parse(vm.address.geometry.location.lat()),
                                lng: JSON.parse(vm.address.geometry.location.lng()),
                                focus: true,
                                message: "test",
                                draggable: true
                            }

                            $scope.osloCenter = {
                                lat: JSON.parse(vm.address.geometry.location.lat()),
                                lng: JSON.parse(vm.address.geometry.location.lng()),
                                zoom: 16
                            }
                        } else {
                            alert("Request failed.")
                        }
                    });
                }, function (error) {
                    $scope.status = 'Unable to load customer data: ' + error.message;
                });
        }
        $scope.onCategoryChange = function () {
            console.log(vm.details.client);

            //alert("Selected Value: " + vm.itemSelected.id + "\nSelected Text: " + vm.itemSelected.name  + " Text: " + vm.itemSelected.power);

        };


        vm.Update = Update;
        vm.owner = $localStorage.currentOwnerid;
        function Update () {
            var id = $stateParams.id;
            var site =  { name: vm.details.name, phone: vm.details.phone, contact: vm.details.contact, client: vm.details.client, owner:  vm.owner, address: vm.details.address, state: vm.details.state, latitude: vm.address.components.location.lat, longitude: vm.address.components.location.long, extra: vm.details.extra };
            console.log(site);
            vm.loading = true;
            SitesService.Update(site, id).then(function (response) {
                if (response) {
                    console.log( response);

                    sweet.show('Amazing', 'You\'ve done it', 'success');
                    $state.go('sites.list', {}, {reload: true});
                } else {

                    console.log( response);
                    vm.loading = false;
                    sweet.show('Error has occured', 'Please check the details you have entered');
                }
            });
        };

    }

})();

/**
 * @author monitour
 * created on 27.07.2017
 */
(function () {
    'use strict';

    angular.module('Monitour.pages.sites')
        .controller('sitesListCtrl', sitesListCtrl);

    /** @ngInject */
    function sitesListCtrl($scope, SitesService, $http, $filter,  $state, SweetAlert) {
        var vm = this;

        vm.filter = filter;


        vm.clienttoggle = function (client) {
            vm.client = client;
            console.log(vm.client.clientName);
        }
        vm.sitetoggle = function (site) {
            vm.site = site;
            console.log(vm.site.siteName);
        }
        vm.devicetoggle = function (device) {
            vm.device = device;
            console.log(vm.device);
        }
        vm.date = {
            startDate: moment().subtract(1, "days"),
            endDate: moment()
        };
        //Watch for date changes
        $scope.$watch('date', function (newDate) {
            console.log('New date set: ', newDate);
        }, false);

        $scope.checked = false;
        $scope.size = '100px';
        $scope.toggle = function () {
            $scope.checked = !$scope.checked
        }
        vm.reset = function () {
            vm.client = [];
            vm.site = [];
        }

        vm.checkpoints = [];
        vm.totalCheckpoints = 0;
        vm.checkpointsPerPage = 2; // this should match however many results your API puts on one page
        getResultsPage(1);

        vm.pagination = {
            current: 1
        };

        vm.pageChanged = function (newPage) {
            getResultsPage(newPage);
        };
        function getResultsPage(pageNumber) {
            var itemsPerPage = vm.checkpointsPerPage;
            // this is just an example, in reality this stuff should be in a service
            SitesService.GetAll(pageNumber, itemsPerPage)
                .then(function (response) {
                    vm.checkpoints = response.data[0].result;
                    vm.totalCheckpoints = response.data[0].count;
                    console.log(vm.totalCheckpoints);
                    console.log(vm.checkpoints);
                }, function (error) {
                    vm.status = 'Unable to load customer data: ' + error.message;
                });


        }

        function filter() {


            if (!vm.client) {
                console.log('no client');
                vm.clientselected = null;
                var client = vm.clientselected;
            } else {
                console.log('yes client');

                vm.clientselected = vm.client.client;
                var client = vm.clientselected;
            }


            if (!vm.site) {

                vm.siteselected = null;

                var site =  vm.siteselected;
            } else {


                vm.siteselected = vm.site.siteId;

                var site =  vm.siteselected;

            }
            vm.loading = true;

            getResultsPage(1);


            vm.pageChanged = function (newPage) {
                getResultsPage(newPage);
            };
            function getResultsPage(pageNumber) {
                var itemsPerPage = vm.checkpointsPerPage;

                SitesService.GetFilters(client, site, pageNumber, itemsPerPage).then(function (response) {

                    vm.checkpoints = response.data[0].result;
                    vm.totalCheckpoints = response.data[0].count;
                    console.log(vm.totalCheckpoints);
                    console.log(vm.checkpoints);
                }, function (error) {
                    $scope.status = 'Unable to load customer data: ' + error.message;
                });


            };
        }

        var confirmtext = $filter('translate')('checkpointlist.deleteconfirm');
        var deletethisuser = $filter('translate')('checkpointlist.deletethisuser');
        var yesdeletethisuser = $filter('translate')('checkpointlist.yesdeletethisuser');
        var canceltext = $filter('translate')('checkpointlist.canceltext');
        var cancelledtext = $filter('translate')('checkpointlist.cancelledtext');
        var userdeleted = $filter('translate')('checkpointlist.userdeleted');
        var deleted = $filter('translate')('checkpointlist.deleted');
        var successtext = $filter('translate')('checkpointlist.successtext');

        vm.deleteCheckpoint =  function Delete(id, index) {

            SweetAlert.swal({

                title: confirmtext,
                text: deletethisuser,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: yesdeletethisuser,
                cancelButtonText: canceltext,
                closeOnConfirm: false,
                closeOnCancel: false
            }, function(isConfirm) {
                if (isConfirm) {

                    CheckpointsService.Delete(id)
                        .then(function (response) {
                            vm.rowCollection.splice(index, 1);
                            SweetAlert.swal(deleted, userdeleted,successtext);

                            console.log(response);
                        }, function (error) {
                            $scope.status = 'Unable to load customer data: ' + error.message;
                        });

                }
                else
                {

                    SweetAlert.swal("Cancelled", cancelledtext, "error");
                }
            });

        }
    }

})();

/**
 * @author monitour
 * created on 27.07.2017
 */
(function () {
    'use strict';

    angular.module('Monitour.pages.sites')
        .controller('sitesNewCtrl', sitesNewCtrl);

    /** @ngInject */
    function sitesNewCtrl($scope, $rootScope, ClientsService, SweetAlert, SitesService) {
        var vm = this;
        vm.types = "['geocode']";
        vm.isDisabled = true;
        vm.form = {

            components: [
            ],
            display: "form",
            page: 0

        };


        console.log(vm.form);
        vm.placeChanged = function() {


            vm.place = this.getPlace();

            vm.zipcode = '';
            vm.country = '';
            vm.state = '';
            vm.city = '';

            // FINDING ZIP
            if (vm.place.address_components[vm.place.address_components.length-1].types[0] == 'postal_code') {
                vm.zipcode = Number(vm.place.address_components[vm.place.address_components.length-1].long_name);
            };

            // FINDING COUNTRY
            if (vm.place.address_components[vm.place.address_components.length-1].types[0] == 'country' ||
                vm.place.address_components[vm.place.address_components.length-2].types[0] == 'country') {
                if(vm.place.address_components[vm.place.address_components.length-1].types[0] == 'country'){
                    vm.country = vm.place.address_components[vm.place.address_components.length-1].long_name;
                }else{
                    vm.country = vm.place.address_components[vm.place.address_components.length-2].long_name;
                }
            };

            // FINDING STATE
            if (vm.place.address_components[vm.place.address_components.length-1].types[0] == 'administrative_area_level_1' ||
                vm.place.address_components[vm.place.address_components.length-2].types[0] == 'administrative_area_level_1' ||
                vm.place.address_components[vm.place.address_components.length-3].types[0] == 'administrative_area_level_1') {

                if(vm.place.address_components[vm.place.address_components.length-1].types[0] == 'administrative_area_level_1'){
                    vm.state = vm.place.address_components[vm.place.address_components.length-1].long_name;
                }else if(vm.place.address_components[vm.place.address_components.length-2].types[0] == 'administrative_area_level_1'){
                    vm.state = vm.place.address_components[vm.place.address_components.length-2].long_name;
                }else{
                    vm.state = vm.place.address_components[vm.place.address_components.length-3].long_name;
                }
            };

            // FINDING CITY
            if (vm.place.address_components[vm.place.address_components.length-1].types[0] == 'locality' ||
                vm.place.address_components[vm.place.address_components.length-2].types[0] == 'locality' ||
                vm.place.address_components[vm.place.address_components.length-3].types[0] == 'locality' ||
                vm.place.address_components[vm.place.address_components.length-4].types[0] == 'locality' ) {

                if(vm.place.address_components[vm.place.address_components.length-1].types[0] == 'locality'){
                    vm.city = vm.place.address_components[vm.place.address_components.length-1].long_name;
                }else if(vm.place.address_components[vm.place.address_components.length-2].types[0] == 'locality'){
                    vm.city = vm.place.address_components[vm.place.address_components.length-2].long_name;
                }else if(vm.place.address_components[vm.place.address_components.length-3].types[0] == 'locality'){
                    vm.city = vm.place.address_components[vm.place.address_components.length-3].long_name;
                }else{
                    vm.city = vm.place.address_components[vm.place.address_components.length-4].long_name;
                }
            };

            console.log(vm.city);
            console.log('location', vm.place.address_components);

            if( vm.radius  == null){
                $scope.markers.siteMarker = {
                    lat: vm.place.geometry.location.lat(),
                    lng: vm.place.geometry.location.lng(),
                    focus: true,
                    message: vm.place.formatted_address,
                    draggable: true
                }

                $scope.siteCenter = {
                    lat: vm.place.geometry.location.lat(),
                    lng: vm.place.geometry.location.lng(),
                    zoom: 16
                }
            } else {

                $scope.markers.siteMarker = {
                    lat: vm.place.geometry.location.lat(),
                    lng: vm.place.geometry.location.lng(),
                    focus: true,
                    message: vm.place.formatted_address,
                    draggable: true
                }

                $scope.siteCenter = {
                    lat: vm.place.geometry.location.lat(),
                    lng: vm.place.geometry.location.lng(),
                    zoom: 16
                }

                $scope.paths.sitePath = {

                    latlngs: {
                        lat: vm.place.geometry.location.lat(),
                        lng: vm.place.geometry.location.lng()
                    },
                    radius: vm.radius,
                    type: 'circle'
                }
            };


            //vm.map.setCenter(vm.place.geometry.location);
        }



        var tiles = { tiles: {

            url: "http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
            options: {
                attribution: "",
                minZoom: 18,
                maxZoom: 22
            }}};
        angular.extend($scope, tiles,  {
            siteCenter: {},
            markers: {},
            paths: {},

            layers: {
                baselayers: {
                    googleRoadmap: {
                        name: 'Google Streets',
                        layerType: 'ROADMAP',
                        type: 'google'
                    },
                    googleTerrain: {
                        name: 'Google Terrain',
                        layerType: 'TERRAIN',
                        type: 'google'
                    },
                    googleHybrid: {
                        name: 'Google Hybrid',
                        layerType: 'HYBRID',
                        type: 'google'
                    }

                }
            },

            events: { // or just {} //all events
                markers:{
                    enable: [ 'dragend' ]
                    //logic: 'emit'
                }
            }
        });


        $scope.$on("leafletDirectiveMarker.dragend", function(event, args){
            console.log(args.model.lat);
            console.log(args.model.lng);
        });

        ClientsService.GetAll().then(function (response) {
            vm.clients = response.data;
            console.log(vm.clients);
        }, function (error) {
            $scope.status = 'Unable to load customer data: ' + error.message;
        });

        $scope.onCategoryChange = function () {
            console.log(vm.selectedClientId);
        };

        vm.onRadiusChange = function () {
            console.log(vm.radius);
            $scope.paths.sitePath = {

                latlngs: {
                    lat: vm.place.geometry.location.lat(),
                    lng: vm.place.geometry.location.lng()
                },
                radius: vm.radius,
                type: 'circle'
            }
        }

        $scope.$watch(function() {
            $('#categoryGroup').selectpicker('refresh');
        });
        vm.create = create;
      //  vm.owner = $localStorage.currentOwnerid;
        function create () {
            var site =  { name: vm.name, phone: vm.phone, contact: vm.contact, client: vm.selectedClientId,  state: vm.address.components.state, address: vm.address.name, latitude: vm.address.components.location.lat, longitude: vm.address.components.location.long, extra: vm.extra };
            console.log(site);
            vm.loading = true;
            SitesService.Create(site).then(function (response) {
                if (response) {
                    console.log( response);

                    SweetAlert.swal('Amazing', 'You\'ve done it', 'success');
                    $state.go('sites.list', {}, {reload: true});
                } else {

                    console.log( response);
                    vm.loading = false;
                    SweetAlert.swal('Error has occured', 'Please check the details you have entered');
                }
            });
        };

    }

})();
/**
 * @author monitour
 * created on 27.07.2017
 */
(function () {
    'use strict';

    angular.module('Monitour.pages.sites')
        .controller('sitesViewCtrl', sitesViewCtrl);

    /** @ngInject */
    function sitesViewCtrl($scope) {
        var vm = this;
 var id = $stateParams.id;

    }

})();

/**
 * @author monitour
 * created on 27.07.2017
 */
(function () {
    'use strict';

    angular.module('Monitour.pages.user')
        .controller('userNewCtrl', userNewCtrl);

    /** @ngInject */
    function userNewCtrl($scope, $rootScope,  $localStorage,  SweetAlert,  $state, $uibModal, $log,  Upload,  $timeout, $translate) {
        var vm = this;
       

      

       





    }

})();

/**
 * @author monitour
 * created on 27.07.2017
 */
(function() {
	'use strict';
	angular.module('Monitour.pages.user').controller('userListCtrl', userListCtrl);
	/** @ngInject */
	function userListCtrl($scope,  $http,    $localStorage ,$state, SweetAlert,  $translate) {
		var vm = this;
		
       vm.filter = filter;


        vm.clienttoggle = function (client) {
            vm.client = client;
            console.log(vm.client.clientName);
        }
        vm.sitetoggle = function (site) {
            vm.site = site;
            console.log(vm.site.siteName);
        }
        vm.devicetoggle = function (device) {
            vm.device = device;
            console.log(vm.device);
        }
        vm.date = {
            startDate: moment().subtract(1, "days"),
            endDate: moment()
        };
        //Watch for date changes
        $scope.$watch('date', function (newDate) {
            console.log('New date set: ', newDate);
        }, false);

        $scope.checked = false;
        $scope.size = '100px';
        $scope.toggle = function () {
            $scope.checked = !$scope.checked
        }
        vm.reset = function () {
            vm.client = [];
            vm.site = [];
        }
		function filter() {


            if (!vm.client) {
                console.log('no client');
                vm.clientselected = null;
                var client = vm.clientselected;
            } else {
                console.log('yes client');

                vm.clientselected = vm.client.client;
                var client = vm.clientselected;
            }


            if (!vm.site) {

                vm.siteselected = null;

                var site =  vm.siteselected;
            } else {


                vm.siteselected = vm.site.siteId;

                var site =  vm.siteselected;

            }
            vm.loading = true;

            getResultsPage(1);


            vm.pageChanged = function (newPage) {
                getResultsPage(newPage);
            };
           
        }
	}
})();
/**
 * @author monitour
 * created on 27.07.2017
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.ui.buttons')
      .controller('ButtonPageCtrl', ButtonPageCtrl);

  /** @ngInject */
  function ButtonPageCtrl($scope, $timeout) {
    $scope.progressFunction = function() {
      return $timeout(function() {}, 3000);
    };
  }

})();

/**
 * @author a.demeshko
 * created on 18.01.2016
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.ui.notifications')
    .controller('ModalsPageCtrl', ModalsPageCtrl);

  /** @ngInject */
  function ModalsPageCtrl($scope, $uibModal, baProgressModal) {
    $scope.open = function (page, size) {
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.openProgressDialog = baProgressModal.open;
  }


})();

/**
 * @author monitour
 * created on 27.07.2017
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.ui.icons')
      .controller('IconsPageCtrl', IconsPageCtrl);

  /** @ngInject */
  function IconsPageCtrl($scope) {
    $scope.icons = {
      kameleonIcons: [
        {
          name: 'Beach',
          img: 'Beach'
        },
        {
          name: 'Bus',
          img: 'Bus'
        },
        {
          name: 'Cheese',
          img: 'Cheese'
        },
        {
          name: 'Desert',
          img: 'Desert'
        },
        {
          name: 'Images',
          img: 'Images'
        },
        {
          name: 'Magician',
          img: 'Magician'
        },
        {
          name: 'Makeup',
          img: 'Makeup'
        },
        {
          name: 'Programming',
          img: 'Programming'
        },
        {
          name: 'Shop',
          img: 'Shop'
        },
        {
          name: 'Surfer',
          img: 'Surfer'
        },
        {
          name: 'Phone Booth',
          img: 'Phone-Booth'
        },
        {
          name: 'Ninja',
          img: 'Ninja'
        },
        {
          name: 'Apartment',
          img: 'Apartment'
        },
        {
          name: 'Batman',
          img: 'Batman'
        },
        {
          name: 'Medal',
          img: 'Medal-2'
        },
        {
          name: 'Money',
          img: 'Money-Increase'
        },
        {
          name: 'Street View',
          img: 'Street-View'
        },
        {
          name: 'Student',
          img: 'Student-3'
        },
        {
          name: 'Bell',
          img: 'Bell'
        },
        {
          name: 'Woman',
          img: 'Boss-5'
        },
        {
          name: 'Euro',
          img: 'Euro-Coin'
        },
        {
          name: 'Chessboard',
          img: 'Chessboard'
        },
        {
          name: 'Burglar',
          img: 'Burglar'
        },
        {
          name: 'Dna',
          img: 'Dna'
        },
        {
          name: 'Clipboard Plan',
          img: 'Clipboard-Plan'
        },
        {
          name: 'Boss',
          img: 'Boss-3'
        },
        {
          name: 'Key',
          img: 'Key'
        },
        {
          name: 'Surgeon',
          img: 'Surgeon'
        },
        {
          name: 'Hacker',
          img: 'Hacker'
        },
        {
          name: 'Santa',
          img: 'Santa'
        }
      ],
      kameleonRoundedIcons: [
        {
          color: 'success',
          img: 'Apartment',
          name: 'Apartment'
        },
        {
          color: 'warning',
          img: 'Bus',
          name: 'Bus'
        },
        {
          color: 'primary',
          img: 'Checklist',
          name: 'Checklist'
        },
        {
          color: 'warning',
          img: 'Desert',
          name: 'Desert'
        },
        {
          color: 'danger',
          img: 'Laptop-Signal',
          name: 'Laptop Signal'
        },
        {
          color: 'info',
          img: 'Love-Letter',
          name: 'Love Letter'
        },
        {
          color: 'success',
          img: 'Makeup',
          name: 'Makeup'
        },
        {
          color: 'primary',
          img: 'Santa',
          name: 'Santa'
        },
        {
          color: 'success',
          img: 'Surfer',
          name: 'Surfer'
        },
        {
          color: 'info',
          img: 'Vector',
          name: 'Vector'
        },
        {
          color: 'warning',
          img: 'Money-Increase',
          name: 'Money Increase'
        },
        {
          color: 'info',
          img: 'Alien',
          name: 'Alien'
        },
        {
          color: 'danger',
          img: 'Online-Shopping',
          name: 'Online Shopping'
        },
        {
          color: 'warning',
          img: 'Euro-Coin',
          name: 'Euro'
        },
        {
          color: 'info',
          img: 'Boss-3',
          name: 'Boss'
        }
      ],
      ionicons: ['ion-ionic', 'ion-arrow-right-b', 'ion-arrow-down-b', 'ion-arrow-left-b', 'ion-arrow-up-c', 'ion-arrow-right-c', 'ion-arrow-down-c', 'ion-arrow-left-c', 'ion-arrow-return-right', 'ion-arrow-return-left', 'ion-arrow-swap', 'ion-arrow-shrink', 'ion-arrow-expand', 'ion-arrow-move', 'ion-arrow-resize', 'ion-chevron-up', 'ion-chevron-right', 'ion-chevron-down', 'ion-chevron-left', 'ion-navicon-round', 'ion-navicon', 'ion-drag', 'ion-log-in', 'ion-log-out', 'ion-checkmark-round', 'ion-checkmark', 'ion-checkmark-circled', 'ion-close-round', 'ion-plus-round', 'ion-minus-round', 'ion-information', 'ion-help', 'ion-backspace-outline', 'ion-help-buoy', 'ion-asterisk', 'ion-alert', 'ion-alert-circled', 'ion-refresh', 'ion-loop', 'ion-shuffle', 'ion-home', 'ion-search', 'ion-flag', 'ion-star', 'ion-heart', 'ion-heart-broken', 'ion-gear-a', 'ion-gear-b', 'ion-toggle-filled', 'ion-toggle', 'ion-settings', 'ion-wrench', 'ion-hammer', 'ion-edit', 'ion-trash-a', 'ion-trash-b', 'ion-document', 'ion-document-text', 'ion-clipboard', 'ion-scissors', 'ion-funnel', 'ion-bookmark', 'ion-email', 'ion-email-unread', 'ion-folder', 'ion-filing', 'ion-archive', 'ion-reply', 'ion-reply-all', 'ion-forward'],
      fontAwesomeIcons: ['fa fa-adjust', 'fa fa-anchor', 'fa fa-archive', 'fa fa-area-chart', 'fa fa-arrows', 'fa fa-arrows-h', 'fa fa-arrows-v', 'fa fa-asterisk', 'fa fa-at', 'fa fa-automobile', 'fa fa-ban', 'fa fa-bank', 'fa fa-bar-chart', 'fa fa-bar-chart-o', 'fa fa-barcode', 'fa fa-bars', 'fa fa-bed', 'fa fa-beer', 'fa fa-bell', 'fa fa-bell-o', 'fa fa-bell-slash', 'fa fa-bell-slash-o', 'fa fa-bicycle', 'fa fa-binoculars', 'fa fa-birthday-cake', 'fa fa-bolt', 'fa fa-bomb', 'fa fa-book', 'fa fa-bookmark', 'fa fa-bookmark-o', 'fa fa-briefcase', 'fa fa-bug', 'fa fa-building', 'fa fa-building-o', 'fa fa-bullhorn'],
      socicon: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', ',', ';', ':', '+', '@', '=', '-', '^', '?', '$', '*', '&', '(', '#', '.', '_', ']', ')', '\'', '"', '}', '{']
    }
  }

})();

/**
 * @author monitour
 * created on 27.07.2017
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.ui.notifications')
      .controller('NotificationsPageCtrl', NotificationsPageCtrl);

  /** @ngInject */
  function NotificationsPageCtrl($scope, toastr, toastrConfig) {
    var defaultConfig = angular.copy(toastrConfig);
    $scope.types = ['success', 'error', 'info', 'warning'];

    $scope.quotes = [
      {
        title: 'Come to Freenode',
        message: 'We rock at <em>#angularjs</em>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Looking for bootstrap?',
        message: 'Try ui-bootstrap out!'
      },
      {
        title: 'Wants a better router?',
        message: 'We have you covered with ui-router'
      },
      {
        title: 'Angular 2',
        message: 'Is gonna rock the world'
      },
      {
        title: null,
        message: 'Titles are not always needed'
      },
      {
        title: null,
        message: 'Toastr rock!'
      },
      {
        title: 'What about nice html?',
        message: '<strong>Sure you <em>can!</em></strong>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Ionic is <em>cool</em>',
        message: 'Best mobile framework ever',
        options: {
          allowHtml: true
        }
      }
    ];

    var openedToasts = [];
    $scope.options = {
      autoDismiss: false,
      positionClass: 'toast-top-right',
      type: 'info',
      timeOut: '5000',
      extendedTimeOut: '2000',
      allowHtml: false,
      closeButton: false,
      tapToDismiss: true,
      progressBar: false,
      newestOnTop: true,
      maxOpened: 0,
      preventDuplicates: false,
      preventOpenDuplicates: false,
      title: "Some title here",
      msg: "Type your message here"
    };


    $scope.clearLastToast = function () {
      var toast = openedToasts.pop();
      toastr.clear(toast);
    };

    $scope.clearToasts = function () {
      toastr.clear();
    };

    $scope.openRandomToast = function () {
      var type = Math.floor(Math.random() * $scope.types.length);
      var quote = Math.floor(Math.random() * $scope.quotes.length);
      var toastType = $scope.types[type];
      var toastQuote = $scope.quotes[quote];
      openedToasts.push(toastr[toastType](toastQuote.message, toastQuote.title, toastQuote.options));
      $scope.optionsStr = "toastr." + toastType + "(\'" + toastQuote.message + "\', \'" + toastQuote.title + "', " + JSON.stringify(toastQuote.options || {}, null, 2) + ")";
    };

    $scope.openToast = function () {
      angular.extend(toastrConfig, $scope.options);
      openedToasts.push(toastr[$scope.options.type]($scope.options.msg, $scope.options.title));
      var strOptions = {};
      for (var o in  $scope.options) if (o != 'msg' && o != 'title')strOptions[o] = $scope.options[o];
      $scope.optionsStr = "toastr." + $scope.options.type + "(\'" + $scope.options.msg + "\', \'" + $scope.options.title + "\', " + JSON.stringify(strOptions, null, 2) + ")";
    };

    $scope.$on('$destroy', function iVeBeenDismissed() {
      angular.extend(toastrConfig, defaultConfig);
    })
  }

})();

/**
 * @author v.lugovksy
 * created on 27.07.2017
 */
(function () {
  'use strict';

  angular.module('Monitour.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('Monitour.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('Monitour.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('Monitour.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author monitour
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('Monitour.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author monitour
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('Monitour.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author monitour
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('Monitour.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author monitour
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('Monitour.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author monitour
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('Monitour.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 27.07.2017
 */
(function () {
  'use strict';

  angular.module('Monitour.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('Monitour.theme.components')
    .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
            .filter(function(s) {
              return s.sidebarMeta;
            })
            .map(function(s) {
              var meta = s.sidebarMeta;
              return {
                name: s.name,
                title: s.title,
                level: ((s.name.match(/\./g) || []).length - 1),
                order: meta.order,
                icon: meta.icon,
                stateRef: s.name,
              };
            })
            .sort(function(a, b) {
              return (a.level - b.level) * 100 + a.order - b.order;
            });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();
/**
 * @author v.lugovksy
 * created on 27.07.2017
 */
(function () {
  'use strict';

  angular.module('Monitour.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService) {

    $scope.menuItems = baSidebarService.getMenuItems();
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 0;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author monitour
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('Monitour.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 27.07.2017
 */
(function () {
  'use strict';

  angular.module('Monitour.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 27.07.2017
 */
(function () {
  'use strict';

  angular.module('Monitour.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 27.07.2017
 */
(function () {
  'use strict';

  angular.module('Monitour.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('Monitour.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 27.07.2017
 */
(function () {
  'use strict';

  angular.module('Monitour.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 27.07.2017
 */
(function () {
  'use strict';

  angular.module('Monitour.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html'
    };
  }

})();
/**
 * @author monitour
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('Monitour.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

/**
 * @author monitour
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('Monitour.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author monitour
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('Monitour.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author monitour
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('Monitour.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('Monitour.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author monitour
 * created on 27.07.2017
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.charts.amCharts')
      .controller('AreaChartCtrl', AreaChartCtrl);

  /** @ngInject */
  function AreaChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var areaChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      dataProvider: [
        {
          lineColor: layoutColors.info,
          date: '2012-01-01',
          duration: 408
        },
        {
          date: '2012-01-02',
          duration: 482
        },
        {
          date: '2012-01-03',
          duration: 562
        },
        {
          date: '2012-01-04',
          duration: 379
        },
        {
          lineColor: layoutColors.warning,
          date: '2012-01-05',
          duration: 501
        },
        {
          date: '2012-01-06',
          duration: 443
        },
        {
          date: '2012-01-07',
          duration: 405
        },
        {
          date: '2012-01-08',
          duration: 309,
          lineColor: layoutColors.danger
        },
        {
          date: '2012-01-09',
          duration: 287
        },
        {
          date: '2012-01-10',
          duration: 485
        },
        {
          date: '2012-01-11',
          duration: 890
        },
        {
          date: '2012-01-12',
          duration: 810
        }
      ],
      balloon: {
        cornerRadius: 6,
        horizontalPadding: 15,
        verticalPadding: 10
      },
      valueAxes: [
        {
          duration: 'mm',
          durationUnits: {
            hh: 'h ',
            mm: 'min'
          },
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      graphs: [
        {
          bullet: 'square',
          bulletBorderAlpha: 1,
          bulletBorderThickness: 1,
          fillAlphas: 0.5,
          fillColorsField: 'lineColor',
          legendValueText: '[[value]]',
          lineColorField: 'lineColor',
          title: 'duration',
          valueField: 'duration'
        }
      ],

      chartCursor: {
        categoryBalloonDateFormat: 'YYYY MMM DD',
        cursorAlpha: 0,
        fullWidth: true
      },
      dataDateFormat: 'YYYY-MM-DD',
      categoryField: 'date',
      categoryAxis: {
        dateFormats: [
          {
            period: 'DD',
            format: 'DD'
          },
          {
            period: 'WW',
            format: 'MMM DD'
          },
          {
            period: 'MM',
            format: 'MMM'
          },
          {
            period: 'YYYY',
            format: 'YYYY'
          }
        ],
        parseDates: true,
        autoGridCount: false,
        gridCount: 50,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      pathToImages: layoutPaths.images.amChart
    });

    areaChart.addListener('dataUpdated', zoomAreaChart);

    function zoomAreaChart() {
      areaChart.zoomToDates(new Date(2012, 0, 3), new Date(2012, 0, 11));
    }
  }

})();

/**
 * @author monitour
 * created on 27.07.2017
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.charts.amCharts')
      .controller('BarChartCtrl', BarChartCtrl);

  /** @ngInject */
  function BarChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var barChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      dataProvider: [
        {
          country: 'USA',
          visits: 3025,
          color: layoutColors.primary
        },
        {
          country: 'China',
          visits: 1882,
          color: layoutColors.danger

        },
        {
          country: 'Japan',
          visits: 1809,
          color: layoutColors.info
        },
        {
          country: 'Germany',
          visits: 1322,
          color: layoutColors.success
        },
        {
          country: 'UK',
          visits: 1122,
          color: layoutColors.warning
        },
        {
          country: 'France',
          visits: 1114,
          color: layoutColors.primaryLight
        }
      ],
      valueAxes: [
        {
          axisAlpha: 0,
          position: 'left',
          title: 'Visitors from country',
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      startDuration: 1,
      graphs: [
        {
          balloonText: '<b>[[category]]: [[value]]</b>',
          fillColorsField: 'color',
          fillAlphas: 0.7,
          lineAlpha: 0.2,
          type: 'column',
          valueField: 'visits'
        }
      ],
      chartCursor: {
        categoryBalloonEnabled: false,
        cursorAlpha: 0,
        zoomable: false
      },
      categoryField: 'country',
      categoryAxis: {
        gridPosition: 'start',
        labelRotation: 45,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      creditsPosition: 'top-right',
      pathToImages: layoutPaths.images.amChart
    });
  }
})();

/**
 * @author monitour
 * created on 27.07.2017
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.charts.amCharts')
      .controller('FunnelChartCtrl', FunnelChartCtrl);

  /** @ngInject */
  function FunnelChartCtrl($scope, $element, layoutPaths, baConfig) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var funnelChart = AmCharts.makeChart(id, {
      type: 'funnel',
      theme: 'blur',
      color: layoutColors.defaultText,
      labelTickColor: layoutColors.borderDark,
      dataProvider: [
        {
          title: 'Website visits',
          value: 300
        },
        {
          title: 'Downloads',
          value: 123
        },
        {
          title: 'Requested prices',
          value: 98
        },
        {
          title: 'Contaced',
          value: 72
        },
        {
          title: 'Purchased',
          value: 35
        },
        {
          title: 'Asked for support',
          value: 25
        },
        {
          title: 'Purchased more',
          value: 18
        }
      ],
      titleField: 'title',
      marginRight: 160,
      marginLeft: 15,
      labelPosition: 'right',
      funnelAlpha: 0.9,
      valueField: 'value',
      startX: 0,
      alpha: 0.8,
      neckWidth: '0%',
      startAlpha: 0,
      outlineThickness: 1,
      neckHeight: '0%',
      balloonText: '[[title]]:<b>[[value]]</b>',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-left',
      pathToImages: layoutPaths
    });
  }
})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.charts.amCharts')
    .controller('combinedChartCtrl', combinedChartCtrl);

  /** @ngInject */
  function combinedChartCtrl($element, baConfig, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var chart = AmCharts.makeChart(id, {
      "type": "serial",
      "theme": "none",
      "color": layoutColors.defaultText,
      "dataDateFormat": "YYYY-MM-DD",
      "precision": 2,
      "valueAxes": [{
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText,
        gridColor: layoutColors.defaultText,
        "id": "v1",
        "title": "Sales",
        "position": "left",
        "autoGridCount": false,
        "labelFunction": function(value) {
          return "$" + Math.round(value) + "M";
        }
      }, {
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText,
        gridColor: layoutColors.defaultText,
        "id": "v2",
        "title": "Market Days",
        "gridAlpha": 0,
        "position": "right",
        "autoGridCount": false
      }],
      "graphs": [{
        "id": "g3",
        color: layoutColors.defaultText,
        "valueAxis": "v1",
        "lineColor": layoutColors.primaryLight,
        "fillColors": layoutColors.primaryLight,
        "fillAlphas": 0.8,
        "lineAlpha": 0.8,
        "type": "column",
        "title": "Actual Sales",
        "valueField": "sales2",
        "clustered": false,
        "columnWidth": 0.5,
        "lineColorField" : layoutColors.defaultText,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g4",
        "valueAxis": "v1",
        color: layoutColors.defaultText,
        "lineColor": layoutColors.primary,
        "fillColors": layoutColors.primary,
        "fillAlphas": 0.9,
        "lineAlpha": 0.9,
        "type": "column",
        "title": "Target Sales",
        "valueField": "sales1",
        "clustered": false,
        "columnWidth": 0.3,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g1",
        "valueAxis": "v2",
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": layoutColors.defaultText,
        color: layoutColors.defaultText,
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": layoutColors.danger,
        "type": "smoothedLine",
        "title": "Market Days",
        "useLineColorForBulletBorder": true,
        "valueField": "market1",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
      }, {
        "id": "g2",
        "valueAxis": "v2",
        color: layoutColors.defaultText,
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": layoutColors.defaultText,
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": layoutColors.warning,
        "type": "smoothedLine",
        "dashLength": 5,
        "title": "Market Days ALL",
        "useLineColorForBulletBorder": true,
        "valueField": "market2",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
      }],
      "chartScrollbar": {
        "graph": "g1",
        "oppositeAxis": false,
        "offset": 30,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        scrollbarHeight: 50,
        backgroundAlpha: 0,
        selectedBackgroundAlpha: 0.05,
        selectedBackgroundColor: layoutColors.defaultText,
        graphFillAlpha: 0,
        autoGridCount: true,
        selectedGraphFillAlpha: 0,
        graphLineAlpha: 0.2,
        selectedGraphLineColor: layoutColors.defaultText,
        selectedGraphLineAlpha: 1
      },
      "chartCursor": {
        "pan": true,
        "cursorColor" : layoutColors.danger,
        "valueLineEnabled": true,
        "valueLineBalloonEnabled": true,
        "cursorAlpha": 0,
        "valueLineAlpha": 0.2
      },
      "categoryField": "date",
      "categoryAxis": {
        "axisColor": layoutColors.defaultText,
        "color": layoutColors.defaultText,
        "gridColor": layoutColors.defaultText,
        "parseDates": true,
        "dashLength": 1,
        "minorGridEnabled": true
      },
      "legend": {
        "useGraphSettings": true,
        "position": "top",
        "color": layoutColors.defaultText
      },
      "balloon": {
        "borderThickness": 1,
        "shadowAlpha": 0
      },
      "export": {
        "enabled": true
      },
      "dataProvider": [{
        "date": "2013-01-16",
        "market1": 71,
        "market2": 75,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-17",
        "market1": 74,
        "market2": 78,
        "sales1": 4,
        "sales2": 6
      }, {
        "date": "2013-01-18",
        "market1": 78,
        "market2": 88,
        "sales1": 5,
        "sales2": 2
      }, {
        "date": "2013-01-19",
        "market1": 85,
        "market2": 89,
        "sales1": 8,
        "sales2": 9
      }, {
        "date": "2013-01-20",
        "market1": 82,
        "market2": 89,
        "sales1": 9,
        "sales2": 6
      }, {
        "date": "2013-01-21",
        "market1": 83,
        "market2": 85,
        "sales1": 3,
        "sales2": 5
      }, {
        "date": "2013-01-22",
        "market1": 88,
        "market2": 92,
        "sales1": 5,
        "sales2": 7
      }, {
        "date": "2013-01-23",
        "market1": 85,
        "market2": 90,
        "sales1": 7,
        "sales2": 6
      }, {
        "date": "2013-01-24",
        "market1": 85,
        "market2": 91,
        "sales1": 9,
        "sales2": 5
      }, {
        "date": "2013-01-25",
        "market1": 80,
        "market2": 84,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-26",
        "market1": 87,
        "market2": 92,
        "sales1": 4,
        "sales2": 8
      }, {
        "date": "2013-01-27",
        "market1": 84,
        "market2": 87,
        "sales1": 3,
        "sales2": 4
      }, {
        "date": "2013-01-28",
        "market1": 83,
        "market2": 88,
        "sales1": 5,
        "sales2": 7
      }, {
        "date": "2013-01-29",
        "market1": 84,
        "market2": 87,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-30",
        "market1": 81,
        "market2": 85,
        "sales1": 4,
        "sales2": 7
      }],
      pathToImages: layoutPaths.images.amChart
    });
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.charts.amCharts')
    .controller('ganttChartCtrl', ganttChartCtrl);

  /** @ngInject */
  function ganttChartCtrl($element) {
    var id = $element[0].getAttribute('id');
    var chart = AmCharts.makeChart( id, {
      "type": "gantt",
      "theme": "light",
      "marginRight": 70,
      "period": "hh",
      "dataDateFormat":"YYYY-MM-DD",
      "balloonDateFormat": "JJ:NN",
      "columnWidth": 0.5,
      "valueAxis": {
        "type": "date",
        "minimum": 7,
        "maximum": 31
      },
      "brightnessStep": 10,
      "graph": {
        "fillAlphas": 1,
        "balloonText": "<b>[[task]]</b>: [[open]] [[value]]"
      },
      "rotate": true,
      "categoryField": "category",
      "segmentsField": "segments",
      "colorField": "color",
      "startDate": "2015-01-01",
      "startField": "start",
      "endField": "end",
      "durationField": "duration",
      "dataProvider": [
        {
        "category": "John",
        "segments": [ {
          "start": 7,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Smith",
        "segments": [ {
          "start": 10,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Ben",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Mike",
        "segments": [ {
          "start": 9,
          "duration": 6,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 4,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Lenny",
        "segments": [ {
          "start": 8,
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Scott",
        "segments": [ {
          "start": 15,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Julia",
        "segments": [ {
          "start": 9,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 1,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 8,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Bob",
        "segments": [ {
          "start": 9,
          "duration": 8,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 7,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Kendra",
        "segments": [ {
          "start": 11,
          "duration": 8,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Tom",
        "segments": [ {
          "start": 9,
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 5,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Kyle",
        "segments": [ {
          "start": 6,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Anita",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Jack",
        "segments": [ {
          "start": 8,
          "duration": 10,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Kim",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 3,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Aaron",
        "segments": [ {
          "start": 18,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Alan",
        "segments": [ {
          "start": 17,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Ruth",
        "segments": [ {
          "start": 13,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Simon",
        "segments": [ {
          "start": 10,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 17,
          "duration": 4,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      } ],
      "valueScrollbar": {
        "autoGridCount":true
      },
      "chartCursor": {
        "cursorColor":"#55bb76",
        "valueBalloonsEnabled": false,
        "cursorAlpha": 0,
        "valueLineAlpha":0.5,
        "valueLineBalloonEnabled": true,
        "valueLineEnabled": true,
        "zoomable":false,
        "valueZoomable":true
      },
      "export": {
        "enabled": true
      }
    });
  }

})();

/**
 * @author monitour
 * created on 27.07.2017
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.charts.amCharts')
      .controller('LineChartCtrl', LineChartCtrl);

  /** @ngInject */
  function LineChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var lineChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      marginTop: 0,
      marginRight: 15,
      dataProvider: [
        {
          year: '1990',
          value: -0.17
        },
        {
          year: '1991',
          value: -0.254
        },
        {
          year: '1992',
          value: 0.019
        },
        {
          year: '1993',
          value: -0.063
        },
        {
          year: '1994',
          value: 0.005
        },
        {
          year: '1995',
          value: 0.077
        },
        {
          year: '1996',
          value: 0.12
        },
        {
          year: '1997',
          value: 0.011
        },
        {
          year: '1998',
          value: 0.177
        },
        {
          year: '1999',
          value: -0.021
        },
        {
          year: '2000',
          value: -0.037
        },
        {
          year: '2001',
          value: 0.03
        },
        {
          year: '2002',
          value: 0.179
        },
        {
          year: '2003',
          value: 0.2
        },
        {
          year: '2004',
          value: 0.180
        },
        {
          year: '2005',
          value: 0.21
        }
      ],
      valueAxes: [
        {
          axisAlpha: 0,
          position: 'left',
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      graphs: [
        {
          id: 'g1',
          balloonText: '[[value]]',
          bullet: 'round',
          bulletSize: 8,
          lineColor: layoutColors.danger,
          lineThickness: 1,
          negativeLineColor: layoutColors.warning,
          type: 'smoothedLine',
          valueField: 'value'
        }
      ],
      chartScrollbar: {
        graph: 'g1',
        gridAlpha: 0,
        color: layoutColors.defaultText,
        scrollbarHeight: 55,
        backgroundAlpha: 0,
        selectedBackgroundAlpha: 0.05,
        selectedBackgroundColor: layoutColors.defaultText,
        graphFillAlpha: 0,
        autoGridCount: true,
        selectedGraphFillAlpha: 0,
        graphLineAlpha: 0.2,
        selectedGraphLineColor: layoutColors.defaultText,
        selectedGraphLineAlpha: 1
      },
      chartCursor: {
        categoryBalloonDateFormat: 'YYYY',
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5,
        fullWidth: true
      },
      dataDateFormat: 'YYYY',
      categoryField: 'year',
      categoryAxis: {
        minPeriod: 'YYYY',
        parseDates: true,
        minorGridAlpha: 0.1,
        minorGridEnabled: true,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });

    lineChart.addListener('rendered', zoomChart);
    if (lineChart.zoomChart) {
      lineChart.zoomChart();
    }

    function zoomChart() {
      lineChart.zoomToIndexes(Math.round(lineChart.dataProvider.length * 0.4), Math.round(lineChart.dataProvider.length * 0.55));
    }
  }

})();

/**
 * @author monitour
 * created on 27.07.2017
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.charts.amCharts')
      .controller('PieChartCtrl', PieChartCtrl);

  /** @ngInject */
  function PieChartCtrl($element, layoutPaths, baConfig) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var pieChart = AmCharts.makeChart(id, {
      type: 'pie',
      startDuration: 0,
      theme: 'blur',
      addClassNames: true,
      color: layoutColors.defaultText,
      labelTickColor: layoutColors.borderDark,
      legend: {
        position: 'right',
        marginRight: 100,
        autoMargins: false,
      },
      innerRadius: '40%',
      defs: {
        filter: [
          {
            id: 'shadow',
            width: '200%',
            height: '200%',
            feOffset: {
              result: 'offOut',
              in: 'SourceAlpha',
              dx: 0,
              dy: 0
            },
            feGaussianBlur: {
              result: 'blurOut',
              in: 'offOut',
              stdDeviation: 5
            },
            feBlend: {
              in: 'SourceGraphic',
              in2: 'blurOut',
              mode: 'normal'
            }
          }
        ]
      },
      dataProvider: [
        {
          country: 'Lithuania',
          litres: 501.9
        },
        {
          country: 'Czech Republic',
          litres: 301.9
        },
        {
          country: 'Ireland',
          litres: 201.1
        },
        {
          country: 'Germany',
          litres: 165.8
        },
        {
          country: 'Australia',
          litres: 139.9
        },
        {
          country: 'Austria',
          litres: 128.3
        },
        {
          country: 'UK',
          litres: 99
        },
        {
          country: 'Belgium',
          litres: 60
        }
      ],
      valueField: 'litres',
      titleField: 'country',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-left',

      autoMargins: false,
      marginTop: 10,
      alpha: 0.8,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
      pullOutRadius: 0,
      pathToImages: layoutPaths.images.amChart,
      responsive: {
        enabled: true,
        rules: [
          // at 900px wide, we hide legend
          {
            maxWidth: 900,
            overrides: {
              legend: {
                enabled: false
              }
            }
          },

          // at 200 px we hide value axis labels altogether
          {
            maxWidth: 200,
            overrides: {
              valueAxes: {
                labelsEnabled: false
              },
              marginTop: 30,
              marginBottom: 30,
              marginLeft: 30,
              marginRight: 30
            }
          }
        ]
      }
    });

    pieChart.addListener('init', handleInit);

    pieChart.addListener('rollOverSlice', function (e) {
      handleRollOver(e);
    });

    function handleInit() {
      pieChart.legend.addListener('rollOverItem', handleRollOver);
    }

    function handleRollOver(e) {
      var wedge = e.dataItem.wedge.node;
      wedge.parentNode.appendChild(wedge);
    }
  }

})();


(function () {
    'use strict';

    angular.module('Monitour.pages.sites')
        .directive('sitesList', sitesList);

    /** @ngInject */
    function sitesList() {
        return {
            restrict: 'EA',
            controller: 'sitesListCtrl',
            templateUrl: 'app/pages/sites/list/sitesList/sitesList.html'
        };
    }
})();

(function () {
    'use strict';

    angular.module('Monitour.pages.sites')
        .directive('sitesFilter', sitesFilter);

    /** @ngInject */
    function sitesFilter() {
        return {
            restrict: 'EA',
            controller: 'sitesListCtrl',
            templateUrl: 'app/pages/sites/list/sitesFilter/sitesFilter.html'
        };
    }
})();

(function () {
    'use strict';

    angular.module('Monitour.pages.user')
        .directive('userFilter', userFilter);

    /** @ngInject */
    function userFilter() {
        return {
            restrict: 'EA',
            controller: 'userListCtrl',
            templateUrl: 'app/pages/user/list/filter/userFilter.html'
        };
    }
})();

(function () {
    'use strict';

    angular.module('Monitour.pages.user')
        .directive('userList', userList);

    /** @ngInject */
    function userList() {
        return {
            restrict: 'EA',
            controller: 'userListCtrl',
            templateUrl: 'app/pages/user/list/list/userList.html'
        };
    }
})();
/**
 * @author monitour
 * created on 27.07.2017
 */
(function () {
  'use strict';

  angular.module('Monitour.pages.ui.modals')
      .controller('NotificationsCtrl', NotificationsCtrl);

  /** @ngInject */
  function NotificationsCtrl($scope, toastr) {
    $scope.showSuccessMsg = function() {
      toastr.success('Your information has been saved successfully!');
    };

    $scope.showInfoMsg = function() {
      toastr.info("You've got a new email!", 'Information');
    };

    $scope.showErrorMsg = function() {
      toastr.error("Your information hasn't been saved!", 'Error');
    };

    $scope.showWarningMsg = function() {
      toastr.warning('Your computer is about to explode!', 'Warning');
    };
  }

})();

/**
 * Created by n.poltoratsky
 * on 24.06.2016.
 */
(function () {
    'use strict';

    angular.module('Monitour.pages.ui.modals')
        .controller('ProgressModalCtrl', ProgressModalCtrl);

    function ProgressModalCtrl($timeout, baProgressModal) {

        baProgressModal.setProgress(0);

        (function changeValue() {
            if (baProgressModal.getProgress() >= 100) {
                baProgressModal.close();
            } else {
                baProgressModal.setProgress(baProgressModal.getProgress() + 10);
                $timeout(changeValue, 300);
            }
        })();
    }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module('Monitour').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/common/messages.html','<div class="messages"><div ng-message="required">Required</div><div ng-message="minlength">Too short</div><div ng-message="maxlength">Too long</div><div ng-message="email">Invalid email address</div><div ng-message="compareTo">Must match the previous entry</div></div>');
$templateCache.put('app/pages/dashboard/dashboard.html','<div class="dashboard"><dashboard-welcome></dashboard-welcome></div>');
$templateCache.put('app/pages/login/login.html','<div class="login" ng-controller="loginCtrl as vm"><div class="col-lg-12 col-md-12 col-sm-12 second"><div class="unauthorized-left"><div class="unauthorized-logo-wrapper"><img src="../../../assets/img/theme/white-logo.png" alt=""></div><div class="unauthorized-right"><div class="unauthorized-container"><div class="unauthorized-form"><h3>Login To Your Account</h3><form class="form-horizontal" ng-submit="vm.login()"><div class="form-item"><input type="email" ng-model="vm.username" id="inputEmail3" placeholder="Email"></div><div class="form-item"><input type="password" ng-model="vm.password" id="inputPassword3" placeholder="Password"></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12"><button type="submit" class="button btn btn-default btn-auth margin">Sign in</button></div><div class="col-lg-12 col-md-12 col-sm-12"><a ui-sref="password" class="form-link margin">Forgot password?</a></div></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12"><button ui-sref="register" type="submit" class="button btn btn-default btn-reg margin">Sign up here</button></div></div></form></div></div></div></div></div></div>');
$templateCache.put('app/pages/invoices/invoices.html','<ui-view><div class="billing-page" ng-controller="InvoicesCtrl"><div class="billing-inner"><div class="billing-inner"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left billing-panel"><div class="billing-body"><div class="panel-content"><div class="header">Invoice History</div><div class="row"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="container group invoices-page"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="vm.smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table st-table="vm.displayedInvoices" st-safe-src="vm.invoices" class="table table-striped"><thead><tr class="sortable"><th st-sort="id" st-sort-default="reverse">Invoice #</th><th st-sort="date">Invoice Date</th><th st-sort="expires">Due date</th><th st-sort="amount">Total</th><th st-sort="status">Status</th></tr><tr><th></th><th><input st-search="date" placeholder="Search Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="expires" placeholder="Search Due date" class="input-sm form-control search-input" type="search"></th><th><input st-search="amount" placeholder="Search amount" class="input-sm form-control search-input" type="search"></th><th><input st-search="status" placeholder="Search Status" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="invoice in vm.displayedInvoices"><td class="table-id">{{invoice.id}}</td><td>{{invoice.date | date:\'dd/MM/yyyy\' }}</td><td>{{invoice.expires | date:\'dd/MM/yyyy\' }}</td><td>${{invoice.amount}}</td><td><span ng-if="invoice.status == \'false\'"><a class="btn" type="button" ui-sref="main.invoices.view({id: invoice.id})"><span class="textred">Unpaid</span></a></span> <span ng-if="invoice.status == \'true\'"><a class="btn" type="button" ui-sref="main.payments.view({id: invoice.id})"><span class="textgreen">Paid</span></a></span></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><st-pagination st-items-by-page="vm.smartTablePageSize" st-displayed-pages="7"></st-pagination></td></tr></tfoot></table></div></div></div></div></div></div></div></div></div></div></div></ui-view>');
$templateCache.put('app/pages/mobile/mobile.html','<ui-view><div ba-panel="" ba-panel-class="profile-page" ng-controller="MobilePageCtrl as vm"><div class="panel-content"><div class="header">App Information</div><div class="row"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="container group"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 tiles"><div class="tile"><div class="row"><div class="plan"><div class="col-xlg-9 col-lg-9 col-md-9 col-sm-12 col-xs-12"><div class="dashboard-policy-detail" bis_skin_checked="1"><p ng-if="vm.details.productName"><span class="plan-title">{{vm.details.productName }}</span> <span class="plan">Plan</span></p><dl class="ng-scope"><dt class="heading">Purchased Number</dt><dd class="ng-binding">{{ vm.details.phoneNumber}}</dd></dl><dl class="ng-scope"><dt class="heading">App Logins</dt><dd class="ng-binding">Username: {{ vm.details.phoneUsername}} Password: {{ vm.details.phoneTelnyxPassword}}</dd></dl><dl class="ng-scope"><dt class="heading">Expiry</dt><dd class="ng-binding">{{ vm.details.subscriptionExpiryDate | date:\'dd/MM/yyyy\'}}</dd></dl></div></div></div></div></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 tiles"><div class="tile"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><a href="https://apps.apple.com/au/app/callio/id6472964006"><img src="../../../assets/img/kisspng-app-store-apple-download-logo-app-store-5b500d8b7184c1.543642341531973003465.png" width="200px" alt=""></a></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><a href="https://play.google.com/store/apps/details?id=com.callio.webrtc.sdk"><img src="../../../assets/img/google-play-download-android-app-logo-png-transparent.png" width="200px" alt=""></a></div></div></div></div></div></div></div></div></div></ui-view>');
$templateCache.put('app/pages/password/confirm-password.html','<div class="password" ng-controller="confirmCtrl as vm"><div class="col-lg-12 col-md-12 col-sm-12"><div class="unauthorized-left"><div class="unauthorized-logo-wrapper"><img src="../../../assets/img/theme/white-logo.png" alt=""></div><div class="unauthorized-right"><div class="unauthorized-container"><div class="unauthorized-form"><h2>Forgotten your password?</h2><p>To reset your password, enter the email address you use to login to Callio. A link will be emailed to this address which will let you reset your password.</p><form name="passwordForm" class="form-horizontal" ng-submit="vm.resetPassword()"><div class="form-group"><input type="pass" class="form-control" ng-model="vm.password" placeholder="Password" autocomplete="false" name="pass" required="required" ng-minlength="6"><div ng-if="passwordForm.pass.$touched || signupSubmitted"><p ng-show="passwordForm.pass.$error.required" class="help-block">Password is required</p><p ng-show="passwordForm.pass.$error.minlength" class="help-block">Minimum 6 character</p></div></div><div class="form-group"><input type="pass" class="form-control" name="confirm_password" autocomplete="false" ng-model="vm.confirm_password" placeholder="Confirm password" match-password="vm.password" required=""><div ng-if="passwordForm.confirm_password.$touched || signupSubmitted"><p ng-show="passwordForm.confirm_password.$error.required" class="help-block">Confirm password is required</p><p ng-show="passwordForm.confirm_password.$error.matchPassword && !passwordForm.confirm_password.$error.required" class="help-block">Confirm password didn\'t match</p></div></div><div class="actions"><div class="onLeft" id="submitButton"><button type="submit" class="btn btn-primary btn-block btn-sm">Retrieve Password</button></div><div class="onLeft btnHeight"><span>or</span> <a href="/">Cancel</a></div></div></form></div></div></div></div></div></div>');
$templateCache.put('app/pages/password/password.html','<div class="password" ng-controller="passwordCtrl as vm"><div class="col-lg-12 col-md-12 col-sm-12"><div class="unauthorized-left"><div class="unauthorized-logo-wrapper"><img src="../../../assets/img/theme/white-logo.png" alt=""></div><div class="unauthorized-right"><div class="unauthorized-container"><div class="unauthorized-form"><h3>Recover Your Password</h3><p>Please enter your e-mail address and choose a new password. You will receive an e-mail with a link to continue the procedure.</p><form class="form-horizontal" ng-submit="vm.forgot()"><div class="form-item"><input type="text" ng-model="vm.email" placeholder="Email address"></div><button type="submit" class="button btn btn-default btn-auth">Retrieve Passowrd</button> <a ui-sref="login" class="form-link">Cancel</a></form></div></div></div></div></div></div>');
$templateCache.put('app/pages/password/pin.html','<div class="password" ng-controller="pinCtrl as vm"><div class="col-lg-12 col-md-12 col-sm-12"><div class="unauthorized-left"><div class="unauthorized-logo-wrapper"><img src="../../../assets/img/theme/white-logo.png" alt=""></div><div class="unauthorized-right"><div class="unauthorized-container"><div class="unauthorized-form"><h3>Recover your password</h3><p>Please enter the pin that was sent to you via sms and email</p><form class="form-horizontal" ng-submit="vm.pinnumber()"><div class="form-item"><input type="text" ng-model="vm.pin" placeholder="Pin Number"></div><button type="submit" class="button btn btn-default btn-auth">Retrieve Passowrd</button> <a ui-sref="authSignIn" class="form-link">Cancel</a></form></div></div></div></div></div></div>');
$templateCache.put('app/pages/password/success.html','<div class="password" ng-controller="authConfirmCtrl as vm"><div class="x-header"><div class="inner"><h1><a href="http://www.xero.com" class="logo" accesskey="1"><span class="hidden">Logo: Xero - Back to home</span></a><span>Beautiful accounting software</span></h1></div></div><main class="auth-main"><div class="password-page"><div class="col-lg-12 col-md-12 col-sm-12"><div class="inner"><div class="x-boxed noBorder"><h2>Forgotten your password?</h2><p>To reset your password, enter the email address you use to login to Xero. A link will be emailed to this address which will let you reset your password.</p></div><div id="submitForm" class="x-boxed"><form name="passwordForm" class="form-horizontal" ng-submit="vm.password()"><div class="form-group"><input type="password" class="form-control" ng-model="vm.password" placeholder="Password" name="password" required="required" ng-minlength="6"><div ng-if="passwordForm.password.$touched || signupSubmitted"><p ng-show="passwordForm.password.$error.required" class="help-block">Password is required</p><p ng-show="passwordForm.password.$error.minlength" class="help-block">Minimum 6 character</p></div></div><div class="form-group"><input type="password" class="form-control" name="confirm_password" ng-model="vm.confirm_password" placeholder="Confirm password" match-password="password" required=""><div ng-if="passwordForm.confirm_password.$touched || signupSubmitted"><p ng-show="passwordForm.confirm_password.$error.required" class="help-block">Confirm password is required</p><p ng-show="passwordForm.confirm_password.$error.matchPassword && !passwordForm.confirm_password.$error.required" class="help-block">Confirm password didn\'t match</p></div></div><div class="actions"><div class="onLeft" id="submitButton"><button type="submit" class="btn btn-primary btn-block btn-sm">Retrieve Passowrd</button></div><div class="onLeft btnHeight"><span>or</span> <a href="/">Cancel</a></div></div></form></div></div></div></div></main><div class="x-footer"><div class="inner"><p class="center try-xero">Don\'t have a password? <a ui-sref="authSignUp" class="auth-link">Sign up for a account!</a></p><p class="center"><a href="https://status.xero.com/">System&nbsp;status</a> <a href="https://www.xero.com/blog/security-noticeboard/">Security&nbsp;noticeboard</a> <a href="https://www.xero.com/about/terms">Terms&nbsp;of&nbsp;use</a> <a href="https://www.xero.com/about/privacy">Privacy</a></p></div></div></div>');
$templateCache.put('app/pages/payments/payments.html','<ui-view><div class="billing-page" ng-controller="PaymentsCtrl"><div class="billing-inner"><div class="billing-inner"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left billing-panel"><div class="billing-body"><div class="panel-content"><div class="header">Payment History</div><div class="row"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="container group payment-page"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="vm.smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table st-table="vm.displayedInvoices" st-safe-src="vm.invoices" class="table table-striped"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">Invoice #</th><th st-sort="date">Invoice Date</th><th st-sort="expires">Due date</th><th st-sort="amount">Total</th><th st-sort="status">Status</th></tr><tr><th></th><th><input st-search="date" placeholder="Search Date" class="input-sm form-control search-input" type="search"></th><th><input st-search="expires" placeholder="Search Due date" class="input-sm form-control search-input" type="search"></th><th><input st-search="amount" placeholder="Search amount" class="input-sm form-control search-input" type="search"></th><th><input st-search="status" placeholder="Search Status" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="invoice in vm.displayedInvoices"><td class="table-id">{{invoice.id}}</td><td>{{invoice.date | date:\'dd/MM/yyyy HH:mm:ss\' }}</td><td>{{invoice.expires | date:\'dd/MM/yyyy HH:mm:ss\' }}</td><td>${{invoice.amount}}</td><td>{{invoice.status}} <button class="btn btn-info" type="button" ui-sref="main.payments.view({id: invoice.id})" app-table-button="list"><span class="textgreen">View</span></button></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><st-pagination st-items-by-page="vm.smartTablePageSize" st-displayed-pages="7"></st-pagination></td></tr></tfoot></table></div></div></div></div></div></div></div></div></div></div></div></ui-view>');
$templateCache.put('app/pages/main/main.html','<div class="body-bg"></div><main ng-if="$pageFinishedLoading" ng-class="{ \'menu-collapsed\': $baSidebarService.isMenuCollapsed() }"><ba-sidebar></ba-sidebar><page-top></page-top><div class="al-main"><div ui-view="" autoscroll="true" autoscroll-body-top=""></div></div><back-top></back-top></main><div id="preloader" ng-show="!$pageFinishedLoading"><div></div></div>');
$templateCache.put('app/pages/profile/profile.html','<ui-view><div ba-panel="" ba-panel-class="profile-page" ng-controller="ProfilePageCtrl as vm"><div class="panel-content"><div class="header">General Information</div><div class="row"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="container group"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 tiles"><div class="tile"><div class="row"><div class="plan"><div class="col-xlg-9 col-lg-9 col-md-9 col-sm-12 col-xs-12"><p ng-if="vm.details.productName"><span class="plan-title">{{vm.details.productName }}</span> <span class="plan">Plan</span></p></div><div class="col-xlg-3 col-lg-3 col-md-3 col-sm-12 col-xs-12"><p class="price" ng-if="vm.details.productPrice"><strong>${{vm.details.productPrice}}</strong><span>/{{vm.details.productPlan}}<br>Incl GST</span></p></div></div></div><div class="row"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><h5>{{vm.days}} Days left of your plan {{vm.invoice.date | date:\'dd-MM-yyyy\'}}</h5><ion-slider type="single" grid="false" min="slider.min" max="slider.max" postfix="Days Left" from="slider.from" disable="true"></ion-slider></div></div><div class="row auto-renewal"><div class="col-xlg-8 col-lg-8 col-md-8 col-sm-12 col-xs-12"><h3>Enable Auto Renewal</h3><p>This option if checked, will renew your Callio Subscription once expires</p></div><div class="col-xlg-4 col-lg-4 col-md-4 col-sm-12 col-xs-12"><ba-switcher switcher-style="primary" switcher-value="vm.details.recurring"></ba-switcher></div></div><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><div class="renewal"><button ui-sref="main.profile.plans" class="btn btn-primary">Change Your Plan</button></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"><div class="renewal pull-right"><button ng-click="unsubscribe()" class="btn btn-danger">Unsubscribe</button></div></div></div></div></div><form name="form" ng-submit="vm.Update()" role="form"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 tiles"><div class="tile"><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{ \'has-error\': form.firstname.$dirty && form.firstname.$error.required }"><label for="firstname">First Name</label> <input ng-if="vm.details.firstname" type="text" name="firstname" id="firstname" class="form-control" ng-model="vm.details.firstname" ng-attr-placeholder="vm.details.firstname" required=""> <span ng-show="form.firstname.$dirty && form.firstname.$error.required" class="help-block">User First Name is required</span></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{ \'has-error\': form.lastname.$dirty && form.lastname.$error.required }"><label for="lastname">Last Name</label> <input type="text" ng-if="vm.details.lastname" name="lastname" id="lastname" class="form-control" ng-model="vm.details.lastname" ng-attr-placeholder="vm.details.lastname" required=""> <span ng-show="form.lastname.$dirty && form.lastname.$error.required" class="help-block">User Last Name is required</span></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{ \'has-error\': form.email.$dirty && form.email.$error.required }"><label for="email">Email</label> <input type="text" ng-if="vm.details.email" name="email" id="email" class="form-control" ng-model="vm.details.email" ng-attr-placeholder="vm.details.email" required=""> <span ng-show="form.email.$dirty && form.email.$error.required" class="help-block">User Email is required</span></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{ \'has-error\': form.phone.$dirty && form.phone.$error.required }"><label for="phone">Phone</label> <input type="text" ng-if="vm.details.phone" name="email" id="phone" class="form-control" ng-model="vm.details.phone" ng-attr-placeholder="vm.details.phone" required=""> <span ng-show="form.phone.$dirty && form.phone.$error.required" class="help-block">User Phone Number is required</span></div></div><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="form-group" ng-class="{ \'has-error\': form.phone.$dirty && form.phone.$error.required }"><label for="address">Your Address</label> <input vs-google-autocomplete="options" ng-model="vm.new.name" vs-street-number="vm.new.streetNumber" vs-street="vm.new.street" vs-city="vm.new.city" vs-state="vm.new.state" vs-country="vm.new.country" vs-post-code="vm.new.postcode" type="text" name="address" id="address" class="form-control" placeholder="{{vm.details.place}}"></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><label for="password">Password</label> <input type="password" class="form-control" ng-model="vm.password" placeholder="Password" name="password" ng-minlength="6"><div ng-if="passwordForm.password.$touched || signupSubmitted"><p ng-show="passwordForm.password.$error.required" class="help-block">Password is required</p><p ng-show="passwordForm.password.$error.minlength" class="help-block">Minimum 6 character</p></div></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><label for="Confirm password">Confirm password</label> <input type="password" class="form-control" name="confirm_password" ng-model="vm.confirm_password" placeholder="Confirm password" match-password="password"><div ng-if="passwordForm.confirm_password.$touched || signupSubmitted"><p ng-show="passwordForm.confirm_password.$error.required" class="help-block">Confirm password is required</p><p ng-show="passwordForm.confirm_password.$error.matchPassword && !passwordForm.confirm_password.$error.required" class="help-block">Confirm password didn\'t match</p></div></div></div><div class="form-actions pull-right"><button type="submit" ng-disabled="form.$invalid || vm.dataLoading" class="btn btn-primary">Update Profile</button> <img ng-if="vm.dataLoading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="></div></div></div></div></form></div></div></div></div></div></ui-view>');
$templateCache.put('app/pages/register/register.html','<div class="register" ng-controller="registerCtrl as vm"><div class="loading-overlay" ng-show="vm.dataLoading"><div class="spinner">Loading...</div></div><div class="col-lg-12 col-md-12 col-sm-12"><div class="unauthorized-left"><div class="unauthorized-logo-wrapper"><img src="../../../assets/img/theme/white-logo.png" alt=""></div><div class="unauthorized-container is-big"><div class="unauthorized-form"><form name="multiStepForm" class="form-validation" role="form" ng-submit="vm.register(register.$valid)" novalidate=""><div class="animate-switch-container" ng-switch="" on="stage" ng-class="{forward: direction, backward:!direction}"><div class="animate-switch" ng-switch-default=""><h3>Register your account details</h3><div class="row"><div class="col-lg-6 col-md-6 col-sm-12"><div class="form-group"><label for="ta-body">First name</label> <input type="text" class="form-control" id="tb-fname" name="firstName" ng-maxlength="250" placeholder="Enter first name" ng-model="vm.formParams.firstName" required="" ng-class="{\'input-error\': formValidation && multiStepForm.firstName.$error.required}"> <span ng-show="multiStepForm.firstName.$error.maxlength">Max character length reached.</span></div></div><div class="col-lg-6 col-md-6 col-sm-12"><div class="form-group"><label for="ta-body">Last name</label> <input type="text" class="form-control" id="tb-lname" name="lastname" placeholder="Enter last name" ng-maxlength="250" ng-model="vm.formParams.lastname" required="" ng-class="{\'input-error\': formValidation && multiStepForm.lastname.$error.required}"> <span ng-show="multiStepForm.lastname.$error.maxlength">Max character length reached.</span></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12"><div class="form-group"><label for="ta-body">Email</label> <input type="email" class="form-control" id="tb-email" name="email" ng-maxlength="100" placeholder="Enter your email" ng-model="vm.formParams.email" ng-class="{\'input-error\': formValidation && multiStepForm.email.$error.required}" ng-model-options="{ updateOn: \'blur\' }" required=""> <span ng-show="multiStepForm.email.$error.email">Incorrect email format.</span> <span ng-show="multiStepForm.email.$error.maxlength">Max character length reached.</span></div></div><div class="col-lg-6 col-md-6 col-sm-12"><div class="form-group"><label for="ta-body">Phone number</label> <input type="text" class="form-control" id="tb-lname" name="companyphone" placeholder="Enter your phone number" ng-maxlength="250" ng-model="vm.formParams.companyphone" required="" ng-class="{\'input-error\': formValidation && multiStepForm.companyphone.$error.required}"> <span ng-show="multiStepForm.companyphone.$error.maxlength">Max character length reached.</span></div></div></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12"><div class="form-group"><label for="inputWebsite">Your full address</label> <input vs-google-autocomplete="options" ng-model="vm.formParams.name" vs-place="vm.formParams.place" vs-place-id="vm.formParams.components.placeId" vs-street-number="vm.formParams.components.streetNumber" vs-street="vm.formParams.components.street" vs-city="vm.formParams.components.city" vs-state="vm.formParams.components.state" vs-country-short="vm.formParams.components.countryCode" vs-country="vm.formParams.components.country" vs-post-code="vm.formParams.components.postCode" vs-district="vm.formParams.components.district" type="text" name="address" id="address" class="form-control" placeholder="Enter your address"></div></div></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12"><div class="form-group"><label for="ta-body">State inmate is located in</label><select class="form-control selectpicker" selectpicker="" title="Select state" ng-model="vm.formParams.City" ng-options="state.City as state.Description for state in vm.states"></select></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12"><div class="form-group"><label for="ta-body">Password</label> <input type="text" class="form-control" ng-model="vm.formParams.password" placeholder="Enter your password" name="password" required="required" ng-minlength="6" ng-maxlength="12"><div ng-if="multiStepForm.password.$touched || signupSubmitted"><p ng-show="multiStepForm.password.$error.required" class="help-block">Password is required</p><p ng-show="multiStepForm.password.$error.minlength" class="help-block">Minimum 6 character</p></div></div></div><div class="col-lg-6 col-md-6 col-sm-12"><div class="form-group"><label for="ta-body">Confirm password</label> <input type="text" class="form-control" name="confirm_password" ng-model="vm.formParams.confirm_password" placeholder="Confirm your password" match-password="vm.formParams.password" required=""><div ng-if="multiStepForm.confirm_password.$touched || signupSubmitted"><p ng-show="multiStepForm.confirm_password.$error.required" class="help-block">Confirm password is required</p><p ng-show="multiStepForm.confirm_password.$error.matchPassword && !multiStepForm.confirm_password.$error.required" class="help-block">Confirm password didn\'t match</p></div></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12"><div class="form-group"><button type="button" class="btn-reg" ng-click="next(\'stage1\')">Sign up here</button></div></div><div class="col-lg-6 col-md-6 col-sm-12"><div class="form-group"><button ui-sref="login" type="submit" class="button btn btn-default btn-reg pull-right">login here</button></div></div></div></div><div class="animate-switch" ng-switch-when="stage1"><div class="row"><div class="col-lg-12 col-md-12 col-sm-12"><h3 style="text-align: center;">Choose a plan below</h3><p style="text-align: center;">There are several plans to choose from</p></div></div><div class="item"><div class="grid-1-5"><div class="space"><h2>{{\'plans.bronze\' | translate}}</h2><h3><span class="uppercase">{{\'plans.bronzeprice\' | translate}}</span></h3><p>{{\'plans.bronzesubplan\' | translate}}</p><p><strong>{{\'plans.bronzesavings\' | translate}}</strong></p><button type="button" ng-click="vm.selectPlan(1)" class="button">{{\'plans.signup\' | translate}}</button></div></div></div><div class="row"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"></div></div></div><div class="animate-switch" ng-switch-when="stage2"><div class="row"><div class="container group"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="description"><div ng-if="vm.selectedPlan"><h3 style="margin-left: 0px;">Selected Plan: {{ vm.selectedPlan.heading }}</h3></div><p><strong>{{\'purchase.username\' | translate}}</strong> {{vm.formParams.firstName}} {{vm.formParams.lastname}}</p><p><strong>{{\'purchase.subprice\' | translate}}</strong> {{vm.selectedPlan.price}}</p><p><strong>{{\'purchase.subperiod\' | translate}}</strong> From {{today | date:\'dd-MM-yyyy\'}} <span>{{\'purchase.to\' | translate}}</span> {{ vm.selectedPlan.month | date:\'dd-MM-yyyy\'}}</p></div></div><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="payment-form" name="paymentForm"><div class="radio-toggles"><input type="radio" id="option-1" name="radio-options" ng-model="vm.radioValue" value="one-time"> <label for="option-1">One-Time</label> <input type="radio" id="option-2" name="radio-options" ng-model="vm.radioValue" value="recurring" checked=""> <label for="option-2">Recurring</label><div class="slide-item"></div></div><div class="notification"><p class="notification__text">{{\'purchase.noitfypaymentdescription\' | translate}}</p></div><div class="card-type clearfix"><div class="card-type__label">{{\'purchase.carddetails\' | translate}}</div></div><div class="card-holder"><stripe-card-element on-ready="vm.handleCardReady(card)"></stripe-card-element></div><button type="submit" ng-disabled="multiStepForm.$invalid" class="button btn btn-default btn-auth">{{\'purchase.buy\' | translate}}</button> <button type="button" class="btn btn-primary" ng-click="next(\'stage1\')">Back</button><div class="payment-form__agreement">By clicking on the Buy Now button, you consent to recurring subscription payments for the particular plan you selected.</div></div></div></div></div></div><div class="animate-switch" ng-switch-when="success"><div class="success-wrap"><h2 class="confirmation-text">Thank you</h2><p>Your message has been sent.<br>You should receive a confirmation email.</p><div><button type="button" class="btn btn-success" ng-click="reset()">Send Another</button></div></div></div><div class="animate-switch" ng-switch-when="error"><div class="error-wrap"><h2 class="confirmation-text">Error</h2><p>There was an error when attempting to submit your request.<br>Please try again later.</p><p><strong>*This will always error until a web service URL is set.*</strong></p><div><button type="button" class="btn btn-danger" ng-click="reset()">Try again</button></div></div></div></div></form></div></div></div></div></div>');
$templateCache.put('app/pages/sites/sites.html','<div ui-view=""></div>');
$templateCache.put('app/pages/user/user.html','<ui-view></ui-view>');
$templateCache.put('app/pages/charts/amCharts/charts.html','<div class="widgets"><div class="row"><div class="col-lg-4 col-md-6" ba-panel="" ba-panel-title="Bar Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/barChart/barChart.html\'"></div></div><div class="col-lg-4 col-md-6" ba-panel="" ba-panel-title="Area Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/areaChart/areaChart.html\'"></div></div><div class="col-lg-4 col-md-12" ba-panel="" ba-panel-title="Line Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/lineChart/lineChart.html\'"></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Pie Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/pieChart/pieChart.html\'"></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Funnel Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/funnelChart/funnelChart.html\'"></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Combined bullet/column and line graphs with multiple value axes" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/combinedChart/combinedChart.html\'"></div></div></div></div>');
$templateCache.put('app/pages/charts/chartJs/chartJs.html','<div class="row"><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Pie" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="pie" class="chart chart-pie" chart-options="options" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Doughnut" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="doughnut" chart-options="options" class="chart chart-doughnut" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Polar" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="polar-area" class="chart chart-polar-area" chart-data="data" chart-options="options" chart-labels="labels" chart-click="changeData"></canvas></div></div></div></div><div class="row"><div class="col-md-6" ng-controller="chartJsWaveCtrl"><div ba-panel="" ba-panel-title="Animated Radar" ba-panel-class="col-eq-height"><div class="chartjs-canvas-holder-second-row"><canvas id="waveLine" class="chart chart-radar" chart-data="[data]" chart-labels="labels"></canvas></div></div></div><div class="col-md-6" ng-controller="chartJsWaveCtrl"><div ba-panel="" ba-panel-title="Animated Bars" ba-panel-class="col-eq-height"><div class="chartjs-canvas-holder-second-row"><canvas id="waveBars" class="chart chart-bar" chart-data="[data]" chart-labels="labels"></canvas></div></div></div></div><div class="row"><div class="col-lg-4 col-md-6" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Radar" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="radar" class="chart chart-radar" chart-series="series" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-lg-4 col-md-6" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Line" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="line" class="chart chart-line" chart-data="data" chart-labels="labels" chart-series="series" chart-click="changeData"></canvas></div></div></div><div class="col-lg-4 col-md-12" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Bars" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="bar" class="chart chart-bar" chart-data="data" chart-labels="labels" chart-series="series" chart-click="changeData" chart-update="updateC"></canvas></div></div></div></div>');
$templateCache.put('app/pages/charts/chartist/chartist.html','<section ng-controller="chartistCtrl" class="chartist"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Lines" ba-panel-class="with-scroll"><h5>Simple line chart</h5><div id="line-chart" class="ct-chart"></div><h5>Line chart with area</h5><div id="area-chart" class="ct-chart"></div><h5>Bi-polar line chart with area only</h5><div id="bi-chart" class="ct-chart"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Bars" ba-panel-class="with-scroll"><h5>Simple bar chart</h5><div id="simple-bar" class="ct-chart"></div><h5>Multi-line labels bar chart</h5><div id="multi-bar" class="ct-chart"></div><h5>Stacked bar chart</h5><div id="stacked-bar" class="ct-chart stacked-bar"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Pies & Donuts" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12 col-lg-4"><h5>Simple Pie</h5><div id="simple-pie" class="ct-chart"></div></div><div class="col-md-12 col-lg-4"><h5>Pie with labels</h5><div id="label-pie" class="ct-chart"></div></div><div class="col-md-12 col-lg-4"><h5>Donut</h5><div id="donut" class="ct-chart"></div></div></div></div></div></div></section>');
$templateCache.put('app/pages/charts/morris/morris.html','<section ng-controller="morrisCtrl"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Line Chart" ba-panel-class="with-scroll"><div line-chart="" line-data="lineData" line-xkey="y" line-ykeys=\'["a", "b"]\' line-labels=\'["Serie A", "Serie B"]\' line-colors="colors"></div></div></div></div><div class="row"><div class="col-md-4"><div ba-panel="" ba-panel-title="Donut" ba-panel-class="with-scroll"><div donut-chart="" donut-data="donutData" donut-colors="colors" donut-formatter=\'"currency"\'></div></div></div><div class="col-md-8"><div ba-panel="" ba-panel-title="Bar Chart" ba-panel-class="with-scroll"><div bar-chart="" bar-data="barData" bar-x="y" bar-y=\'["a", "b"]\' bar-labels=\'["Series A", "Series B"]\' bar-colors="colors"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Area Chart" ba-panel-class="with-scroll"><div area-chart="" area-data="areaData" area-xkey="y" area-ykeys=\'["a", "b"]\' %="" area-labels=\'["Serie A", "Serie B"]\' line-colors="colors"></div></div></div></div></section>');
$templateCache.put('app/pages/dashboard/blurFeed/blurFeed.html','<div class="feed-messages-container" track-width="smallContainerWidth" min-width="360"><div class="feed-message" ng-repeat="message in feed" ng-click="expandMessage(message)"><div class="message-icon" ng-if="message.type == \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"></div><div class="message-icon" ng-if="message.type != \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"> <span class="sub-photo-icon" ng-class="::message.type"></span></div><div class="text-block text-message"><div class="message-header"><span class="author">{{ ::message.author }} {{ ::message.surname}}</span></div><div class="message-content line-clamp" ng-class="{\'line-clamp-2\' : !message.expanded}"><span ng-if="message.preview">{{message.header}}</span>{{::message.text}}</div><div class="preview" ng-show="message.expanded" ng-if="message.preview"><a href="{{::message.link}}" target="_blank"><img ng-src="{{ ::( message.preview | appImage )}}"></a></div><div ng-show="message.expanded" class="message-time"><div class="post-time">{{::message.time}}</div><div class="ago-time">{{::message.ago}}</div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardMap/dashboardMap.html','<div ng-controller="DashboardMapCtrl as vm"><div class="row"><div class="col-lg-12 col-md-12 col-sm-12"><div class="col-xlg-3 col-lg-3 col-md-3 col-sm-12 col-xs-12"><div class="toolbar"><div class="filter-container"><div class="link-group"><a class="link active" href="#"><i class="fa fa-map-o"></i>Map</a> <a class="link" href="#"><i class="fa fa-list"></i>List</a></div><div class="right-filter"><div class="dropdown"><a href="" title="" class="btn-filter" dropdown-menu="ddSelectOptions" dropdown-model="ddSelectSelected" dropdown-item-label="text"><i class="fa fa-filter"></i> Last Updated</a></div><div class="dropdown"><a href="" title="" class="btn-filter ng-isolate-scope" ng-click="toggle()"><i class="fa fa-filter"></i> Filters</a></div></div><div class="col-lg-2 col-md-2 col-sm-2 pull-right"><div pageslide="" ps-open="checked"><div style="padding:20px" id="demo-right">//template for display all users<div class="content"><div class="search-bar"><input type="search" ng-model="q" placeholder="filter people..." class="search-input"></div><h3 class="nav-list__header">People</h3><div class="nav-list scroll"><ul class="nav-list__container"><li ng-repeat="people in peoples | filter:q" class="nav-list__item"><a href="#/view/{{people.name}}" ng-click="next()" class="next">{{$index+1}}. {{people.name}}</a></li></ul></div></div><h2>Hello Pageslide</h2><p>Put here whatever you want</p><div class="date-picker-map"><input date-range-picker="" id="daterange1" name="daterange1" class="form-control date-picker" type="text" ng-model="date" required=""></div><a ng-click="toggle()" class="button">Close</a></div></div></div></div></div><div class="chartjs-canvas-holder-first-row"><canvas id="doughnut" chart-options="options" height="100" width="100" class="chart chart-doughnut" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div><div class="feed-panel-home" ba-panel="" ba-panel-class="medium-panel with-scroll feed-panel"><div class="feed-messages-container" track-width="smallContainerWidth" min-width="360"><div class="feed-message" ng-repeat="message in feed" ng-click="expandMessage(message)"><div class="message-icon" ng-if="message.type == \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"></div><div class="message-icon" ng-if="message.type != \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"></div><div class="text-block text-message"><div class="message-header"><span class="author">{{ ::message.author }} {{ ::message.surname}}</span> <span class="ago-time">{{::message.ago}}</span><span class="sub-photo-icon" ng-class="::message.type"></span></div><div class="message-content line-clamp" ng-class="{\'line-clamp-2\' : !message.expanded}"><span ng-if="message.preview">{{message.header}}</span>{{::message.text}}</div><div class="preview" ng-show="message.expanded" ng-if="message.preview"><a href="{{::message.link}}" target="_blank"><img ng-src="{{ ::( message.preview | appImage )}}"></a></div><div ng-show="message.expanded" class="message-time"><div class="post-time">{{::message.time}}</div><div class="ago-time">{{::message.ago}}</div></div></div></div></div></div></div><div class="col-xlg-9 col-lg-9 col-md-9 col-sm-12"><div class="mapContainer"><leaflet lf-center="center" markers="markers" layers="layers" width="100%" height="100%"></leaflet></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardLineChart/dashboardLineChart.html','<div id="amchart"></div>');
$templateCache.put('app/pages/dashboard/dashboardPieChart/dashboardPieChart.html','<div class="row pie-charts"><div class="pie-chart-item-container" ng-repeat="chart in charts"><div ba-panel=""><div class="pie-chart-item"><div class="chart" rel="{{ ::chart.color }}" data-percent="60"><span class="percent"></span></div><div class="description"><div>{{ ::chart.description }}</div><div class="description-stats">{{ ::chart.stats }}</div></div><i class="chart-icon i-{{ ::chart.icon }}"></i></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardPayment/dashboardPayment.html','<form ng-controller="dashboardPaymentCtrl" class="payment-form" name="paymentForm"><div class="notification"><img src="data:image/png;base64,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" class="notification__icon"> <span class="notification__text">We do not store your payment data, but immediately transfer it via an encrypted channel to the payment system</span></div><div class="card-type clearfix"><div class="card-type__label">Enter your card details</div><div class="card-type__icons"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAOCAYAAABZ/o57AAAAAXNSR0IArs4c6QAABLJJREFUSA2tVk1sVFUUPue+9+ZHZ94wibWmBTL2tSCVxBjF8LOQhUsWmmriQsPCNGFDGlphYYiZBGOt2EwLJhhjUNxIohsShVaDRhMrMUGjFVDT6Q8goRqhPzOlPzPv+p335s5MBVZ6knfP7z333PNzZziWyWVIl5jqwLapWMjv/7NOFJJN2Xti0USDkS9O/H4t3uw12vHIOpH5ZX+hONHzk9EHOJONJfxEi7KdDHHZ98m6WsjfvEiU9VfZCdPyRipO8ZSQt4rLf9P0/qLQAiqiVHvEiRyKOpGf8Y3LZ3FkOtU6cDw0qa1ufE1v1HIm5Yso5xxRE9ux6EFFakQ+y7LfNNap9b3plJfrS9npaSviXGBFnzFbZyym0ZSXHjZ2BrvewLGUis9EFE3J5yadA0YnWM2Nd52eG+t6YXbhZmNZ65Oa9LIotKbddF9fUugAkBkmftGwMDiGrCyjFJurMp9+CeiGbEI78WFiJYe5Vb0hWE8ZUrCb6d/KzHvqZaC31fOqylzLLljEb5HmeU2Ux0aVSNmPG72rUh3ElBYe+iWfV94RGsFXA4U8CDTppvZg/xbRAwo++Z3oiy0ln57ytT5Q9vXpUBWubNs99bzQrPkJJKIan11vMJvv+sFtHfRZ6yaYTjHZcthXwUalOqu22j8pPRz3+tch0qCnAhvSQaCKeIexRYWuzI/NfijZr8jOGp1gmRFU7xmWKdH6MvxZOLtZ/Ca8dHshH16+GnFlM5KiUTKOg3CZ9SMiT7b0bwB6smJDpZI/KLRDqpZNRDRXXLkY2vCYsUXGN7leejTRMtBhZPU4YnMXgkRwOJnpAyD0fghMulr+fweK0dVDYobNaa11MM2K7Vo2SX+zMNXzo9jourLjUhNmSvVSuRdxXxIbAfjaYCn+xPUGv403960NpVgx5UjkS8LjLH+5XDrua/rO6BXX+vS2QP2FW5+jFEioHMDb4s1H1uKmu81m9FeQzUBfN0jYEw4SFHNXu2/MjeUfxdmH4GjJ7EXA251Y9EuivVGRJTmKBLAZ2C8WJ17GkOlqRpGIu2e0cP2Vv2B8XhyhbLYT06/j1uHbqWmqMD5ySnQCkNdKXxmkUCPr0aW5/L5XV3SpDZcIqiRSXL7NbfV2omdt9PJekQnA12Vk/HmQbYFAFk0b5ZkT8raMihBQ55iqTxKm922ij8uhSTCRm0I6uNRoQGdya4xM8K18zxUEcbBehjIX0LfPIur1VTlzJzL+kWL1vpGBZ+3Etgq/auqNASo/BJtVznG94nyZ3jM2bkvaQxrihsfPTFB611bD7A1iOPyzWvN19O4DaJ0OBBsAfN+Yz1/63vXac0EejYO7Yyn/mTsGOp8fOZfydszgxtXsoNdO0OS+GeMPh2+uHU4rhfyF36BDEvTDWO9FsR4DIyIpawBogUXt+08nH3xIHnjzzlK5VN5ZwnNYMaOIxbugPyo8kwr69I6BSnk1bUcv8i5kEjFiLdMRwQbQMw1Q/BrwWo8TvbtCjYcRIA1hh7yjjUHp5I+E5j+QyVPLZZ1bnOyexM/lCfTfbOhLny9Mdn8d0pU1k/s0avFrFf1GYHPXVWb/E5O1E97h+4meC97I/+r0H2FHmUxT7+LTAAAAAElFTkSuQmCC" class="card-type__icon card-type__icon--disabled" ng-class="{\'card-type__icon--disabled\': !isVisa()}"> <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAUCAYAAAB1aeb6AAAAAXNSR0IArs4c6QAABABJREFUSA2VlW1ollUYx3/3NqduavlSyy3TTNecLy1RyxXMhBl9iJFazrcIIjKhzH2Q8MMMkdbLB0n60AsUZUQg+EItNPBjTjBMRytCnVubiZuxTXHNbe7ud/bwPDhm7dkFF+c+53r7n/+5zrkj/kNiiDQtUB9QJ6pX1HoX/3a8o8TfkEcmxWQ4xlxngGYqaTDGdMMlFBgiek1z4S11gzp9iBHTQZ36gYFHkrb4AM+bfrtwH3dtaM6YS658TS/vRRvpSMaEcYijhde49rk6KRhHkGM8y5ts5mOzlI3gG/beIfQXo0q+T/qmilt4q4sfqam1pNMdx4h2auhjFvlSnZ7Elo95JVo3uMFEIQuvNPpHNd00A2SbJkP/h43aqWao6Ugs4JinBPBTZOEsY35VQ5r0pJAT7KA05TzGr5zUbOSPmLP8xuJQfJ3e344ckfIY4C6xR7exdI+2d1L29D5iKsKuVzNvHpSX22r22qZN0NQER48OT5KbC1MnNLLjypxhxpuu3LdMfRrajnshTwxzSS3Mtr0ufvJc2Hkj1dUPsmuXMFbDwYOwd69n6CGGYnv2wNq1sHAhXLjgffBCrF8PVVVw3CKtrbDMoouuwsYPoXm/hetgymMeqGdx3h7Or4DO03D3Yui/7gF7k2vzGzLfhnfZujWLMR5cXp4BklFbK6RGWLUKiopgyxaoqYEVK6ChwQazw+osUF0NN91yZaVAvZ03vtOurftPW1fgecZPmAuzX/WF6JU1AY0vEECX7H6VFXq0h/nz4bTIZs6Evj4o0GHbtsRYXw8nTybm4XgOHYI5sh6YCDsvLobduwUt+O4m0yn3vwBzjQ+FMsfBJdnMMXfjp9BxCq79Hrx6MsjObmW6D9m5c3D4cCJxfr40dYp0KsyYAe3tMHlyYl5WlqC/pycREwCdOQN/GFuyD0rd/RSPobcDxk6zuNR3au9Si2Vq7na4bq3MiX9FcU7OPtG/TlubtN2AwsIEtWFHYR4kgDsl4gCqvz8m93LEo6Xu6KKF7oVfbK43bpl4aWKnnWd9I43vNz6SkX9aZLRL3yWO1zwq+6Pvxvuh4TwI5HUUstkmncXsVIQEIcOjkPDUlAw+pQKQMypGEXyLRd7z5EO8xkjZT1vizAOXx5e8lCwun8ir73S6spyfWc4SigywHUYhzXSPf+J8V8HVJHafLEpM8IPqAacpj0j/TukPdyYdiWmhn2eiDTQE91SYKGxH7JhBAMH2f9Kp8bXoLA85VoncLhpRjlh4abJw8E7t/PZQWXjSue8s5ap3DVt2sEAA6F3iMwNt34TEXzLVH8vLzioEssCskxx7nbc4HlP3+x8fXVOH1AIJN2Js+E5X4i8YF+JG8v8X5UMlkwCffwoAAAAASUVORK5CYII=" class="card-type__icon card-type__icon--disabled" ng-class="{\'card-type__icon--disabled\': !isMasterCard()}"></div></div><input type="text" class="card-input card-input--full" placeholder="Card Number" ng-model="card.number" required="" card-number=""> <input type="text" class="card-input card-input--full" placeholder="Card Number" ng-model="card.holder" card-holder="" required=""><div class="card-info clearfix"><div class="card-info__date"><div class="card-info__text">validity</div><input type="text" class="card-input card-input--date" placeholder="\u041C\u041C / YY" ng-model="card.date" card-date="" required=""></div><div class="card-info__cvv"><div class="card-info__text">CVV</div><input type="text" class="card-input card-input--cvv" placeholder="CVV" ng-model="card.cvv" card-cvv="" required=""></div></div><button class="payment-form__button" ng-disabled="paymentForm.$invalid" ng-click="sendForm()">Buy Now</button><div class="payment-form__agreement">By clicking on the Buy button, you consent to recurring subscription payments. You can always cancel your subscription in the service settings.</div></form>');
$templateCache.put('app/pages/dashboard/dashboardToolbar/dashboardToolbar.html','<div class="toolbar"><div class="filter-container"><div class="link-group"><a class="link" href="#"><i class="fa fa-list"></i>List</a> <a class="link" href="#"><i class="fa fa-list"></i>Data</a> <a class="link active" href="#"><i class="fa fa-map-o"></i>Map</a> <a href="" title="" dropdown-menu="ddSelectOptions" dropdown-model="ddSelectSelected" dropdown-item-label="text"><i class="fa fa-filter"></i> Filters</a></div></div></div>');
$templateCache.put('app/pages/dashboard/topHeader/topHeader.html','<div class="row tiles" bis_skin_checked="1"><div class="col-sm-6 col-xs-6 tile" onclick="window.location=\'clientarea.php?action=services\'" bis_skin_checked="1"><a href="clientarea.php?action=services"><div class="icon" bis_skin_checked="1"><i class="fas fa-cube"></i></div><div class="stat" bis_skin_checked="1">1</div><div class="title" bis_skin_checked="1">Plans</div><div class="highlight bg-color-blue" bis_skin_checked="1"></div></a></div><div class="col-sm-6 col-xs-6 tile" onclick="window.location=\'clientarea.php?action=domains\'" bis_skin_checked="1"><a href="clientarea.php?action=domains"><div class="icon" bis_skin_checked="1"><i class="fas fa-globe"></i></div><div class="stat" bis_skin_checked="1">1</div><div class="title" bis_skin_checked="1">Calls</div><div class="highlight bg-color-green" bis_skin_checked="1"></div></a></div><div class="col-sm-6 col-xs-6 tile" onclick="window.location=\'supporttickets.php\'" bis_skin_checked="1"><a href="supporttickets.php"><div class="icon" bis_skin_checked="1"><i class="fas fa-comments"></i></div><div class="stat" bis_skin_checked="1">0</div><div class="title" bis_skin_checked="1">Payments</div><div class="highlight bg-color-red" bis_skin_checked="1"></div></a></div><div class="col-sm-6 col-xs-6 tile" onclick="window.location=\'clientarea.php?action=invoices\'" bis_skin_checked="1"><a href="clientarea.php?action=invoices"><div class="icon" bis_skin_checked="1"><i class="ion-card"></i></div><div class="stat" bis_skin_checked="1">0</div><div class="title" bis_skin_checked="1">Invoices</div><div class="highlight bg-color-gold" bis_skin_checked="1"></div></a></div></div>');
$templateCache.put('app/pages/dashboard/trafficChart/trafficChart.html','<div ng-controller="TrafficChartCtrl"><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table class="table" st-table="smartTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">Start time</th><th st-sort="lastName">End time</th><th st-sort="username">Originating</th><th st-sort="email">Duration</th></tr><tr><th></th><th><input st-search="firstName" placeholder="Search First Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastName" placeholder="Search Last Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="username" placeholder="Search Username" class="input-sm form-control search-input" type="search"></th><th><input st-search="email" placeholder="Search Email" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/dashboard/welcome/dashboardWelcome.html','<div ng-controller="DashboardWelcomeCtrl as vm"><div class="row welcome" bis_skin_checked="1"><div class="col-md-6" bis_skin_checked="1"><div class="form-group row clearfix" bis_skin_checked="1"><div id="heroimage-dashboard-home" class="heroimage-dashboard hcf-white" bis_skin_checked="1"><h4 class="hcf-font-ruby ng-scope" ng-if="vm.details.firstname"><b pii="MaskStd" class="ng-binding">{{vm.details.firstname}} {{vm.details.lastname}}</b></h4><div class="dashboard-policy-detail" bis_skin_checked="1"><dl id="memberDetails" ng-if="vm.details.phone" class="ng-scope"><dt class="heading">Phone number</dt><dd pii="MaskStd" ng-bind="vm.details.phone" class="ng-binding">{{vm.details.phone}}</dd></dl><dl id="memberDetails" ng-if="vm.details.email" class="ng-scope"><dt class="heading">Email</dt><dd pii="MaskStd" ng-bind="vm.details.email" class="ng-binding">{{vm.details.email}}</dd></dl><span class="viewmemberLink"><a href="/main/profile" class="" title="View all members on your cover" bis_skin_checked="1">View all Details</a></span></div><div class="dashboard-policy-detail" bis_skin_checked="1"><dl ng-if="vm.plan" class="ng-scope"><dt class="heading">Phone Plan</dt><dd class="ng-binding">{{ vm.details.productName}} ${{ vm.details.productPrice}} {{ vm.details.productPlan}} (subscription)</dd></dl><dl class="ng-scope"><dt class="heading">Purchase Number</dt><dd class="ng-binding">{{ vm.details.phoneNumber}}</dd></dl><dl class="ng-scope"><dt class="heading">App Logins</dt><dd class="ng-binding">Username: {{ vm.details.phoneUsername}} Password: {{ vm.details.phoneTelnyxPassword}}</dd></dl><dl class="ng-scope"><dt class="heading">Expiry</dt><dd class="ng-binding">{{ vm.details.subscriptionExpiryDate | date:\'dd/MM/yyyy\'}}</dd></dl></div><div id="overdue-block-dashborad-id-ss-tt" class="row dashboard-messages overdue-block-dashborad ng-hide" ng-show="vm.displayStatusMessage" bis_skin_checked="1"></div><div ng-show="vm.ifPolicyIsInArrear" class="row overdue-block-dashborad dashboard-messages ng-binding ng-hide" bis_skin_checked="1"><div class="fieldError payment-warning-message" id="overduePolicyTextMessage" role="alert" bis_skin_checked="1">Your payment is overdue</div><p>Make a payment to ensure you can continue to claim and stay covered.</p><a href="unsafe:javascript:void(0)" class="ruby-box make-a-payment" title="Edit details" style="margin-left: 20px;" bis_skin_checked="1">Make a payment</a></div><div class="row col-lg-12 thank-you-details" ng-init="vm.loyaltyImages({&quot;DIAMOND&quot;:&quot;/content/dam/hcf/images/placeholder/HCF_THANKYOU_LM_TIER4_DIAMOND_LIGHT_RGB-01.svg&quot;,&quot;RUBY&quot;:&quot;/content/dam/hcf/images/placeholder/HCF_THANKYOU_LM_TIER3_RUBY_DARK_RGB-01.svg&quot;,&quot;EMERALD&quot;:&quot;/content/dam/hcf/images/placeholder/HCF_THANKYOU_LM_TIER2_EMERALD_DARK_RGB.svg&quot;,&quot;OPAL&quot;:&quot;/content/dam/hcf/images/placeholder/HCF_THANKYOU_LM_TIER1_OPAL_LIGHT_RGB-01.svg&quot;})" ng-show="vm.showLoyaltyData" bis_skin_checked="1"><div class="col-lg-12 grey-theme thanku-desc" bis_skin_checked="1"><b>HCF Thank You tier:</b> <span ng-bind="vm.loyaltyTeir" class="ng-binding">OPAL</span><p><a href="/memberservices/mycover/hcf-thank-you" class="" title="View rewards" bis_skin_checked="1">View rewards</a></p></div><img class="thanku-image" ng-src="/content/dam/hcf/images/placeholder/HCF_THANKYOU_LM_TIER1_OPAL_LIGHT_RGB-01.svg" src="/content/dam/hcf/images/placeholder/HCF_THANKYOU_LM_TIER1_OPAL_LIGHT_RGB-01.svg"></div></div></div></div><div class="col-md-6" bis_skin_checked="1"><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 tiles" ui-sref="main.profile" bis_skin_checked="1"><div class="tile" bis_skin_checked="1"><a ui-sref="main.profile"><div class="icon" bis_skin_checked="1"><i class="ion-power"></i></div><div class="stat" bis_skin_checked="1">1</div><div class="title" bis_skin_checked="1">Plans</div><div class="highlight bg-color-blue" bis_skin_checked="1"></div></a></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 tiles" ui-sref="main.mobile" bis_skin_checked="1"><div class="tile" bis_skin_checked="1"><a ui-sref="main.mobile"><div class="icon" bis_skin_checked="1"><i class="ion-iphone"></i></div><div class="stat" bis_skin_checked="1">1</div><div class="title" bis_skin_checked="1">App Details</div><div class="highlight bg-color-green" bis_skin_checked="1"></div></a></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 tiles" ui-sref="main.payments" bis_skin_checked="1"><div class="tile" bis_skin_checked="1"><a ui-sref="main.payments"><div class="icon" bis_skin_checked="1"><i class="ion-document-text"></i></div><div class="stat" bis_skin_checked="1">{{ vm.totalpayments }}</div><div class="title" bis_skin_checked="1">Payments</div><div class="highlight bg-color-red" bis_skin_checked="1"></div></a></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 tiles" ui-sref="main.invoices" bis_skin_checked="1"><div class="tile" bis_skin_checked="1"><a ui-sref="main.invoices"><div class="icon" bis_skin_checked="1"><i class="ion-card"></i></div><div class="stat" bis_skin_checked="1">{{ vm.unpaidInvoicesCount }}</div><div class="title" bis_skin_checked="1">Invoices</div><div class="highlight bg-color-gold" bis_skin_checked="1"></div></a></div></div></div></div></div></div>');
$templateCache.put('app/pages/invoices/view/card.html','<div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 tiles"><div class="tile"><div class="payment-form" name="paymentForm"><div class="notification"><img src="data:image/png;base64,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" class="notification__icon"> <span class="notification__text">{{\'purchase.noitfypaymentdescription\' | translate}}</span></div><div class="card-type clearfix"><div class="card-type__label">{{\'purchase.carddetails\' | translate}}</div><div class="card-type__icons"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAOCAYAAABZ/o57AAAAAXNSR0IArs4c6QAABLJJREFUSA2tVk1sVFUUPue+9+ZHZ94wibWmBTL2tSCVxBjF8LOQhUsWmmriQsPCNGFDGlphYYiZBGOt2EwLJhhjUNxIohsShVaDRhMrMUGjFVDT6Q8goRqhPzOlPzPv+p335s5MBVZ6knfP7z333PNzZziWyWVIl5jqwLapWMjv/7NOFJJN2Xti0USDkS9O/H4t3uw12vHIOpH5ZX+hONHzk9EHOJONJfxEi7KdDHHZ98m6WsjfvEiU9VfZCdPyRipO8ZSQt4rLf9P0/qLQAiqiVHvEiRyKOpGf8Y3LZ3FkOtU6cDw0qa1ufE1v1HIm5Yso5xxRE9ux6EFFakQ+y7LfNNap9b3plJfrS9npaSviXGBFnzFbZyym0ZSXHjZ2BrvewLGUis9EFE3J5yadA0YnWM2Nd52eG+t6YXbhZmNZ65Oa9LIotKbddF9fUugAkBkmftGwMDiGrCyjFJurMp9+CeiGbEI78WFiJYe5Vb0hWE8ZUrCb6d/KzHvqZaC31fOqylzLLljEb5HmeU2Ux0aVSNmPG72rUh3ElBYe+iWfV94RGsFXA4U8CDTppvZg/xbRAwo++Z3oiy0ln57ytT5Q9vXpUBWubNs99bzQrPkJJKIan11vMJvv+sFtHfRZ6yaYTjHZcthXwUalOqu22j8pPRz3+tch0qCnAhvSQaCKeIexRYWuzI/NfijZr8jOGp1gmRFU7xmWKdH6MvxZOLtZ/Ca8dHshH16+GnFlM5KiUTKOg3CZ9SMiT7b0bwB6smJDpZI/KLRDqpZNRDRXXLkY2vCYsUXGN7leejTRMtBhZPU4YnMXgkRwOJnpAyD0fghMulr+fweK0dVDYobNaa11MM2K7Vo2SX+zMNXzo9jourLjUhNmSvVSuRdxXxIbAfjaYCn+xPUGv403960NpVgx5UjkS8LjLH+5XDrua/rO6BXX+vS2QP2FW5+jFEioHMDb4s1H1uKmu81m9FeQzUBfN0jYEw4SFHNXu2/MjeUfxdmH4GjJ7EXA251Y9EuivVGRJTmKBLAZ2C8WJ17GkOlqRpGIu2e0cP2Vv2B8XhyhbLYT06/j1uHbqWmqMD5ySnQCkNdKXxmkUCPr0aW5/L5XV3SpDZcIqiRSXL7NbfV2omdt9PJekQnA12Vk/HmQbYFAFk0b5ZkT8raMihBQ55iqTxKm922ij8uhSTCRm0I6uNRoQGdya4xM8K18zxUEcbBehjIX0LfPIur1VTlzJzL+kWL1vpGBZ+3Etgq/auqNASo/BJtVznG94nyZ3jM2bkvaQxrihsfPTFB611bD7A1iOPyzWvN19O4DaJ0OBBsAfN+Yz1/63vXac0EejYO7Yyn/mTsGOp8fOZfydszgxtXsoNdO0OS+GeMPh2+uHU4rhfyF36BDEvTDWO9FsR4DIyIpawBogUXt+08nH3xIHnjzzlK5VN5ZwnNYMaOIxbugPyo8kwr69I6BSnk1bUcv8i5kEjFiLdMRwQbQMw1Q/BrwWo8TvbtCjYcRIA1hh7yjjUHp5I+E5j+QyVPLZZ1bnOyexM/lCfTfbOhLny9Mdn8d0pU1k/s0avFrFf1GYHPXVWb/E5O1E97h+4meC97I/+r0H2FHmUxT7+LTAAAAAElFTkSuQmCC" class="card-type__icon card-type__icon--disabled" ng-class="{\'card-type__icon--disabled\': !isVisa()}"> <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAUCAYAAAB1aeb6AAAAAXNSR0IArs4c6QAABABJREFUSA2VlW1ollUYx3/3NqduavlSyy3TTNecLy1RyxXMhBl9iJFazrcIIjKhzH2Q8MMMkdbLB0n60AsUZUQg+EItNPBjTjBMRytCnVubiZuxTXHNbe7ud/bwPDhm7dkFF+c+53r7n/+5zrkj/kNiiDQtUB9QJ6pX1HoX/3a8o8TfkEcmxWQ4xlxngGYqaTDGdMMlFBgiek1z4S11gzp9iBHTQZ36gYFHkrb4AM+bfrtwH3dtaM6YS658TS/vRRvpSMaEcYijhde49rk6KRhHkGM8y5ts5mOzlI3gG/beIfQXo0q+T/qmilt4q4sfqam1pNMdx4h2auhjFvlSnZ7Elo95JVo3uMFEIQuvNPpHNd00A2SbJkP/h43aqWao6Ugs4JinBPBTZOEsY35VQ5r0pJAT7KA05TzGr5zUbOSPmLP8xuJQfJ3e344ckfIY4C6xR7exdI+2d1L29D5iKsKuVzNvHpSX22r22qZN0NQER48OT5KbC1MnNLLjypxhxpuu3LdMfRrajnshTwxzSS3Mtr0ufvJc2Hkj1dUPsmuXMFbDwYOwd69n6CGGYnv2wNq1sHAhXLjgffBCrF8PVVVw3CKtrbDMoouuwsYPoXm/hetgymMeqGdx3h7Or4DO03D3Yui/7gF7k2vzGzLfhnfZujWLMR5cXp4BklFbK6RGWLUKiopgyxaoqYEVK6ChwQazw+osUF0NN91yZaVAvZ03vtOurftPW1fgecZPmAuzX/WF6JU1AY0vEECX7H6VFXq0h/nz4bTIZs6Evj4o0GHbtsRYXw8nTybm4XgOHYI5sh6YCDsvLobduwUt+O4m0yn3vwBzjQ+FMsfBJdnMMXfjp9BxCq79Hrx6MsjObmW6D9m5c3D4cCJxfr40dYp0KsyYAe3tMHlyYl5WlqC/pycREwCdOQN/GFuyD0rd/RSPobcDxk6zuNR3au9Si2Vq7na4bq3MiX9FcU7OPtG/TlubtN2AwsIEtWFHYR4kgDsl4gCqvz8m93LEo6Xu6KKF7oVfbK43bpl4aWKnnWd9I43vNz6SkX9aZLRL3yWO1zwq+6Pvxvuh4TwI5HUUstkmncXsVIQEIcOjkPDUlAw+pQKQMypGEXyLRd7z5EO8xkjZT1vizAOXx5e8lCwun8ir73S6spyfWc4SigywHUYhzXSPf+J8V8HVJHafLEpM8IPqAacpj0j/TukPdyYdiWmhn2eiDTQE91SYKGxH7JhBAMH2f9Kp8bXoLA85VoncLhpRjlh4abJw8E7t/PZQWXjSue8s5ap3DVt2sEAA6F3iMwNt34TEXzLVH8vLzioEssCskxx7nbc4HlP3+x8fXVOH1AIJN2Js+E5X4i8YF+JG8v8X5UMlkwCffwoAAAAASUVORK5CYII=" class="card-type__icon card-type__icon--disabled" ng-class="{\'card-type__icon--disabled\': !isMasterCard()}"></div></div><input type="text" class="card-input card-input--full" placeholder="{{\'purchase.cardnumber\' | translate}}" ng-model="card.number" card-number="" required=""> <input type="text" class="card-input card-input--full" placeholder="{{\'purchase.cardholder\' | translate}}" ng-model="card.holder" card-holder="" required=""><div class="card-info clearfix"><div class="card-info__date"><div class="card-info__text">{{\'purchase.validity\' | translate}}</div><input type="text" class="card-input card-input--date" placeholder="\u041C\u041C / YY" ng-model="card.date" card-date="" required=""></div><div class="card-info__cvv"><div class="card-info__text">{{\'purchase.security\' | translate}}</div><input type="text" class="card-input card-input--cvv" placeholder="CVV" ng-model="card.cvv" card-cvv="" required=""></div></div><button class="payment-form__button" ng-disabled="paymentForm.$invalid" ng-click="vm.submitForm()">{{\'purchase.buy\' | translate}}</button><div class="payment-form__agreement">{{\'purchase.subscription\' | translate}}</div></div></div></div>');
$templateCache.put('app/pages/invoices/view/invoice.html','<div class="invoice-page" ng-controller="InvoiceCtrl as vm"><div class="invoice-inner"><div class="invoice-inner"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left invoice-panel"><div class="invoice-body"><div class="panel-content"><div class="header">Invoice No 20 <span class="textred" ng-if="vm.invoice.status == \'false\'">Unpaid</span> <span class="textgreen" ng-if="vm.invoice.status == \'true\'">Paid</span></div><div class="row"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="col-xlg-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 tiles"><div class="tile"><div class="row"><div class="plan"><div class="col-xlg-9 col-lg-9 col-md-9 col-sm-6 col-xs-6"><p ng-if="vm.invoice.ProductName"><span class="plan-title">{{vm.invoice.ProductName }}</span> <span class="plan">Plan</span></p></div><div class="col-xlg-3 col-lg-3 col-md-3 col-sm-6 col-xs-6"><p class="price" ng-if="vm.invoice.ProductPrice"><strong>${{vm.invoice.ProductPrice}}</strong><span>{{vm.invoice.ProductPlan}}</span></p></div></div></div><div class="row"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="invoice-template-header"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-7 col-xs-7"><div class="left-invoice"><p><strong>Invoice Number</strong></p><p><strong>INV# {{ vm.invoice.id}}</strong></p><p><strong>Issued Date:</strong> {{vm.invoice.createdAt | date:\'dd-MM-yyyy\'}}</p><p><strong>Due Sate:</strong> {{vm.invoice.expires | date:\'dd-MM-yyyy\'}}</p></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-5 col-xs-5"><div class="right-invoice"><p><strong>Billed To</strong></p><p>{{ vm.invoice.firstName }} {{ vm.invoice.lastName }}</p><p>{{ vm.invoice.address }} {{ vm.invoice.city }}</p><p>{{ vm.invoice.state }} {{ vm.invoice.country }}</p></div></div></div><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><h5>Paymemt is due by the {{vm.invoice.date | date:\'dd-MM-yyyy\'}}, you have {{vm.days }} days remaining to pay.</h5><div class="card"><div class="card-body"><div class="table-responsive-sm"><table class="table table-striped"><thead><tr><th class="center">#</th><th>Item</th><th class="right">Unit Cost</th><th class="center">Qty</th><th class="right">Total</th></tr></thead><tbody><tr><td class="center">{{ vm.invoice.id }}</td><td class="left strong">{{ vm.invoice.ProductName }} {{ vm.invoice.ProductPlan}}<p><strong>{{\'purchase.subperiod\' | translate}}</strong> {{vm.today | date:\'dd-MM-yyyy\'}} <span>{{\'purchase.to\' | translate}}</span> {{vm.dateInFuture | date:\'dd-MM-yyyy\'}}</p></td><td ng-if="vm.invoice.ProductMonthlycost">${{ vm.invoice.ProductMonthlycost }}</td><td class="center">1</td><td ng-if="vm.invoice.ProductMonthlycost">${{ vm.invoice.ProductMonthlycost }}</td></tr><tr></tr></tbody></table></div><div class="row"><div class="col-lg-4 pull-right"><table class="table"><tbody><tr><td class="left strong"></td><td class="left strong"></td><td class="center"></td><td class="right" style="text-align: right;"><strong>Subtotal</strong></td><td class="right" style="text-align: right;">${{ vm.invoice.ProductMonthlycost }}</td></tr><tr><td class="left strong"></td><td class="left strong"></td><td class="center"></td><td class="right" style="text-align: right;"><strong>Total</strong></td><td class="right" style="text-align: right;"><strong>${{ vm.invoice.total }}</strong></td></tr></tbody></table></div></div></div></div></div></div></div><div ng-if="vm.invoice.recurring == 0"><div class="col-xlg-4 col-lg-4 col-md-4 col-sm-12 col-xs-12"><div class="renewal"><button ng-click="toggleSection()" class="button btn btn-default btn-bill">Pay Now</button></div></div></div><div class="row auto-renewal"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><h3>Enable Auto Renewal</h3><p>This option if checked, will renew your Callio Subscription once expires</p></div><div class="col-xlg-4 col-lg-4 col-md-4 col-sm-12 col-xs-12"><ba-switcher switcher-style="primary" switcher-value="vm.invoice.recurring"></ba-switcher></div><div ng-if="vm.invoice.recurring == 1"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">Your Last details were used with a</div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="card-type__icons"><img ng-if="cardType === \'visa\'" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAUCAYAAAB1aeb6AAAAAXNSR0IArs4c6QAABABJREFUSA2VlW1ollUYx3/3NqduavlSyy3TTNecLy1RyxXMhBl9iJFazrcIIjKhzH2Q8MMMkdbLB0n60AsUZUQg+EItNPBjTjBMRytCnVubiZuxTXHNbe7ud/bwPDhm7dkFF+c+53r7n/+5zrkj/kNiiDQtUB9QJ6pX1HoX/3a8o8TfkEcmxWQ4xlxngGYqaTDGdMMlFBgiek1z4S11gzp9iBHTQZ36gYFHkrb4AM+bfrtwH3dtaM6YS658TS/vRRvpSMaEcYijhde49rk6KRhHkGM8y5ts5mOzlI3gG/beIfQXo0q+T/qmilt4q4sfqam1pNMdx4h2auhjFvlSnZ7Elo95JVo3uMFEIQuvNPpHNd00A2SbJkP/h43aqWao6Ugs4JinBPBTZOEsY35VQ5r0pJAT7KA05TzGr5zUbOSPmLP8xuJQfJ3e344ckfIY4C6xR7exdI+2d1L29D5iKsKuVzNvHpSX22r22qZN0NQER48OT5KbC1MnNLLjypxhxpuu3LdMfRrajnshTwxzSS3Mtr0ufvJc2Hkj1dUPsmuXMFbDwYOwd69n6CGGYnv2wNq1sHAhXLjgffBCrF8PVVVw3CKtrbDMoouuwsYPoXm/hetgymMeqGdx3h7Or4DO03D3Yui/7gF7k2vzGzLfhnfZujWLMR5cXp4BklFbK6RGWLUKiopgyxaoqYEVK6ChwQazw+osUF0NN91yZaVAvZ03vtOurftPW1fgecZPmAuzX/WF6JU1AY0vEECX7H6VFXq0h/nz4bTIZs6Evj4o0GHbtsRYXw8nTybm4XgOHYI5sh6YCDsvLobduwUt+O4m0yn3vwBzjQ+FMsfBJdnMMXfjp9BxCq79Hrx6MsjObmW6D9m5c3D4cCJxfr40dYp0KsyYAe3tMHlyYl5WlqC/pycREwCdOQN/GFuyD0rd/RSPobcDxk6zuNR3au9Si2Vq7na4bq3MiX9FcU7OPtG/TlubtN2AwsIEtWFHYR4kgDsl4gCqvz8m93LEo6Xu6KKF7oVfbK43bpl4aWKnnWd9I43vNz6SkX9aZLRL3yWO1zwq+6Pvxvuh4TwI5HUUstkmncXsVIQEIcOjkPDUlAw+pQKQMypGEXyLRd7z5EO8xkjZT1vizAOXx5e8lCwun8ir73S6spyfWc4SigywHUYhzXSPf+J8V8HVJHafLEpM8IPqAacpj0j/TukPdyYdiWmhn2eiDTQE91SYKGxH7JhBAMH2f9Kp8bXoLA85VoncLhpRjlh4abJw8E7t/PZQWXjSue8s5ap3DVt2sEAA6F3iMwNt34TEXzLVH8vLzioEssCskxx7nbc4HlP3+x8fXVOH1AIJN2Js+E5X4i8YF+JG8v8X5UMlkwCffwoAAAAASUVORK5CYII=" class="card-type__icon"><img ng-if="cardType === \'mastercard\'" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAOCAYAAABZ/o57AAAAAXNSR0IArs4c6QAABLJJREFUSA2tVk1sVFUUPue+9+ZHZ94wibWmBTL2tSCVxBjF8LOQhUsWmmriQsPCNGFDGlphYYiZBGOt2EwLJhhjUNxIohsShVaDRhMrMUGjFVDT6Q8goRqhPzOlPzPv+p335s5MBVZ6knfP7z333PNzZziWyWVIl5jqwLapWMjv/7NOFJJN2Xti0USDkS9O/H4t3uw12vHIOpH5ZX+hONHzk9EHOJONJfxEi7KdDHHZ98m6WsjfvEiU9VfZCdPyRipO8ZSQt4rLf9P0/qLQAiqiVHvEiRyKOpGf8Y3LZ3FkOtU6cDw0qa1ufE1v1HIm5Yso5xxRE9ux6EFFakQ+y7LfNNap9b3plJfrS9npaSviXGBFnzFbZyym0ZSXHjZ2BrvewLGUis9EFE3J5yadA0YnWM2Nd52eG+t6YXbhZmNZ65Oa9LIotKbddF9fUugAkBkmftGwMDiGrCyjFJurMp9+CeiGbEI78WFiJYe5Vb0hWE8ZUrCb6d/KzHvqZaC31fOqylzLLljEb5HmeU2Ux0aVSNmPG72rUh3ElBYe+iWfV94RGsFXA4U8CDTppvZg/xbRAwo++Z3oiy0ln57ytT5Q9vXpUBWubNs99bzQrPkJJKIan11vMJvv+sFtHfRZ6yaYTjHZcthXwUalOqu22j8pPRz3+tch0qCnAhvSQaCKeIexRYWuzI/NfijZr8jOGp1gmRFU7xmWKdH6MvxZOLtZ/Ca8dHshH16+GnFlM5KiUTKOg3CZ9SMiT7b0bwB6smJDpZI/KLRDqpZNRDRXXLkY2vCYsUXGN7leejTRMtBhZPU4YnMXgkRwOJnpAyD0fghMulr+fweK0dVDYobNaa11MM2K7Vo2SX+zMNXzo9jourLjUhNmSvVSuRdxXxIbAfjaYCn+xPUGv403960NpVgx5UjkS8LjLH+5XDrua/rO6BXX+vS2QP2FW5+jFEioHMDb4s1H1uKmu81m9FeQzUBfN0jYEw4SFHNXu2/MjeUfxdmH4GjJ7EXA251Y9EuivVGRJTmKBLAZ2C8WJ17GkOlqRpGIu2e0cP2Vv2B8XhyhbLYT06/j1uHbqWmqMD5ySnQCkNdKXxmkUCPr0aW5/L5XV3SpDZcIqiRSXL7NbfV2omdt9PJekQnA12Vk/HmQbYFAFk0b5ZkT8raMihBQ55iqTxKm922ij8uhSTCRm0I6uNRoQGdya4xM8K18zxUEcbBehjIX0LfPIur1VTlzJzL+kWL1vpGBZ+3Etgq/auqNASo/BJtVznG94nyZ3jM2bkvaQxrihsfPTFB611bD7A1iOPyzWvN19O4DaJ0OBBsAfN+Yz1/63vXac0EejYO7Yyn/mTsGOp8fOZfydszgxtXsoNdO0OS+GeMPh2+uHU4rhfyF36BDEvTDWO9FsR4DIyIpawBogUXt+08nH3xIHnjzzlK5VN5ZwnNYMaOIxbugPyo8kwr69I6BSnk1bUcv8i5kEjFiLdMRwQbQMw1Q/BrwWo8TvbtCjYcRIA1hh7yjjUHp5I+E5j+QyVPLZZ1bnOyexM/lCfTfbOhLny9Mdn8d0pU1k/s0avFrFf1GYHPXVWb/E5O1E97h+4meC97I/+r0H2FHmUxT7+LTAAAAAElFTkSuQmCC" class="card-type__icon"></div></div></div></div></div></div><div class="col-xlg-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 tiles"><div class="tile"><div class="header-next">Change Your Plan</div><p>You can save over 20% by changing your plan</p><div class="renewal"><button ui-sref="main.profile.plans" class="button btn btn-default btn-bill">To upgrade your Plan</button></div><div class="renewal"><a href="https://api.callio.com.au/public/pdf/invoice-{{vm.invoice.pdf}}" class="button btn btn-default btn-bill">Download Invoice</a></div></div><div ng-show="isSectionVisible"><form class="payment-form" name="paymentForm"><cardsinv></cardsinv></form></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/payments/view/payment.html','<div class="payments-page" ng-controller="PaymentCtrl as vm"><div class="payments-inner"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left payments-panel"><div class="payments-body"><div class="panel-content"><div class="header">Payments No {{ vm.payment.id }}0 <span class="textgreen">Paid</span></div><div class="row"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="group"><div print-section=""><div class="col-xlg-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 tiles"><div class="tile"><div class="row"><div class="plan"><div class="col-xlg-9 col-lg-9 col-md-9 col-sm-6 col-xs-6"><p ng-if="vm.payment.ProductName"><span class="plan-title">{{ vm.payment.ProductName }}</span> <span class="plan">Plan</span></p></div><div class="col-xlg-3 col-lg-3 col-md-3 col-sm-6 col-xs-6"><p class="price" ng-if="vm.payment.ProductPrice"><strong>${{ vm.payment.ProductPrice }}</strong><span>{{ vm.payment.ProductPlan }}</span></p></div></div></div><div class="row"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="payments-template-header"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-7 col-xs-7"><div class="left-payments"><p><strong>Payments Number</strong> # {{ vm.payment.id}}</p><p><strong>Issued Date:</strong> {{vm.payment.createdAt | date:\'dd-MM-yyyy\'}}</p><p><strong>Payment Date:</strong> {{ vm.payment.date | date:\'dd/MM/yyyy\' }}</p><p><strong>Payment Receipt</strong> {{ vm.payment.receipt }}</p></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-5 col-xs-5"><div class="right-payments"><p><strong>Billed To</strong></p><p>{{ vm.payment.firstName }} {{ vm.payment.lastName }}</p><p>{{ vm.payment.ClientAddress }} {{ vm.payment.city }}</p><p>{{ vm.payment.ClientState }} {{ vm.payment.postcode }}</p><p>{{ vm.payment.country }}</p></div></div></div><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><h5>Payment was made {{ vm.payment.date | date:\'dd/MM/yyyy\' }}</h5><div class="card"><div class="card-body"><div class="table-responsive-sm"><table class="table table-striped"><thead><tr><th class="center">#</th><th>Item</th><th class="right">Unit Cost</th><th class="center">Qty</th><th class="right">Total</th></tr></thead><tbody><tr><td class="left">{{ vm.payment.id }}</td><td class="left strong">{{ vm.payment.ProductName }} {{ vm.payment.ProductPeriod }} {{ vm.payment.ProductPlan }} Plan</td><td class="right" ng-if="vm.payment.ProductMonthlycost">${{ vm.payment.ProductMonthlycost }}</td><td class="center">1</td><td class="right" ng-if="vm.payment.ProductMonthlycost">${{ vm.payment.ProductMonthlycost }}</td></tr></tbody></table></div><div class="row"><div class="col-lg-4 pull-right"><table class="table"><tbody><tr><td class="left strong"></td><td class="left strong"></td><td class="center"></td><td class="right" style="text-align: right;"><strong>Subtotal</strong></td><td class="right" style="text-align: right;">${{ vm.payment.ProductMonthlycost }}</td></tr><tr><td class="left strong"></td><td class="left strong"></td><td class="center"></td><td class="right" style="text-align: right;"><strong>Total</strong></td><td class="right" style="text-align: right;"><strong>${{ vm.payment.ProductTotal }}</strong></td></tr></tbody></table></div></div></div></div></div></div></div></div></div><div class="col-xlg-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 tiles"><div class="tile"><div class="header-next">Payment Receipt or Invoice</div><p>You can download below your payment receipt or invoice</p><div style="width: 100% !important;" class="renewal"><a href="https://api.callio.com.au/public/pdf/payment-{{vm.payment.pdf}}" target="_blank" class="button btn btn-default btn-bill" download="">Download Payment Receipt</a></div><div class="renewal"><a href="https://api.callio.com.au/public/pdf/invoice-{{vm.payment.InvoicePdf}}" target="_blank" class="button btn btn-default btn-bill" download="">Download Invoice</a></div></div></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/profile/billing/plans.html','<div class="billing-page" ng-controller="plansCtrl as vm"><div ba-panel="" ba-panel-title="{{\'plans.heading\' | translate}}"><div class="pull-right back"><a ui-sref="main.checkpoints.list" class="newlink">{{\'plans.back\' | translate}} <i class="fa fa-chevron-right" aria-hidden="true"></i></a></div><div class="billing-inner"><div class="billing-inner"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left billing-panel"><div class="billing-body"><div class="panel-content"><div class="header">{{\'plans.title\' | translate}}</div><div class="row"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="container group"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="description">{{\'plans.description\' | translate}}</div></div><div class="grid-1-5"><div class="space"><h2>{{\'plans.bronze\' | translate}}</h2><p>{{\'plans.bronzesubplan\' | translate}}</p><h3><span class="uppercase">{{\'plans.bronzeprice\' | translate}}</span></h3><p><strong>{{\'plans.bronzesavings\' | translate}}</strong></p><p>{{\'plans.mins\' | translate}}</p><ul><li>{{\'plans.setup\' | translate}}</li><li>{{\'plans.cancel\' | translate}}</li><li>Email Support</li><li>Phone Support</li></ul><a ui-sref="main.billing.purchase({id: 1})" class="button">{{\'plans.signup\' | translate}}</a></div></div><div class="grid-1-5"><div class="space"><h2>{{\'plans.silver\' | translate}}</h2><p>{{\'plans.silversubplan\' | translate}}</p><h3><span class="uppercase">{{\'plans.silverprice\' | translate}}</span></h3><p><strong>{{\'plans.silversavings\' | translate}}</strong></p><p>{{\'plans.mins\' | translate}}</p><ul><li>{{\'plans.setup\' | translate}}</li><li>Email Support</li><li>Phone Support</li></ul><a ui-sref="main.billing.purchase({id: 2})" class="button">{{\'plans.signup\' | translate}}</a></div></div><div class="grid-1-5"><div class="space"><h2>{{\'plans.gold\' | translate}}</h2><p>{{\'plans.goldsubplan\' | translate}}</p><h3><span class="uppercase">{{\'plans.goldprice\' | translate}}</span></h3><p><strong>{{\'plans.goldsavings\' | translate}}</strong></p><p>{{\'plans.mins\' | translate}}</p><ul><li>{{\'plans.setup\' | translate}}</li><li>Email Support</li><li>Phone Support</li></ul><a ui-sref="main.billing.purchase({id: 3})" class="button">{{\'plans.signup\' | translate}}</a></div></div><div class="grid-1-5"><div class="space"><h2>{{\'plans.platinum\' | translate}}</h2><p>{{\'plans.platinumsubplan\' | translate}}</p><h3><span class="uppercase">{{\'plans.platinumprice\' | translate}}</span></h3><p><strong>{{\'plans.platinumsavings\' | translate}}</strong></p><p>{{\'plans.mins\' | translate}}</p><ul><li>{{\'plans.setup\' | translate}}</li><li>Email Support</li><li>Phone Support</li></ul><a ui-sref="main.billing.purchase({id: 4})" class="button">{{\'plans.signup\' | translate}}</a></div></div><div class="grid-1-5"><div class="space"><h2>{{\'plans.diamond\' | translate}}</h2><p>{{\'plans.diamondsubplan\' | translate}}</p><h3><span class="uppercase">{{\'plans.diamondprice\' | translate}}</span></h3><p><strong>{{\'plans.diamondsavings\' | translate}}</strong></p><p>{{\'plans.mins\' | translate}}</p><ul><li>{{\'plans.setup\' | translate}}</li><li>Email Support</li><li>Phone Support</li></ul><a ui-sref="main.billing.purchase({id: 5})" class="button">{{\'plans.signup\' | translate}}</a></div></div></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/profile/edit/edit.html','<div ba-panel="" ba-panel-class="profile-page"><div class="panel-content"><div class="header">General Information</div><form name="form" ng-submit="vm.Update()" role="form"><div class="row"><div class="col-md-6"><div class="col-md-6"><div class="form-group clearfix"><label for="inputFirstName" class="control-label">First Name</label> <input type="text" class="form-control" id="inputFirstName" placeholder="" value="Anastasiya"></div></div><div class="col-md-6"><div class="form-group clearfix"><label for="inputLastName" class="control-label">Last Name</label> <input type="text" class="form-control" id="inputLastName" placeholder="" value=""></div></div><div class="col-md-6"><div class="form-group clearfix"><label for="inputEmail" class="control-label">Email Address</label> <input type="text" class="form-control" id="inputLastName" placeholder="" value=""></div></div><div class="col-md-6"><div class="form-group clearfix"><label for="inputLastName" class="control-label">Mobile Number</label> <input type="text" class="form-control" id="inputLastName" placeholder="" value=""></div></div><div class="col-md-6"><div class="form-group clearfix"><label class="control-label">Role</label><select class="form-control" title="Standard Select" selectpicker=""><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Picture</label><div class="col-sm-9"><div class="userpic"><div class="userpic-wrapper"><img ng-src="{{ picture }}" ng-click="uploadPicture()"></div><i class="ion-ios-close-outline" ng-click="removePicture()" ng-if="!noPicture"></i> <a href="" class="change-userpic" ng-click="uploadPicture()">Change Profile Picture</a> <input type="file" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"></div></div></div></div></div><div class="header">Change Password</div><div class="row"><div class="col-md-6"><div class="col-md-6"><div class="form-group"><input type="password" class="form-control" ng-model="vm.password" placeholder="Password" name="password" required="required" ng-minlength="6"><div ng-if="passwordForm.password.$touched || signupSubmitted"><p ng-show="passwordForm.password.$error.required" class="help-block">Password is required</p><p ng-show="passwordForm.password.$error.minlength" class="help-block">Minimum 6 character</p></div></div></div><div class="col-md-6"><div class="form-group"><input type="password" class="form-control" name="confirm_password" ng-model="vm.confirm_password" placeholder="Confirm password" match-password="password" required=""><div ng-if="passwordForm.confirm_password.$touched || signupSubmitted"><p ng-show="passwordForm.confirm_password.$error.required" class="help-block">Confirm password is required</p><p ng-show="passwordForm.confirm_password.$error.matchPassword && !passwordForm.confirm_password.$error.required" class="help-block">Confirm password didn\'t match</p></div></div></div></div></div><h3 class="with-line">Contact Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputEmail3" class="col-sm-3 control-label">Email</label><div class="col-sm-9"><input type="email" class="form-control" id="inputEmail3" placeholder="" value="contact@akveo.com"></div></div><div class="form-group row clearfix"><label for="inputPhone" class="col-sm-3 control-label">Phone</label><div class="col-sm-9"><input type="text" class="form-control" id="inputPhone" placeholder="" value="+1 (23) 456 7890"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Office Location</label><div class="col-sm-9"><select class="form-control" title="Standard Select" selectpicker=""><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div><div class="form-group row clearfix"><label for="inputRoom" class="col-sm-3 control-label">Room</label><div class="col-sm-9"><input type="text" class="form-control" id="inputRoom" placeholder="" value="303"></div></div></div></div><h3 class="with-line">Social Profiles</h3><div class="social-profiles row clearfix"><div class="col-md-3 col-sm-4" ng-repeat="item in socialProfiles"><a class="sn-link" href="" ng-click="showModal(item)" ng-if="!item.href"><i class="socicon {{ item.icon }}"></i> <span>{{ item.name }}</span></a> <a class="sn-link connected" href="{{ item.href }}" target="_blank" ng-if="item.href"><i class="socicon {{ item.icon }}"></i> <span>{{ item.name }}</span> <em class="ion-ios-close-empty sn-link-close" ng-mousedown="unconnect(item)"></em></a></div></div><h3 class="with-line">Send Email Notifications</h3><div class="notification row clearfix"><div class="col-sm-6"><div class="form-group row clearfix"><label class="col-xs-8">When I receive a message</label><div class="col-xs-4"><switch color="primary" ng-model="switches[0]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">When Someone sends me an invitation</label><div class="col-xs-4"><switch color="primary" ng-model="switches[1]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">When profile information changes</label><div class="col-xs-4"><switch color="primary" ng-model="switches[2]"></switch></div></div></div><div class="col-sm-6"><div class="form-group row clearfix"><label class="col-xs-8">When anyone logs into your account from a new device or browser</label><div class="col-xs-4"><switch color="primary" ng-model="switches[3]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">Weekly Reports</label><div class="col-xs-4"><switch color="primary" ng-model="switches[4]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">Daily Reports</label><div class="col-xs-4"><switch color="primary" ng-model="switches[5]"></switch></div></div></div></div><button type="submit" ng-disabled="form.$invalid || vm.dataLoading" class="btn btn-primary" translate="">Update Profile</button></form></div></div>');
$templateCache.put('app/pages/profile/plans/plans.html','<div class="plan-page" ng-controller="plansCtrl as vm"><div class="pull-right back"><a ui-sref="main.profile" class="newlink">{{\'plans.back\' | translate}} <i class="fa fa-chevron-right" aria-hidden="true"></i></a></div><div class="billing-inner"><div class="billing-inner"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left billing-panel"><div class="billing-body"><div class="panel-content"><div class="header">{{\'plans.title\' | translate}}</div><div class="row"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="container group"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12"><div class="row"><div class="container group"><div class="description">{{\'plans.description\' | translate}}</div></div></div></div><div class="grid-1-5 plans-table" ng-repeat="plan in vm.plans"><div class="space"><h2>{{plan.Name}}</h2><h3>$ {{plan.Price}}</h3><p>Per Month {{plan.Period}} plan</p><p><strong>as low as ${{plan.Savings}} per week</strong></p><a ui-sref="main.profile.purchase({id: plan.Id})" class="btn btn-primary">Buy Now</a></div></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/profile/purchase/card.html','<div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 tiles"><div class="tile"><div class="payment-form" name="paymentForm"><div class="notification"><img src="data:image/png;base64,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" class="notification__icon"> <span class="notification__text">{{\'purchase.noitfypaymentdescription\' | translate}}</span></div><div class="card-type clearfix"><div class="card-type__label">{{\'purchase.carddetails\' | translate}}</div><div class="card-type__icons"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAOCAYAAABZ/o57AAAAAXNSR0IArs4c6QAABLJJREFUSA2tVk1sVFUUPue+9+ZHZ94wibWmBTL2tSCVxBjF8LOQhUsWmmriQsPCNGFDGlphYYiZBGOt2EwLJhhjUNxIohsShVaDRhMrMUGjFVDT6Q8goRqhPzOlPzPv+p335s5MBVZ6knfP7z333PNzZziWyWVIl5jqwLapWMjv/7NOFJJN2Xti0USDkS9O/H4t3uw12vHIOpH5ZX+hONHzk9EHOJONJfxEi7KdDHHZ98m6WsjfvEiU9VfZCdPyRipO8ZSQt4rLf9P0/qLQAiqiVHvEiRyKOpGf8Y3LZ3FkOtU6cDw0qa1ufE1v1HIm5Yso5xxRE9ux6EFFakQ+y7LfNNap9b3plJfrS9npaSviXGBFnzFbZyym0ZSXHjZ2BrvewLGUis9EFE3J5yadA0YnWM2Nd52eG+t6YXbhZmNZ65Oa9LIotKbddF9fUugAkBkmftGwMDiGrCyjFJurMp9+CeiGbEI78WFiJYe5Vb0hWE8ZUrCb6d/KzHvqZaC31fOqylzLLljEb5HmeU2Ux0aVSNmPG72rUh3ElBYe+iWfV94RGsFXA4U8CDTppvZg/xbRAwo++Z3oiy0ln57ytT5Q9vXpUBWubNs99bzQrPkJJKIan11vMJvv+sFtHfRZ6yaYTjHZcthXwUalOqu22j8pPRz3+tch0qCnAhvSQaCKeIexRYWuzI/NfijZr8jOGp1gmRFU7xmWKdH6MvxZOLtZ/Ca8dHshH16+GnFlM5KiUTKOg3CZ9SMiT7b0bwB6smJDpZI/KLRDqpZNRDRXXLkY2vCYsUXGN7leejTRMtBhZPU4YnMXgkRwOJnpAyD0fghMulr+fweK0dVDYobNaa11MM2K7Vo2SX+zMNXzo9jourLjUhNmSvVSuRdxXxIbAfjaYCn+xPUGv403960NpVgx5UjkS8LjLH+5XDrua/rO6BXX+vS2QP2FW5+jFEioHMDb4s1H1uKmu81m9FeQzUBfN0jYEw4SFHNXu2/MjeUfxdmH4GjJ7EXA251Y9EuivVGRJTmKBLAZ2C8WJ17GkOlqRpGIu2e0cP2Vv2B8XhyhbLYT06/j1uHbqWmqMD5ySnQCkNdKXxmkUCPr0aW5/L5XV3SpDZcIqiRSXL7NbfV2omdt9PJekQnA12Vk/HmQbYFAFk0b5ZkT8raMihBQ55iqTxKm922ij8uhSTCRm0I6uNRoQGdya4xM8K18zxUEcbBehjIX0LfPIur1VTlzJzL+kWL1vpGBZ+3Etgq/auqNASo/BJtVznG94nyZ3jM2bkvaQxrihsfPTFB611bD7A1iOPyzWvN19O4DaJ0OBBsAfN+Yz1/63vXac0EejYO7Yyn/mTsGOp8fOZfydszgxtXsoNdO0OS+GeMPh2+uHU4rhfyF36BDEvTDWO9FsR4DIyIpawBogUXt+08nH3xIHnjzzlK5VN5ZwnNYMaOIxbugPyo8kwr69I6BSnk1bUcv8i5kEjFiLdMRwQbQMw1Q/BrwWo8TvbtCjYcRIA1hh7yjjUHp5I+E5j+QyVPLZZ1bnOyexM/lCfTfbOhLny9Mdn8d0pU1k/s0avFrFf1GYHPXVWb/E5O1E97h+4meC97I/+r0H2FHmUxT7+LTAAAAAElFTkSuQmCC" class="card-type__icon card-type__icon--disabled" ng-class="{\'card-type__icon--disabled\': !isVisa()}"> <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAUCAYAAAB1aeb6AAAAAXNSR0IArs4c6QAABABJREFUSA2VlW1ollUYx3/3NqduavlSyy3TTNecLy1RyxXMhBl9iJFazrcIIjKhzH2Q8MMMkdbLB0n60AsUZUQg+EItNPBjTjBMRytCnVubiZuxTXHNbe7ud/bwPDhm7dkFF+c+53r7n/+5zrkj/kNiiDQtUB9QJ6pX1HoX/3a8o8TfkEcmxWQ4xlxngGYqaTDGdMMlFBgiek1z4S11gzp9iBHTQZ36gYFHkrb4AM+bfrtwH3dtaM6YS658TS/vRRvpSMaEcYijhde49rk6KRhHkGM8y5ts5mOzlI3gG/beIfQXo0q+T/qmilt4q4sfqam1pNMdx4h2auhjFvlSnZ7Elo95JVo3uMFEIQuvNPpHNd00A2SbJkP/h43aqWao6Ugs4JinBPBTZOEsY35VQ5r0pJAT7KA05TzGr5zUbOSPmLP8xuJQfJ3e344ckfIY4C6xR7exdI+2d1L29D5iKsKuVzNvHpSX22r22qZN0NQER48OT5KbC1MnNLLjypxhxpuu3LdMfRrajnshTwxzSS3Mtr0ufvJc2Hkj1dUPsmuXMFbDwYOwd69n6CGGYnv2wNq1sHAhXLjgffBCrF8PVVVw3CKtrbDMoouuwsYPoXm/hetgymMeqGdx3h7Or4DO03D3Yui/7gF7k2vzGzLfhnfZujWLMR5cXp4BklFbK6RGWLUKiopgyxaoqYEVK6ChwQazw+osUF0NN91yZaVAvZ03vtOurftPW1fgecZPmAuzX/WF6JU1AY0vEECX7H6VFXq0h/nz4bTIZs6Evj4o0GHbtsRYXw8nTybm4XgOHYI5sh6YCDsvLobduwUt+O4m0yn3vwBzjQ+FMsfBJdnMMXfjp9BxCq79Hrx6MsjObmW6D9m5c3D4cCJxfr40dYp0KsyYAe3tMHlyYl5WlqC/pycREwCdOQN/GFuyD0rd/RSPobcDxk6zuNR3au9Si2Vq7na4bq3MiX9FcU7OPtG/TlubtN2AwsIEtWFHYR4kgDsl4gCqvz8m93LEo6Xu6KKF7oVfbK43bpl4aWKnnWd9I43vNz6SkX9aZLRL3yWO1zwq+6Pvxvuh4TwI5HUUstkmncXsVIQEIcOjkPDUlAw+pQKQMypGEXyLRd7z5EO8xkjZT1vizAOXx5e8lCwun8ir73S6spyfWc4SigywHUYhzXSPf+J8V8HVJHafLEpM8IPqAacpj0j/TukPdyYdiWmhn2eiDTQE91SYKGxH7JhBAMH2f9Kp8bXoLA85VoncLhpRjlh4abJw8E7t/PZQWXjSue8s5ap3DVt2sEAA6F3iMwNt34TEXzLVH8vLzioEssCskxx7nbc4HlP3+x8fXVOH1AIJN2Js+E5X4i8YF+JG8v8X5UMlkwCffwoAAAAASUVORK5CYII=" class="card-type__icon card-type__icon--disabled" ng-class="{\'card-type__icon--disabled\': !isMasterCard()}"></div></div><input type="text" class="card-input card-input--full" placeholder="{{\'purchase.cardnumber\' | translate}}" ng-model="vm.card.number" card-number="" required=""> <input type="text" class="card-input card-input--full" placeholder="{{\'purchase.cardholder\' | translate}}" ng-model="vm.card.holder" card-holder="" required=""><div class="card-info clearfix"><div class="card-info__date"><div class="card-info__text">{{\'purchase.validity\' | translate}}</div><input type="text" class="card-input card-input--date" placeholder="\u041C\u041C / YY" ng-model="vm.card.date" card-date="" required=""></div><div class="card-info__cvv"><div class="card-info__text">{{\'purchase.security\' | translate}}</div><input type="text" class="card-input card-input--cvv" placeholder="CVV" ng-model="vm.card.cvv" card-cvv="" required=""></div></div><button type="submit" ng-disabled="paymentForm.$invalid || vm.dataLoading" class="payment-form__button">{{\'purchase.buy\' | translate}}</button> <img ng-if="vm.dataLoading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="><div class="payment-form__agreement">{{\'purchase.subscription\' | translate}}</div></div></div></div>');
$templateCache.put('app/pages/profile/purchase/purchase.html','<div class="purchase-page" ng-controller="purchaseCtrl as vm"><div class="purchase-inner"><div class="purchase-inner"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left purchase-panel"><div class="purchase-body"><div class="panel-content"><div class="header">{{\'purchase.title\' | translate}}</div><div class="row"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><form name="paymentForm" ng-submit="vm.payment()"><div class="container group"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 tiles"><div class="tile"><div class="row"><div class="plan"><div class="col-xlg-9 col-lg-9 col-md-9 col-sm-12 col-xs-12"><p ng-if="vm.products.Name"><span class="plan-title">{{vm.products.Name}} Plan</span> <span class="plan">Plan</span></p><div class="description"><p><strong style="text-transform:capitalize;">{{vm.products.Name}}</strong> Plan</p><p><strong>Subscription period is {{vm.products.Period}}</strong> {{vm.products.Plan}}</p><p><strong>Subscription Total Price</strong> ${{vm.products.Total}}</p><p><strong>{{\'purchase.saving\' | translate}}</strong> ${{vm.products.Savings}}</p><p><strong>Your subscription Period</strong> From {{vm.expiry | date:\'mediumDate\'}} <span>To</span> {{vm.endDate | date:\'mediumDate\'}}</p></div></div><div class="col-xlg-3 col-lg-3 col-md-3 col-sm-12 col-xs-12"><p class="price" ng-if="vm.products.Monthlycost"><strong>${{vm.products.Total}}</strong><span>{{vm.products.Period}} Month/s<br>Inc Gst</span></p></div></div></div></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 tiles"><div class="tile"><div class="header-next">Next Payment</div><p>is Due By: {{vm.endDate | date:\'mediumDate\'}}</p><div ng-if="vm.detail.recurring == 0"><div class="renewal"><button ng-click="toggleSection()" class="button btn btn-default btn-bill">Manage Payment</button></div></div><div ng-if="vm.detail.recurring == 1"><div class="card-type__icons"><img ng-if="cardType === \'visa\'" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAUCAYAAAB1aeb6AAAAAXNSR0IArs4c6QAABABJREFUSA2VlW1ollUYx3/3NqduavlSyy3TTNecLy1RyxXMhBl9iJFazrcIIjKhzH2Q8MMMkdbLB0n60AsUZUQg+EItNPBjTjBMRytCnVubiZuxTXHNbe7ud/bwPDhm7dkFF+c+53r7n/+5zrkj/kNiiDQtUB9QJ6pX1HoX/3a8o8TfkEcmxWQ4xlxngGYqaTDGdMMlFBgiek1z4S11gzp9iBHTQZ36gYFHkrb4AM+bfrtwH3dtaM6YS658TS/vRRvpSMaEcYijhde49rk6KRhHkGM8y5ts5mOzlI3gG/beIfQXo0q+T/qmilt4q4sfqam1pNMdx4h2auhjFvlSnZ7Elo95JVo3uMFEIQuvNPpHNd00A2SbJkP/h43aqWao6Ugs4JinBPBTZOEsY35VQ5r0pJAT7KA05TzGr5zUbOSPmLP8xuJQfJ3e344ckfIY4C6xR7exdI+2d1L29D5iKsKuVzNvHpSX22r22qZN0NQER48OT5KbC1MnNLLjypxhxpuu3LdMfRrajnshTwxzSS3Mtr0ufvJc2Hkj1dUPsmuXMFbDwYOwd69n6CGGYnv2wNq1sHAhXLjgffBCrF8PVVVw3CKtrbDMoouuwsYPoXm/hetgymMeqGdx3h7Or4DO03D3Yui/7gF7k2vzGzLfhnfZujWLMR5cXp4BklFbK6RGWLUKiopgyxaoqYEVK6ChwQazw+osUF0NN91yZaVAvZ03vtOurftPW1fgecZPmAuzX/WF6JU1AY0vEECX7H6VFXq0h/nz4bTIZs6Evj4o0GHbtsRYXw8nTybm4XgOHYI5sh6YCDsvLobduwUt+O4m0yn3vwBzjQ+FMsfBJdnMMXfjp9BxCq79Hrx6MsjObmW6D9m5c3D4cCJxfr40dYp0KsyYAe3tMHlyYl5WlqC/pycREwCdOQN/GFuyD0rd/RSPobcDxk6zuNR3au9Si2Vq7na4bq3MiX9FcU7OPtG/TlubtN2AwsIEtWFHYR4kgDsl4gCqvz8m93LEo6Xu6KKF7oVfbK43bpl4aWKnnWd9I43vNz6SkX9aZLRL3yWO1zwq+6Pvxvuh4TwI5HUUstkmncXsVIQEIcOjkPDUlAw+pQKQMypGEXyLRd7z5EO8xkjZT1vizAOXx5e8lCwun8ir73S6spyfWc4SigywHUYhzXSPf+J8V8HVJHafLEpM8IPqAacpj0j/TukPdyYdiWmhn2eiDTQE91SYKGxH7JhBAMH2f9Kp8bXoLA85VoncLhpRjlh4abJw8E7t/PZQWXjSue8s5ap3DVt2sEAA6F3iMwNt34TEXzLVH8vLzioEssCskxx7nbc4HlP3+x8fXVOH1AIJN2Js+E5X4i8YF+JG8v8X5UMlkwCffwoAAAAASUVORK5CYII=" class="card-type__icon"><img ng-if="cardType === \'mastercard\'" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAOCAYAAABZ/o57AAAAAXNSR0IArs4c6QAABLJJREFUSA2tVk1sVFUUPue+9+ZHZ94wibWmBTL2tSCVxBjF8LOQhUsWmmriQsPCNGFDGlphYYiZBGOt2EwLJhhjUNxIohsShVaDRhMrMUGjFVDT6Q8goRqhPzOlPzPv+p335s5MBVZ6knfP7z333PNzZziWyWVIl5jqwLapWMjv/7NOFJJN2Xti0USDkS9O/H4t3uw12vHIOpH5ZX+hONHzk9EHOJONJfxEi7KdDHHZ98m6WsjfvEiU9VfZCdPyRipO8ZSQt4rLf9P0/qLQAiqiVHvEiRyKOpGf8Y3LZ3FkOtU6cDw0qa1ufE1v1HIm5Yso5xxRE9ux6EFFakQ+y7LfNNap9b3plJfrS9npaSviXGBFnzFbZyym0ZSXHjZ2BrvewLGUis9EFE3J5yadA0YnWM2Nd52eG+t6YXbhZmNZ65Oa9LIotKbddF9fUugAkBkmftGwMDiGrCyjFJurMp9+CeiGbEI78WFiJYe5Vb0hWE8ZUrCb6d/KzHvqZaC31fOqylzLLljEb5HmeU2Ux0aVSNmPG72rUh3ElBYe+iWfV94RGsFXA4U8CDTppvZg/xbRAwo++Z3oiy0ln57ytT5Q9vXpUBWubNs99bzQrPkJJKIan11vMJvv+sFtHfRZ6yaYTjHZcthXwUalOqu22j8pPRz3+tch0qCnAhvSQaCKeIexRYWuzI/NfijZr8jOGp1gmRFU7xmWKdH6MvxZOLtZ/Ca8dHshH16+GnFlM5KiUTKOg3CZ9SMiT7b0bwB6smJDpZI/KLRDqpZNRDRXXLkY2vCYsUXGN7leejTRMtBhZPU4YnMXgkRwOJnpAyD0fghMulr+fweK0dVDYobNaa11MM2K7Vo2SX+zMNXzo9jourLjUhNmSvVSuRdxXxIbAfjaYCn+xPUGv403960NpVgx5UjkS8LjLH+5XDrua/rO6BXX+vS2QP2FW5+jFEioHMDb4s1H1uKmu81m9FeQzUBfN0jYEw4SFHNXu2/MjeUfxdmH4GjJ7EXA251Y9EuivVGRJTmKBLAZ2C8WJ17GkOlqRpGIu2e0cP2Vv2B8XhyhbLYT06/j1uHbqWmqMD5ySnQCkNdKXxmkUCPr0aW5/L5XV3SpDZcIqiRSXL7NbfV2omdt9PJekQnA12Vk/HmQbYFAFk0b5ZkT8raMihBQ55iqTxKm922ij8uhSTCRm0I6uNRoQGdya4xM8K18zxUEcbBehjIX0LfPIur1VTlzJzL+kWL1vpGBZ+3Etgq/auqNASo/BJtVznG94nyZ3jM2bkvaQxrihsfPTFB611bD7A1iOPyzWvN19O4DaJ0OBBsAfN+Yz1/63vXac0EejYO7Yyn/mTsGOp8fOZfydszgxtXsoNdO0OS+GeMPh2+uHU4rhfyF36BDEvTDWO9FsR4DIyIpawBogUXt+08nH3xIHnjzzlK5VN5ZwnNYMaOIxbugPyo8kwr69I6BSnk1bUcv8i5kEjFiLdMRwQbQMw1Q/BrwWo8TvbtCjYcRIA1hh7yjjUHp5I+E5j+QyVPLZZ1bnOyexM/lCfTfbOhLny9Mdn8d0pU1k/s0avFrFf1GYHPXVWb/E5O1E97h+4meC97I/+r0H2FHmUxT7+LTAAAAAElFTkSuQmCC" class="card-type__icon"></div></div><div class="row auto-renewal"><div class="col-xlg-8 col-lg-8 col-md-8 col-sm-12 col-xs-12"><h3>Enable Auto Renewal</h3><p>This option if checked, will renew your Callio Subscription once expires</p></div><div class="col-xlg-4 col-lg-4 col-md-4 col-sm-12 col-xs-12"><ba-switcher switcher-style="primary" switcher-value="vm.detail.recurring"></ba-switcher></div></div></div><div ng-show="isSectionVisible"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 tiles"><div class="tile"><div class="payment-form" name="paymentForm"><div class="notification"><img src="data:image/png;base64,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" class="notification__icon"> <span class="notification__text">{{\'purchase.noitfypaymentdescription\' | translate}}</span></div><div class="card-type clearfix"><div class="card-type__label">{{\'purchase.carddetails\' | translate}}</div></div><div class="card-info clearfix"><div class="card-holder"><stripe-card-element on-ready="vm.handleCardReady(card)"></stripe-card-element></div></div><button type="submit" ng-disabled="paymentForm.$invalid || vm.dataLoading" class="payment-form__button">{{\'purchase.buy\' | translate}}</button> <img ng-if="vm.dataLoading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="><div class="payment-form__agreement">{{\'purchase.subscription\' | translate}}</div></div></div></div></div></div></div></form></div></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/profile/upload/profileModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Add Account</h4></div><form name="linkForm"><div class="modal-body"><p>Paste a link to your profile into the box below</p><div class="form-group"><input type="text" class="form-control" placeholder="Link to Profile" ng-model="link"></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="ok(link)">Save changes</button></div></form></div>');
$templateCache.put('app/pages/profile/view/view.html','<div ba-panel="" ba-panel-class="profile-page"><div class="panel-content"><div class="header">General Information</div><div class="row"><div class="col-md-6"><div class="col-md-6"><div class="form-group clearfix"><label for="inputFirstName" class="control-label">First Name</label> <input type="text" class="form-control" id="inputFirstName" placeholder="" value="Anastasiya"></div></div><div class="col-md-6"><div class="form-group clearfix"><label for="inputLastName" class="control-label">Last Name</label> <input type="text" class="form-control" id="inputLastName" placeholder="" value=""></div></div><div class="col-md-6"><div class="form-group clearfix"><label for="inputEmail" class="control-label">Email Address</label> <input type="text" class="form-control" id="inputLastName" placeholder="" value=""></div></div><div class="col-md-6"><div class="form-group clearfix"><label for="inputLastName" class="control-label">Mobile Number</label> <input type="text" class="form-control" id="inputLastName" placeholder="" value=""></div></div><div class="col-md-6"><div class="form-group clearfix"><label class="control-label">Role</label><select class="form-control" title="Standard Select" selectpicker=""><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Picture</label><div class="col-sm-9"><div class="userpic"><div class="userpic-wrapper"><img ng-src="{{ picture }}" ng-click="uploadPicture()"></div><i class="ion-ios-close-outline" ng-click="removePicture()" ng-if="!noPicture"></i> <a href="" class="change-userpic" ng-click="uploadPicture()">Change Profile Picture</a> <input type="file" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"></div></div></div></div></div><div class="header">Change Password</div><div class="row"><div class="col-md-6"><div class="col-md-6"><div class="form-group"><input type="password" class="form-control" ng-model="vm.password" placeholder="Password" name="password" required="required" ng-minlength="6"><div ng-if="passwordForm.password.$touched || signupSubmitted"><p ng-show="passwordForm.password.$error.required" class="help-block">Password is required</p><p ng-show="passwordForm.password.$error.minlength" class="help-block">Minimum 6 character</p></div></div></div><div class="col-md-6"><div class="form-group"><input type="password" class="form-control" name="confirm_password" ng-model="vm.confirm_password" placeholder="Confirm password" match-password="password" required=""><div ng-if="passwordForm.confirm_password.$touched || signupSubmitted"><p ng-show="passwordForm.confirm_password.$error.required" class="help-block">Confirm password is required</p><p ng-show="passwordForm.confirm_password.$error.matchPassword && !passwordForm.confirm_password.$error.required" class="help-block">Confirm password didn\'t match</p></div></div></div></div></div><h3 class="with-line">Contact Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputEmail3" class="col-sm-3 control-label">Email</label><div class="col-sm-9"><input type="email" class="form-control" id="inputEmail3" placeholder="" value="contact@akveo.com"></div></div><div class="form-group row clearfix"><label for="inputPhone" class="col-sm-3 control-label">Phone</label><div class="col-sm-9"><input type="text" class="form-control" id="inputPhone" placeholder="" value="+1 (23) 456 7890"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Office Location</label><div class="col-sm-9"><select class="form-control" title="Standard Select" selectpicker=""><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div><div class="form-group row clearfix"><label for="inputRoom" class="col-sm-3 control-label">Room</label><div class="col-sm-9"><input type="text" class="form-control" id="inputRoom" placeholder="" value="303"></div></div></div></div><h3 class="with-line">Social Profiles</h3><div class="social-profiles row clearfix"><div class="col-md-3 col-sm-4" ng-repeat="item in socialProfiles"><a class="sn-link" href="" ng-click="showModal(item)" ng-if="!item.href"><i class="socicon {{ item.icon }}"></i> <span>{{ item.name }}</span></a> <a class="sn-link connected" href="{{ item.href }}" target="_blank" ng-if="item.href"><i class="socicon {{ item.icon }}"></i> <span>{{ item.name }}</span> <em class="ion-ios-close-empty sn-link-close" ng-mousedown="unconnect(item)"></em></a></div></div><h3 class="with-line">Send Email Notifications</h3><div class="notification row clearfix"><div class="col-sm-6"><div class="form-group row clearfix"><label class="col-xs-8">When I receive a message</label><div class="col-xs-4"><switch color="primary" ng-model="switches[0]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">When Someone sends me an invitation</label><div class="col-xs-4"><switch color="primary" ng-model="switches[1]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">When profile information changes</label><div class="col-xs-4"><switch color="primary" ng-model="switches[2]"></switch></div></div></div><div class="col-sm-6"><div class="form-group row clearfix"><label class="col-xs-8">When anyone logs into your account from a new device or browser</label><div class="col-xs-4"><switch color="primary" ng-model="switches[3]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">Weekly Reports</label><div class="col-xs-4"><switch color="primary" ng-model="switches[4]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">Daily Reports</label><div class="col-xs-4"><switch color="primary" ng-model="switches[5]"></switch></div></div></div></div><button type="button" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Update Profile</button></div></div>');
$templateCache.put('app/pages/register/card/card.html','<div class="payment-form" name="paymentForm"><div class="radio-toggles"><input type="radio" id="option-1" name="radio-options" ng-model="vm.radioValue" value="one-time"> <label for="option-1">One-Time</label> <input type="radio" id="option-2" name="radio-options" ng-model="vm.radioValue" value="recurring" checked=""> <label for="option-2">Recurring</label><div class="slide-item"></div></div><div class="notification"><p class="notification__text">{{\'purchase.noitfypaymentdescription\' | translate}}</p></div><div class="card-type clearfix"><div class="card-type__label">{{\'purchase.carddetails\' | translate}}</div><div class="card-type__icons"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAOCAYAAABZ/o57AAAAAXNSR0IArs4c6QAABLJJREFUSA2tVk1sVFUUPue+9+ZHZ94wibWmBTL2tSCVxBjF8LOQhUsWmmriQsPCNGFDGlphYYiZBGOt2EwLJhhjUNxIohsShVaDRhMrMUGjFVDT6Q8goRqhPzOlPzPv+p335s5MBVZ6knfP7z333PNzZziWyWVIl5jqwLapWMjv/7NOFJJN2Xti0USDkS9O/H4t3uw12vHIOpH5ZX+hONHzk9EHOJONJfxEi7KdDHHZ98m6WsjfvEiU9VfZCdPyRipO8ZSQt4rLf9P0/qLQAiqiVHvEiRyKOpGf8Y3LZ3FkOtU6cDw0qa1ufE1v1HIm5Yso5xxRE9ux6EFFakQ+y7LfNNap9b3plJfrS9npaSviXGBFnzFbZyym0ZSXHjZ2BrvewLGUis9EFE3J5yadA0YnWM2Nd52eG+t6YXbhZmNZ65Oa9LIotKbddF9fUugAkBkmftGwMDiGrCyjFJurMp9+CeiGbEI78WFiJYe5Vb0hWE8ZUrCb6d/KzHvqZaC31fOqylzLLljEb5HmeU2Ux0aVSNmPG72rUh3ElBYe+iWfV94RGsFXA4U8CDTppvZg/xbRAwo++Z3oiy0ln57ytT5Q9vXpUBWubNs99bzQrPkJJKIan11vMJvv+sFtHfRZ6yaYTjHZcthXwUalOqu22j8pPRz3+tch0qCnAhvSQaCKeIexRYWuzI/NfijZr8jOGp1gmRFU7xmWKdH6MvxZOLtZ/Ca8dHshH16+GnFlM5KiUTKOg3CZ9SMiT7b0bwB6smJDpZI/KLRDqpZNRDRXXLkY2vCYsUXGN7leejTRMtBhZPU4YnMXgkRwOJnpAyD0fghMulr+fweK0dVDYobNaa11MM2K7Vo2SX+zMNXzo9jourLjUhNmSvVSuRdxXxIbAfjaYCn+xPUGv403960NpVgx5UjkS8LjLH+5XDrua/rO6BXX+vS2QP2FW5+jFEioHMDb4s1H1uKmu81m9FeQzUBfN0jYEw4SFHNXu2/MjeUfxdmH4GjJ7EXA251Y9EuivVGRJTmKBLAZ2C8WJ17GkOlqRpGIu2e0cP2Vv2B8XhyhbLYT06/j1uHbqWmqMD5ySnQCkNdKXxmkUCPr0aW5/L5XV3SpDZcIqiRSXL7NbfV2omdt9PJekQnA12Vk/HmQbYFAFk0b5ZkT8raMihBQ55iqTxKm922ij8uhSTCRm0I6uNRoQGdya4xM8K18zxUEcbBehjIX0LfPIur1VTlzJzL+kWL1vpGBZ+3Etgq/auqNASo/BJtVznG94nyZ3jM2bkvaQxrihsfPTFB611bD7A1iOPyzWvN19O4DaJ0OBBsAfN+Yz1/63vXac0EejYO7Yyn/mTsGOp8fOZfydszgxtXsoNdO0OS+GeMPh2+uHU4rhfyF36BDEvTDWO9FsR4DIyIpawBogUXt+08nH3xIHnjzzlK5VN5ZwnNYMaOIxbugPyo8kwr69I6BSnk1bUcv8i5kEjFiLdMRwQbQMw1Q/BrwWo8TvbtCjYcRIA1hh7yjjUHp5I+E5j+QyVPLZZ1bnOyexM/lCfTfbOhLny9Mdn8d0pU1k/s0avFrFf1GYHPXVWb/E5O1E97h+4meC97I/+r0H2FHmUxT7+LTAAAAAElFTkSuQmCC" class="card-type__icon card-type__icon--disabled" ng-class="{\'card-type__icon--disabled\': !isVisa()}"> <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAUCAYAAAB1aeb6AAAAAXNSR0IArs4c6QAABABJREFUSA2VlW1ollUYx3/3NqduavlSyy3TTNecLy1RyxXMhBl9iJFazrcIIjKhzH2Q8MMMkdbLB0n60AsUZUQg+EItNPBjTjBMRytCnVubiZuxTXHNbe7ud/bwPDhm7dkFF+c+53r7n/+5zrkj/kNiiDQtUB9QJ6pX1HoX/3a8o8TfkEcmxWQ4xlxngGYqaTDGdMMlFBgiek1z4S11gzp9iBHTQZ36gYFHkrb4AM+bfrtwH3dtaM6YS658TS/vRRvpSMaEcYijhde49rk6KRhHkGM8y5ts5mOzlI3gG/beIfQXo0q+T/qmilt4q4sfqam1pNMdx4h2auhjFvlSnZ7Elo95JVo3uMFEIQuvNPpHNd00A2SbJkP/h43aqWao6Ugs4JinBPBTZOEsY35VQ5r0pJAT7KA05TzGr5zUbOSPmLP8xuJQfJ3e344ckfIY4C6xR7exdI+2d1L29D5iKsKuVzNvHpSX22r22qZN0NQER48OT5KbC1MnNLLjypxhxpuu3LdMfRrajnshTwxzSS3Mtr0ufvJc2Hkj1dUPsmuXMFbDwYOwd69n6CGGYnv2wNq1sHAhXLjgffBCrF8PVVVw3CKtrbDMoouuwsYPoXm/hetgymMeqGdx3h7Or4DO03D3Yui/7gF7k2vzGzLfhnfZujWLMR5cXp4BklFbK6RGWLUKiopgyxaoqYEVK6ChwQazw+osUF0NN91yZaVAvZ03vtOurftPW1fgecZPmAuzX/WF6JU1AY0vEECX7H6VFXq0h/nz4bTIZs6Evj4o0GHbtsRYXw8nTybm4XgOHYI5sh6YCDsvLobduwUt+O4m0yn3vwBzjQ+FMsfBJdnMMXfjp9BxCq79Hrx6MsjObmW6D9m5c3D4cCJxfr40dYp0KsyYAe3tMHlyYl5WlqC/pycREwCdOQN/GFuyD0rd/RSPobcDxk6zuNR3au9Si2Vq7na4bq3MiX9FcU7OPtG/TlubtN2AwsIEtWFHYR4kgDsl4gCqvz8m93LEo6Xu6KKF7oVfbK43bpl4aWKnnWd9I43vNz6SkX9aZLRL3yWO1zwq+6Pvxvuh4TwI5HUUstkmncXsVIQEIcOjkPDUlAw+pQKQMypGEXyLRd7z5EO8xkjZT1vizAOXx5e8lCwun8ir73S6spyfWc4SigywHUYhzXSPf+J8V8HVJHafLEpM8IPqAacpj0j/TukPdyYdiWmhn2eiDTQE91SYKGxH7JhBAMH2f9Kp8bXoLA85VoncLhpRjlh4abJw8E7t/PZQWXjSue8s5ap3DVt2sEAA6F3iMwNt34TEXzLVH8vLzioEssCskxx7nbc4HlP3+x8fXVOH1AIJN2Js+E5X4i8YF+JG8v8X5UMlkwCffwoAAAAASUVORK5CYII=" class="card-type__icon card-type__icon--disabled" ng-class="{\'card-type__icon--disabled\': !isMasterCard()}"></div></div><div class="card-holder"><div id="card-element"></div><div id="card-errors"></div></div><div class="card-info clearfix"></div><button type="submit" ng-disabled="multiStepForm.$invalid" class="button btn btn-default btn-auth">{{\'purchase.buy\' | translate}}</button> <button type="button" class="btn btn-primary" ng-click="next(\'stage1\')">Back</button><div class="payment-form__agreement">By clicking on the Buy Now button, you consent to recurring subscription payments for the particular plan you selected.</div></div>');
$templateCache.put('app/pages/sites/list/list.html','<div class="site-page row" ng-controller="sitesListCtrl as vm"><div ba-panel="" ba-panel-title="Site List"><div class="pull-right back"><a ui-sref="main.sites.new"><span translate="">sitelist.addnewsite</span> <i class="fa fa-plus" aria-hidden="true"></i></a></div><sites-list></sites-list><sites-filter></sites-filter></div></div>');
$templateCache.put('app/pages/sites/edit/edit.html','<div ng-controller="sitesEditCtrl as vm"></div>');
$templateCache.put('app/pages/sites/view/view.html','<div ng-controller="sitesViewCtrl as vm"></div>');
$templateCache.put('app/pages/sites/new/new.html','<div class="checkpoint-page" ng-controller="sitesNewCtrl as vm"><div ba-panel="" ba-panel-title="{{ \'newsites\' | translate }}"><div class="pull-right back"><a ui-sref="main.checkpoints.list" class="newlink">{{\'checkpointnewpage.back\' | translate}} <i class="fa fa-chevron-right" aria-hidden="true"></i></a></div><form name="form" ng-submit="vm.create()" role="form"><div class="checkpoint-inner"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 pull-left checkpoint-panel"><div class="checkpoint-body"><div class="panel-content"><div class="header">{{\'sitenewpage.information\' |translate }}</div><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{ \'has-error\': form.name.$dirty && form.name.$error.required }"><label for="name" translate="">sitenewpage.name</label> <input type="text" name="name" id="name" class="form-control" ng-model="vm.name" placeholder="Add a site name" required=""> <span ng-show="form.name.$dirty && form.name.$error.required" class="help-block" translate="">sitenewpage.namereg</span></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{ \'has-error\': form.phone.$dirty && form.phone.$error.required }"><label for="phone" translate="">sitenewpage.phone</label> <input type="text" name="phone" id="phone" class="form-control" ng-model="vm.phone" placeholder="example (123) 555-6789" required=""> <span ng-show="form.phone.$dirty && form.phone.$error.required" class="help-block" translate="">sitenewpage.phone</span></div></div></div><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{ \'has-error\': form.contact.$dirty && form.contact.$error.required }"><label for="contact" translate="">sitenewpage.contact</label> <input type="text" name="contact" id="contact" class="form-control" ng-model="vm.contact" placeholder="Add a site contact" required=""> <span ng-show="form.contact.$dirty && form.contact.$error.required" class="help-block" translate="">sitenewpage.contact</span></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><label class="control-label" translate="">sitenewpage.client</label><select name="category-group" id="categoryGroup" ng-model="vm.selectedClientId" class="form-control selectpicker" ng-change="onCategoryChange(itemSelected)" ng-options="client.id as client.name for client in vm.clients" selectpicker=""></select></div></div></div></div></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 pull-right checkpoint-panel"><div class="checkpoint-body"><div class="panel-content"><div class="header">Checkpoint Geolocation</div><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><label for="inputWebsite" translate="">checkpointnewpage.checkpointaddress</label> <input id="mapDetails" class="form-control" places-auto-complete="" size="80" ng-model="vm.address" on-place-changed="vm.placeChanged()"><div ng-show="vm.place">Address = {{vm.place.formatted_address}}<br>Location: {{vm.place.geometry.location}}<br>zipcode: {{vm.zipcode}}<br>country: {{vm.country}}<br>state: {{vm.state}}<br>city: {{vm.city}}<br></div></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><label for="checkpointgeo" translate="">checkpointnewpage.checkpointgeo</label><md-slider-container class="slider-left" ng-disabled="vm.isDisabled"><md-slider ng-model="vm.radius" ng-change="vm.onRadiusChange()" aria-label="Disabled 1" flex="" md-discrete="" min="5" max="500"></md-slider></md-slider-container><md-checkbox class="slider-right" ng-model="vm.isDisabled">{{\'checkpointnewpage.disabled\' | translate}}</md-checkbox></div></div></div><div class="row"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="form-group"><leaflet lf-center="siteCenter" paths="paths" layers="layers" tiles="tiles" markers="markers" height="370px" width="100%"></leaflet></div></div></div></div></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 pull-left checkpoint-panel"><div class="checkpoint-body"><div class="panel-content"><div class="header">Site Extra Notes Task</div><div class="row"><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="form-group"><label for="extra" translate="">profilepage.extra</label> <textarea placeholder="Extra Notes" class="form-control" id="extra" ng-model="vm.extra"></textarea></div></div></div></div></div></div><div class="row col-sm-12"><form-builder form="vm.form"></form-builder></div><div class="row col-sm-12"><div class="form-actions pull-right"><button type="submit" ng-disabled="form.$invalid || vm.dataLoading" class="btn btn-primary" translate="">checkpointnewpage.checkpointbutton</button> <img ng-if="vm.dataLoading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="></div></div></div></form></div></div>');
$templateCache.put('app/pages/ui/alerts/alerts.html','<div class="widgets"><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Basic" ba-panel-class="with-scroll"><div><div class="alert bg-success"><strong>Well done!</strong> You successfully read this important alert message.</div><div class="alert bg-info"><strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class="alert bg-warning"><strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class="alert bg-danger"><strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Dismissible alerts" ba-panel-class="with-scroll"><div><div class="alert bg-success closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Well done!</strong> You successfully read this important alert message.</div><div class="alert bg-info closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class="alert bg-warning closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class="alert bg-danger closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Links in alerts" ba-panel-class="with-scroll"><div><div class="alert bg-success"><strong>Well done!</strong> You successfully read <a href="" class="alert-link">this important alert message</a>.</div><div class="alert bg-info"><strong>Heads up!</strong> This <a href="" class="alert-link">alert needs your attention</a>, but it\'s not super important.</div><div class="alert bg-warning"><strong>Warning!</strong> Better check yourself, you\'re <a href="" class="alert-link">not looking too good</a>.</div><div class="alert bg-danger"><strong>Oh snap!</strong> <a href="" class="alert-link">Change a few things up</a> and try submitting again.</div></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Composite alerts" ba-panel-class="with-scroll"><div><div class="alert bg-warning"><h4>Warning!</h4><strong>Pay attention.</strong> Change a few things up and try submitting again.<div class="control-alert"><button type="button" class="btn btn-danger">Pay Attention</button> <button type="button" class="btn btn-primary">Ignore</button></div></div></div></div></div></div>');
$templateCache.put('app/pages/ui/buttons/buttons.html','<div class="widgets"><div class="row"><div class="col-md-3" ba-panel="" ba-panel-title="Flat Buttons" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Raised Buttons" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default btn-raised">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary btn-raised">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success btn-raised">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info btn-raised">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning btn-raised">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger btn-raised">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Different sizes" ba-panel-class="with-scroll button-panel df-size-button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default btn-xs">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary btn-sm">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success btn-mm">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info btn-md">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning btn-xm">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger btn-lg">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Disabled" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default" disabled="disabled">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary" disabled="disabled">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success" disabled="disabled">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info" disabled="disabled">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning" disabled="disabled">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger" disabled="disabled">Danger</button></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Icon Buttons" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/iconButtons.html\'"></div></div><div ba-panel="" ba-panel-title="Large Buttons" ba-panel-class="with-scroll large-buttons-panel"><div ng-include="\'app/pages/ui/buttons/widgets/largeButtons.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Button Dropdowns" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/dropdowns.html\'"></div></div><div ba-panel="" ba-panel-title="Button Groups" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/buttonGroups.html\'"></div></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Progress Buttons" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/progressButtons.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/grid/baseGrid.html','<h4 class="grid-h">Stacked to horizontal</h4><div class="row show-grid"><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div></div><div class="row show-grid"><div class="col-md-8"><div>.col-md-8</div></div><div class="col-md-4"><div>.col-md-4</div></div></div><div class="row show-grid"><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4"><div>.col-md-4</div></div></div><div class="row show-grid"><div class="col-md-6"><div>.col-md-6</div></div><div class="col-md-6"><div>.col-md-6</div></div></div><h4 class="grid-h">Mobile and desktop</h4><div class="row show-grid"><div class="col-xs-12 col-md-8"><div>xs-12 .col-md-8</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6"><div>.col-xs-6</div></div><div class="col-xs-6"><div>.col-xs-6</div></div></div><h4 class="grid-h">Mobile, tablet, desktop</h4><div class="row show-grid"><div class="col-xs-12 col-sm-6 col-md-8"><div>.col-xs-12 .col-sm-6 .col-md-8</div></div><div class="col-xs-6 col-md-4"><div>.col-xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div><div class="clearfix visible-xs-block"></div><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div></div><h4 class="grid-h">Column wrapping</h4><div class="row show-grid"><div class="col-xs-9"><div>.col-xs-9</div></div><div class="col-xs-4"><div>.col-xs-4<br>Since 9 + 4 = 13 &gt; 12, this 4-column-wide div gets wrapped onto a new line as one contiguous unit.</div></div><div class="col-xs-6"><div>.col-xs-6<br>Subsequent columns continue along the new line.</div></div></div><h4 class="grid-h">Responsive column resets</h4><div class="row show-grid"><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3<p>Resize your viewport or check it out on your phone for an example.</p></div></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div><div class="clearfix visible-xs-block"></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div></div><h4 class="grid-h">Offsetting columns</h4><div class="row show-grid"><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4 col-md-offset-4"><div>.col-md-4 .col-md-offset-4</div></div></div><div class="row show-grid"><div class="col-md-3 col-md-offset-3"><div>.col-md-3 .col-md-offset-3</div></div><div class="col-md-3 col-md-offset-3"><div>.col-md-3 .col-md-offset-3</div></div></div><div class="row show-grid"><div class="col-md-6 col-md-offset-3"><div>.col-md-6 .col-md-offset-3</div></div></div><h4 class="grid-h">Grid options</h4><div class="table-responsive"><table class="table table-bordered table-striped"><thead><tr><th></th><th>Extra small devices <small>Phones (&lt;768px)</small></th><th>Small devices <small>Tablets (\u2265768px)</small></th><th>Medium devices <small>Desktops (\u2265992px)</small></th><th>Large devices <small>Desktops (\u22651200px)</small></th></tr></thead><tbody><tr><th class="text-nowrap" scope="row">Grid behavior</th><td>Horizontal at all times</td><td colspan="3">Collapsed to start, horizontal above breakpoints</td></tr><tr><th class="text-nowrap" scope="row">Container width</th><td>None (auto)</td><td>750px</td><td>970px</td><td>1170px</td></tr><tr><th class="text-nowrap" scope="row">Class prefix</th><td><code>.col-xs-</code></td><td><code>.col-sm-</code></td><td><code>.col-md-</code></td><td><code>.col-lg-</code></td></tr><tr><th class="text-nowrap" scope="row"># of columns</th><td colspan="4">12</td></tr><tr><th class="text-nowrap" scope="row">Column width</th><td class="text-muted">Auto</td><td>~62px</td><td>~81px</td><td>~97px</td></tr><tr><th class="text-nowrap" scope="row">Gutter width</th><td colspan="4">30px (15px on each side of a column)</td></tr><tr><th class="text-nowrap" scope="row">Nestable</th><td colspan="4">Yes</td></tr><tr><th class="text-nowrap" scope="row">Offsets</th><td colspan="4">Yes</td></tr><tr><th class="text-nowrap" scope="row">Column ordering</th><td colspan="4">Yes</td></tr></tbody></table></div>');
$templateCache.put('app/pages/ui/grid/grid.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Inline Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/grid/baseGrid.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/modals/modals.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Modals" ba-panel-class="with-scroll"><div class="modal-buttons clearfix"><button type="button" class="btn btn-primary" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/basicModal.html\', \'md\')">Default modal</button> <button type="button" class="btn btn-success" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/largeModal.html\', \'lg\')">Large modal</button> <button type="button" class="btn btn-warning" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/smallModal.html\', \'sm\')">Small modal</button></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Message Modals" ba-panel-class="with-scroll"><div class="modal-buttons same-width clearfix"><button type="button" class="btn btn-success" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/successModal.html\')">Success Message</button> <button type="button" class="btn btn-info" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/infoModal.html\')">Info Message</button> <button type="button" class="btn btn-warning" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/warningModal.html\')">Warning Message</button> <button type="button" class="btn btn-danger" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/dangerModal.html\')">Danger Message</button></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Notifications" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/modals/notifications/notifications.html\'"></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Progress dialogs" ba-panel-class="with-scroll"><div class="modal-buttons same-width clearfix"><button type="button" class="btn btn-info" data-toggle="modal" ng-click="openProgressDialog()">Progress dialog</button></div></div></div></div>');
$templateCache.put('app/pages/ui/icons/icons.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Kameleon SVG Icons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/kameleon.html"></div></div><div ba-panel="" ba-panel-title="Socicon" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/socicon.html"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Icons With Rounded Background" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/kameleonRounded.html"></div></div><div ba-panel="" ba-panel-title="ionicons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/ionicons.html"></div></div><div ba-panel="" ba-panel-title="Font Awesome Icons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/fontAwesomeIcons.html"></div></div></div></div></div>');
$templateCache.put('app/pages/ui/panels/panels.html','<h2>Default panels</h2><div class="row"><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-class="xsmall-panel light-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ac mi erat. Phasellus placerat, elit a laoreet semper, enim ipsum ultricies orci, ac tincidunt tellus massa eu est. Nam non porta purus, sed facilisis justo. Nam pulvinar sagittis quam.</div></div><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-title="Panel with header" ba-panel-class="xsmall-panel light-text">Phasellus maximus venenatis augue, et vestibulum neque aliquam ut. Morbi mattis libero vitae vulputate dignissim. Praesent placerat, sem non dapibus cursus, lacus nisi blandit quam, vitae porttitor lectus lacus non turpis. Donec suscipit consequat tellus.</div></div><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-title="Panel with header & scroll" ba-panel-class="xsmall-panel with-scroll light-text"><p>Suspendisse nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Sed dapibus, purus vel hendrerit consectetur, lectus orci gravida massa, sed bibendum dui mauris et eros. Nulla dolor massa, posuere et dictum sit amet, dignissim quis odio. Fusce mollis finibus dignissim. Integer sodales augue erat. Pellentesque laoreet vestibulum urna at iaculis. Nulla libero augue, euismod at diam eget, aliquam condimentum ligula. Donec a leo eu est molestie lacinia hendrerit sed lorem. Duis id diam eu metus sodales consequat vel eu elit. Praesent dolor nibh, convallis eleifend feugiat a, finibus porttitor nibh. Ut non libero vel velit pulvinar scelerisque non vel lorem. Integer porta tempor nulla. Sed nibh erat, ultrices vel lorem eu, rutrum vehicula sem.</p><p>Donec nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque fermentum nec ligula egestas rhoncus. Sed dignissim, augue vel scelerisque vulputate, nisi ante posuere lorem, quis iaculis eros dolor eu nisl. Etiam sagittis, ipsum ac tempor iaculis, justo neque mattis ante, ac maximus sapien risus eu sapien. Morbi erat urna, varius et lectus vel, porta dictum orci. Duis bibendum euismod elit, et lobortis purus venenatis in. Mauris eget lacus enim. Cras quis sem et magna fringilla convallis. Proin hendrerit nulla vel gravida mollis. Interdum et malesuada fames ac ante ipsum primis in faucibus. Vestibulum consectetur quis purus vel aliquam.</p></div></div></div><h2>Bootstrap panels</h2><div class="row"><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel xsmall-panel"><div class="panel-body"><p>A panel in bootstrap is a bordered box with some padding around its content.</p><p class="p-with-code">Panels are created with the <code>.panel</code> class, and content inside the panel has a <code>.panel-body</code> class. The <code>.panel-default .panel-primary .panel-danger</code> and other classes are used to style the color of the panel. See the next example on this page for more contextual classes.</p></div></div></div><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel xsmall-panel"><div class="panel-heading">Panel Heading</div><div class="panel-body"><p class="p-with-code">The <code>.panel-heading</code> class adds a heading to the panel.Easily add a heading container to your panel with .panel-heading. You may also include any <code>h1-h6</code> with a <code>.panel-title</code> class to add a pre-styled heading.</p></div></div></div><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel"><div class="panel-body footer-panel"><p class="p-with-code">Wrap buttons or secondary text in <code>.panel-footer</code>. Note that panel footers do not inherit colors and borders when using contextual variations as they are not meant to be in the foreground.</p></div><div class="panel-footer">Panel Footer</div></div></div></div><h2>Panels with Contextual Classes</h2><div class="row"><div class="col-md-6 col-lg-4"><div class="panel panel-default contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-default class</div><div class="panel-body">To color the panel, use contextual classes. This is sample <code>.panel-default</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-primary contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-primary class</div><div class="panel-body">Sample <code>.panel-primary</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-success contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-success class</div><div class="panel-body">Sample <code>.panel-success</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-info contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-info class</div><div class="panel-body">Sample <code>.panel-info</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-warning contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-warning class</div><div class="panel-body">Sample <code>.panel-warning</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-danger contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-danger class</div><div class="panel-body">Sample <code>.panel-danger</code> panel</div></div></div></div><div class="row"><div class="col-md-12"><h2>Panel Group</h2><div class="panel-group"><div class="panel panel-default bootstrap-panel"><div class="panel-heading">Panel group 1</div><div class="panel-body"><p>To group many panels together, wrap a <code>&lt;div&gt;</code> with class <code>\n            .panel-group</code> around them.</p></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">Panel group 2</div><div class="panel-body"><p>The <code>.panel-group</code> class clears the bottom-margin of each panel.</p></div></div></div></div></div>');
$templateCache.put('app/pages/ui/notifications/notifications.html','<div ba-panel="" ba-panel-class="with-scroll notification-panel"><div class="row"><div class="col-md-3 col-sm-4"><div class="control"><label for="title">Title</label> <input ng-model="options.title" type="text" class="form-control" id="title" placeholder="Enter a title ..."></div><div class="control"><label for="message">Message</label> <textarea ng-model="options.msg" class="form-control" id="message" rows="3" placeholder="Enter a message ..."></textarea></div><div class="control-group"><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.closeButton" type="checkbox" id="closeButton"> <span>Close Button</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.allowHtml" type="checkbox" id="html"> <span>Allow html</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.progressBar" type="checkbox" id="progressBar"> <span>Progress bar</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.preventDuplicates" type="checkbox" id="preventDuplicates"> <span>Prevent duplicates</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.preventOpenDuplicates" type="checkbox" id="preventOpenDuplicates"> <span>Prevent open duplicates</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.tapToDismiss" type="checkbox" id="tapToDismiss"> <span>Tap to dismiss</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.newestOnTop" type="checkbox" id="newestOnTop"> <span>Newest on top</span></label></div></div></div><div class="col-md-2 col-sm-3 toastr-radio-setup"><div id="toastTypeGroup"><div class="controls radio-controls"><label class="radio-header">Toast Type</label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="success"><span>Success</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="info"><span>Info</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="warning"><span>Warning</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="error"><span>Error</span></label></div></div><div id="positionGroup"><div class="controls radio-controls"><label class="radio-header position-header">Position</label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-right"> <span>Top Right</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-right"> <span>Bottom Right</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-left"> <span>Bottom Left</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-left"> <span>Top Left</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-full-width"> <span>Top Full Width</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-full-width"> <span>Bottom Full Width</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-center"> <span>Top Center</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-center"> <span>Bottom Center</span></label></div></div></div><div class="col-md-2 col-sm-3"><div class="control"><label for="timeOut">Time out</label> <input type="text" class="form-control" id="timeOut" ng-model="options.timeOut" placeholder="ms"> <label class="sub-label" for="timeOut">If you set it to 0, it will stick</label></div><div class="control"><label for="extendedTimeOut">Extended time out</label> <input type="text" class="form-control" id="extendedTimeOut" ng-model="options.extendedTimeOut" placeholder="ms"></div><div class="control"><label for="maxOpened">Maximum number of toasts</label> <input type="text" class="form-control" id="maxOpened" ng-model="options.maxOpened" value="0"> <label for="maxOpened" class="sub-label">0 means no limit</label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.autoDismiss" type="checkbox" id="autoDismiss"> <span>Auto dismiss</span></label></div></div><div class="col-md-5 col-sm-12"><label>Result:</label><pre class="result-toastr" id="toastrOptions">{{optionsStr}}</pre></div></div><div class="row"><div class="col-md-12 button-row"><button ng-click="openToast()" class="btn btn-primary">Open Toast</button> <button ng-click="openRandomToast()" class="btn btn-primary">Random Toast</button> <button ng-click="clearToasts()" class="btn btn-danger">Clear Toasts</button> <button ng-click="clearLastToast()" class="btn btn-danger">Clear Last Toast</button></div></div></div>');
$templateCache.put('app/pages/ui/progressBars/progressBars.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/basic.html\'"></div></div><div ba-panel="" ba-panel-title="Striped" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/striped.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="With label" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/label.html\'"></div></div><div ba-panel="" ba-panel-title="Animated" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/animated.html\'"></div></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Stacked" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/stacked.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/tabs/contextualAccordion.html','<uib-accordion><uib-accordion-group heading="Primary" panel-class="panel-primary bootstrap-panel accordion-panel">Primary <i class="ion-heart"></i></uib-accordion-group><uib-accordion-group heading="Success" panel-class="panel-success bootstrap-panel accordion-panel">Success <i class="ion-checkmark-round"></i></uib-accordion-group><uib-accordion-group heading="Info" panel-class="panel-info bootstrap-panel accordion-panel">Info <i class="ion-information-circled"></i></uib-accordion-group><uib-accordion-group heading="Warning" panel-class="panel-warning bootstrap-panel accordion-panel">Warning <i class="ion-alert"></i></uib-accordion-group><uib-accordion-group heading="Danger" panel-class="panel-danger bootstrap-panel accordion-panel">Danger <i class="ion-nuclear"></i></uib-accordion-group></uib-accordion>');
$templateCache.put('app/pages/ui/tabs/mainTabs.html','<uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Start"><p>Take up one idea. Make that one idea your life--think of it, dream of it, live on that idea. Let the brain, muscles, nerves, every part of your body, be full of that idea, and just leave every other idea alone. This is the way to success.</p><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed. Similarly, when someone is failing, the tendency is to get on a downward spiral that can even become a self-fulfilling prophecy.</p><div class="text-center"><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Shop\' | kameleonImg )}}"></div><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Programming\' | kameleonImg )}}"></div><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Dna\' | kameleonImg )}}"></div></div><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Getting Done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab ng-init="$dropdownTabActive = 1" class="with-dropdown"><uib-tab-heading uib-dropdown=""><a uib-dropdown-toggle="" ng-click="$event.stopPropagation()">Dropdown tab <i class="caret"></i></a><ul class="dropdown-menu" uib-dropdown-menu=""><li><a ng-click="$dropdownTabActive = 1; $tabSetStatus.activeTab = 3">Tab 1</a></li><li><a ng-click="$dropdownTabActive = 2; $tabSetStatus.activeTab = 3">Tab 2</a></li></ul></uib-tab-heading><div ng-show="$dropdownTabActive == 1"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></div><div ng-show="$dropdownTabActive == 2"><p class="text-center"><button class="btn btn-danger">I\'m just a dummy button</button></p></div></uib-tab></uib-tabset>');
$templateCache.put('app/pages/ui/tabs/sampleAccordion.html','<uib-accordion><uib-accordion-group is-open="true" heading="Static Header, initially expanded" panel-class="bootstrap-panel accordion-panel panel-default">This content is straight in the template.</uib-accordion-group><uib-accordion-group heading="Dynamic Body Content" panel-class="bootstrap-panel accordion-panel panel-default"><p>The body of the uib-accordion group grows to fit the contents</p><button type="button" class="btn btn-primary btn-sm">Add Item</button></uib-accordion-group><uib-accordion-group heading="Custom template" panel-class="bootstrap-panel accordion-panel panel-default">Hello</uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading>I can have markup, too! <i class="fa pull-right ion-settings"></i></uib-accordion-heading>This is just some content to illustrate fancy headings.</uib-accordion-group></uib-accordion>');
$templateCache.put('app/pages/ui/tabs/sideTabs.html','<div ba-panel="" ba-panel-class="tabs-panel xsmall-panel with-scroll"><uib-tabset class="tabs-left"><uib-tab heading="Start"><p class="text-center">Take up one idea.</p><div class="kameleon-icon-tabs kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Key\' | kameleonImg )}}"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading="Get it done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Achieve"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div><div ba-panel="" ba-panel-class="tabs-panel xsmall-panel with-scroll"><uib-tabset class="tabs-right"><uib-tab heading="Start"><p class="text-center">Take up one idea.</p><div class="kameleon-icon-tabs kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Phone-Booth\' | kameleonImg )}}"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading="Get it done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Achieve"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/ui/tabs/tabs.html','<div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel medium-panel"><div ng-include="\'app/pages/ui/tabs/mainTabs.html\'"></div></div></div><div class="col-md-6 tabset-group" ng-include="\'app/pages/ui/tabs/sideTabs.html\'"></div></div><div class="row accordions-row"><div class="col-md-6" ng-include="\'app/pages/ui/tabs/sampleAccordion.html\'"></div><div class="col-md-6" ng-include="\'app/pages/ui/tabs/contextualAccordion.html\'"></div></div></div>');
$templateCache.put('app/pages/ui/typography/typography.html','<div class="typography-document-samples row-fluid"><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll heading-widget" ba-panel-title="Text Size"><div class="section-block"><h1>H1. Heading 1</h1><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h2>H2. Heading 2</h2><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h3>H3. Heading 3</h3><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h4>H4. Heading 4</h4><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra,.</p></div><div class="section-block"><h5>H5. Heading 5</h5><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</p></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll more-text-widget" ba-panel-title="Some more text"><div class="section-block light-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis.</p></div><div class="section-block regular-text"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id.</p></div><div class="section-block upper-text bold-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class="section-block bold-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullam-corper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class="section-block small-text"><p>Secondary text. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar,</p><p>lacinia scelerisque pharetra, placerat vestibulum eleifend</p><p>pellentesque, mi nam.</p></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll lists-widget" ba-panel-title="Lists"><div class="section-block"><h5 class="list-header">Unordered list:</h5><ul class="blur"><li>Lorem ipsum dolor sit amet</li><li>\u0421lacinia scelerisque pharetra<ul><li>Dui rhoncus quisque integer lorem<ul><li>Libero iaculis vestibulum eu vitae</li></ul></li></ul></li><li>Nisl lectus nibh habitasse suspendisse ut</li><li><span>Posuere cursus hac, vestibulum wisi nulla bibendum</span></li></ul><h5 class="list-header">Ordered Lists:</h5><ol class="blur"><li><span>Eu non nec cursus quis mollis, amet quam nec</span></li><li><span>Et suspendisse, adipiscing fringilla ornare sit ligula sed</span><ol><li><span>Interdum et justo nulla</span><ol><li><span>Magna amet, suscipit suscipit non amet</span></li></ol></li></ol></li><li><span>Metus duis eu non eu ridiculus turpis</span></li><li><span>Neque egestas id fringilla consectetuer justo curabitur, wisi magna neque commodo volutpat</span></li></ol><div class="accent">Important text fragment. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</div></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll color-widget" ba-panel-title="Text Color"><div class="section-block red-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p></div><div class="section-block yellow-text"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id nibh ultricies vehicula ut id elit. In sed ornare nulla.</p></div><div class="section-block links"><p>Lorem ipsum <a href="">dolor</a> sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis <a href="">ullamcorper</a> ligula sodales at. Nulla tellus elit, varius non commodo eget, <a href="">mattis</a> vel eros. In sed ornare nulla.</p></div><div class="section-block links"><p><a href="">Active link \u2014 #209e91</a></p><p class="hovered"><a href="">Hover link \u2014 #17857a</a></p></div></div></div></div><div class="row-fluid"><div class="col-lg-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="banner-column-panel"><div class="banner"><div class="large-banner-wrapper"><img ng-src="{{::( \'app/typography/banner.png\' | appImage )}}" alt=""></div><div class="banner-text-wrapper"><div class="banner-text"><h1>Simple Banner Text</h1><p>Lorem ipsum dolor sit amet</p><p>Odio amet viverra rutrum</p></div></div></div><div class="section"><h2>Columns</h2><div class="row"><div class="col-sm-6"><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo03.png\' | appImage )}}" alt="" title=""></div><p>Vel elit, eros elementum, id lacinia, duis non ut ut tortor blandit. Mauris <a href="">dapibus</a> magna rutrum. Ornare neque suspendisse <a href="">phasellus wisi</a>, quam cras pede rutrum suspendisse, <a href="">felis amet eu</a>. Congue magna elit quisque quia, nullam justo sagittis, ante erat libero placerat, proin condimentum consectetuer lacus. Velit condimentum velit, sed penatibus arcu nulla.</p></div><div class="col-sm-6"><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo01.png\' | appImage )}}" alt="" title=""></div><p>Et suspendisse, adipiscing fringilla ornare sit ligula sed, vel nam. Interdum et justo nulla, fermentum lobortis purus ut eu, duis nibh dolor massa tristique elementum, nibh iste potenti risus fusce aliquet fusce, ullamcorper debitis primis arcu tellus vestibulum ac.</p></div></div><div class="separator"></div><div class="row"><div class="col-sm-4"><h4>Column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo04.png\' | appImage )}}" alt=""></div><p>Eget augue, lacus erat ante egestas scelerisque aliquam, metus molestie leo in habitasse magna maecenas</p><a href="" class="learn-more">Lean more</a></div><div class="col-sm-4"><h4>Yet another column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo05.png\' | appImage )}}" alt=""></div><p>Augue massa et parturient, suspendisse orci nec scelerisque sit, integer nam mauris pede consequat in velit</p><a href="" class="learn-more">Lean more</a></div><div class="col-sm-4"><h4>Third column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo06.png\' | appImage )}}" alt=""></div><p>Eget turpis, tortor lobortis porttitor, vestibulum nullam vehicula aliquam</p><a href="" class="learn-more">Lean more</a></div></div><div class="separator"></div></div></div></div></div>');
$templateCache.put('app/pages/ui/slider/slider.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Ion Range Slider" ba-panel-class="with-scroll"><div class="slider-box"><h5>Basic</h5><ion-slider type="single" grid="false" min="0" max="100" from="45" disable="false"></ion-slider></div><div class="slider-box"><h5>With prefix</h5><ion-slider type="single" grid="true" min="100" max="1200" prefix="$" from="420" disable="false"></ion-slider></div><div class="slider-box"><h5>With postfix</h5><ion-slider type="single" grid="true" min="-90" max="90" postfix="\xB0" from="36" disable="false"></ion-slider></div><div class="slider-box"><h5>Two way range</h5><ion-slider type="double" grid="true" min="100" max="1200" from="420" to="900" disable="false"></ion-slider></div><div class="slider-box"><h5>With Steps</h5><ion-slider type="single" grid="true" min="0" max="1000" from="300" step="50" disable="false"></ion-slider></div><div class="slider-box"><h5>Decorating numbers</h5><ion-slider type="single" grid="true" min="0" max="1000000" from="300000" step="1000" prettify-separator="." prettify="true" disable="false"></ion-slider></div><div class="slider-box"><h5>Using custom values array</h5><ion-slider type="single" grid="true" from="5" step="1000" values="[\'January\', \'February\', \'March\', \'April\', \'May\', \'June\', \'July\', \'August\', \'September\', \'October\', \'November\', \'December\']" disable="false"></ion-slider></div><div class="slider-box"><h5>Disabled</h5><ion-slider type="single" grid="false" min="0" max="100" from="45" disable="true"></ion-slider></div></div></div></div>');
$templateCache.put('app/pages/tables/smart/tables.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Rows" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableRowTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Cells" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Smart Table With Filtering, Sorting And Pagination" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/smartTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/tables/basic/tables.html','<div class="widgets"><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Hover Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/hoverRows.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Bordered Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/borderedTable.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Condensed Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/condensedTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Striped Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/stripedRows.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Contextual Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/contextualTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Responsive Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/responsiveTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/user/list/list.html','<div class="user-page row" ng-controller="userListCtrl as vm"><div ba-panel="" ba-panel-title="User List"><div class="pull-right back"><a ui-sref="main.user.new"><span translate="">billinglist.makeapayment</span> <i class="fa fa-plus" aria-hidden="true"></i></a></div><user-list></user-list><user-filter></user-filter></div></div>');
$templateCache.put('app/pages/tables/widgets/basicTable.html','<div class="horizontal-scroll"><table class="table"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Downloads</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">DAU</th><th class="table-arr"></th><th class="align-right">MAU</th><th class="table-arr"></th><th class="align-right">LTV</th><th class="table-arr"></th><th class="align-right">Users %</th><th class="table-arr"></th></tr></thead><tbody><tr><td><img src="img/chrome.svg" width="20" height="20"></td><td class="nowrap">Google Chrome</td><td class="align-right">10,392</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">3,822</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,214</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">899</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">7,098</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">178</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">45%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/firefox.svg" width="20" height="20"></td><td class="nowrap">Mozilla Firefox</td><td class="align-right">7,873</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">6,003</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,031</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">897</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">8,997</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">28%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/ie.svg" width="20" height="20"></td><td class="nowrap">Internet Explorer</td><td class="align-right">5,890</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,492</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">2,102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">27</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,039</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">99</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">17%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/safari.svg" width="20" height="20"></td><td class="nowrap">Safari</td><td class="align-right">4,001</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">2,039</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">1,001</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">104</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,983</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">209</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">14%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/opera.svg" width="20" height="20"></td><td class="nowrap">Opera</td><td class="align-right">1,833</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">983</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">83</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">19</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">1,099</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">103</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">5%</td><td class="table-arr"><i class="icon-up"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/borderedTable.html','<div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="align-right">Purchases</th><th class="align-right">%</th></tr></thead><tbody><tr ng-repeat="item in metricsTableData"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="align-right">{{item.purchases}}</td><td class="align-right">{{item.percent}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/condensedTable.html','<div class="horizontal-scroll"><table class="table table-condensed"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Status</th></tr></thead><tbody><tr ng-repeat="item in peopleTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><button class="status-button btn btn-xs btn-{{item.status}}">{{item.status}}</button></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/contextualTable.html','<table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr class="primary"><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr class="success"><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr class="warning"><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr class="danger"><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr class="info"><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableRowTable.html','<div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addUser()">Add row</button></div><table class="table table-bordered table-hover table-condensed"><tr><td></td><td>Name</td><td>Status</td><td>Group</td><td>Actions</td></tr><tr ng-repeat="user in users" class="editable-row"><td>{{$index}}</td><td><span editable-text="user.name" e-name="name" e-form="rowform" e-required="">{{ user.name || \'empty\' }}</span></td><td class="select-td"><span editable-select="user.status" e-name="status" e-form="rowform" e-selectpicker="" e-ng-options="s.value as s.text for s in statuses">{{ showStatus(user) }}</span></td><td class="select-td"><span editable-select="user.group" e-name="group" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.text for g in groups">{{ showGroup(user) }}</span></td><td><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == user"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="removeUser($index)">Delete</button></div></td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableTable.html','<div class="horizontal-scroll"><table class="table table-hover" st-table="editableTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr></thead><tbody><tr ng-repeat="item in editableTableData" class="editable-tr-wrap"><td class="table-id">{{item.id}}</td><td><span editable-text="item.firstName" blur="cancel">{{item.firstName}}</span></td><td><span editable-text="item.lastName" blur="cancel">{{item.lastName}}</span></td><td><span editable-text="item.username" blur="cancel">{{item.username}}</span></td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><span editable-text="item.age" blur="cancel">{{item.age}}</span></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="12" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/hoverRows.html','<div class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">%</th><th class="table-arr"></th></tr></thead><tbody><tr ng-repeat="item in metricsTableData" class="no-top-border"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isVisitsUp, \'icon-down\': !item.isVisitsUp }"></i></td><td class="align-right">{{item.purchases}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPurchasesUp, \'icon-down\': !item.isPurchasesUp }"></i></td><td class="align-right">{{item.percent}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPercentUp, \'icon-down\': !item.isPercentUp }"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/responsiveTable.html','<div class="table-responsive"><table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table></div>');
$templateCache.put('app/pages/tables/widgets/smartTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table class="table" st-table="smartTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr><tr><th></th><th><input st-search="firstName" placeholder="Search First Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastName" placeholder="Search Last Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="username" placeholder="Search Username" class="input-sm form-control search-input" type="search"></th><th><input st-search="email" placeholder="Search Email" class="input-sm form-control search-input" type="search"></th><th><input st-search="age" placeholder="Search Age" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/stripedRows.html','<div class="vertical-scroll"><table class="table table-striped"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/user/new/new.html','<div class="client-page" ng-controller="userNewCtrl as vm"><div ba-panel="" ba-panel-title="New User"><div class="pull-right back"><a ui-sref="main.users.list" class="newlink">{{\'usernewpage.back\' | translate}} <i class="fa fa-chevron-right" aria-hidden="true"></i></a></div><form name="form" ng-submit="vm.create()" role="form"><div class="client-inner"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 pull-left client-panel"><div class="client-body"><div class="panel-content"><div class="header" translate="">usernewpage.generalinformation</div><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{ \'has-error\': form.firstname.$dirty && form.firstname.$error.required }"><label for="firstname" translate="">profilepage.firstname</label> <input type="text" name="firstname" id="firstname" class="form-control" placeholder="Add a first name" ng-model="vm.firstname" required=""> <span ng-show="form.firstname.$dirty && form.firstname.$error.required" class="help-block" translate="">usernewpage.firstnamereq</span></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{ \'has-error\': form.lastname.$dirty && form.lastname.$error.required }"><label for="lastname" translate="">profilepage.lastname</label> <input type="text" name="lastname" id="lastname" class="form-control" placeholder="Add a last name" ng-model="vm.lastname" required=""> <span ng-show="form.lastname.$dirty && form.lastname.$error.required" class="help-block" translate="">usernewpage.lastnamereq</span></div></div></div><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{ \'has-error\': form.email.$dirty && form.email.$error.required }"><label for="email" translate="">profilepage.email</label> <input type="text" name="email" id="email" class="form-control" placeholder="example@address.com" ng-model="vm.email" required=""> <span ng-show="form.email.$dirty && form.email.$error.required" class="help-block" translate="">usernewpage.email</span></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{ \'has-error\': form.phone.$dirty && form.phone.$error.required }"><label for="email" translate="">profilepage.phone</label> <input type="text" name="phone" id="phone" class="form-control" placeholder="example (123) 555-6789" ng-model="vm.phone" required=""> <span ng-show="form.phone.$dirty && form.phone.$error.required" class="help-block" translate="">usernewpage.phone</span></div></div></div><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><input type="password" class="form-control" ng-model="vm.password" placeholder="Password" name="password" required="required" ng-minlength="6"><div ng-if="form.password.$touched || signupSubmitted"><p ng-show="form.password.$error.required" class="help-block">Password is required</p><p ng-show="form.password.$error.minlength" class="help-block">Minimum 6 character</p></div></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><input type="password" class="form-control" name="confirm_password" ng-model="vm.confirm_password" placeholder="Confirm password" match-password="vm.password" required=""><div ng-if="form.confirm_password.$touched || signupSubmitted"><p ng-show="form.confirm_password.$error.required" class="help-block">Confirm password is required</p><p ng-show="form.confirm_password.$error.matchPassword && !form.confirm_password.$error.required" class="help-block">Confirm password didn\'t match</p></div></div></div></div></div></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 pull-left client-panel"><div class="client-body"><div class="panel-content"><div class="header" translate="">clientnewpage.userinfo</div><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{ \'has-error\': form.firstname.$dirty && form.firstname.$error.required }"><label for="firstname" translate="">clientnewpage.firstname</label> <input type="text" name="firstname" id="firstname" class="form-control" placeholder="Add Client First Name" ng-model="vm.firstname" required=""> <span ng-show="form.firstname.$dirty && form.firstname.$error.required" class="help-block" translate="">clientnewpage.firstnamereq</span></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group" ng-class="{ \'has-error\': form.lastname.$dirty && form.lastname.$error.required }"><label for="lastname" translate="">clientnewpage.lastname</label> <input type="text" name="lastname" id="lastname" class="form-control" placeholder="Add Client Last Name" ng-model="vm.lastname" required=""> <span ng-show="form.lastname.$dirty && form.lastname.$error.required" class="help-block" translate="">clientnewpage.lastnamereq</span></div></div></div><div class="row"><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><input type="password" class="form-control" ng-model="vm.password" placeholder="Password" name="password" required="required" ng-minlength="6"><div ng-if="form.password.$touched || signupSubmitted"><p ng-show="form.password.$error.required" class="help-block">Password is required</p><p ng-show="form.password.$error.minlength" class="help-block">Minimum 6 character</p></div></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="form-group"><input type="password" class="form-control" name="confirm_password" ng-model="vm.confirm_password" placeholder="Confirm password" match-password="vm.password" required=""><div ng-if="form.confirm_password.$touched || signupSubmitted"><p ng-show="form.confirm_password.$error.required" class="help-block">Confirm password is required</p><p ng-show="form.confirm_password.$error.matchPassword && !form.confirm_password.$error.required" class="help-block">Confirm password didn\'t match</p></div></div></div></div></div></div></div><div class="col-xlg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 pull-right client-panel"><div class="client-body"><div class="panel-content"><div class="header" translate="">clientnewpage.timezone</div><div class="row padding-client"><div class="col-md-12"><div class="col-md-4"><span ng-if="vm.selected"><img width="150px" ng-src="{{ vm.selected }}"></span> <span ng-if="!vm.selected"><img width="150px" src="../../../../assets/img/blank_avatar_thumbnail.jpg"></span></div><div class="col-md-3"><button type="button" class="btn btn-default" ng-click="vm.open(\'lg\')">image gallery</button></div><div class="col-md-3"><button type="button" class="btn btn-default" ng-click="vm.upload(\'lg\')">upload image</button></div></div></div></div></div><div class="row col-sm-12"><div class="form-actions pull-right"><button type="submit" ng-disabled="form.$invalid || vm.dataLoading" class="btn btn-primary" translate="">clientnewpage.button</button> <img ng-if="vm.dataLoading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="></div></div></div></div></form></div></div>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<ul class="breadcrumb al-breadcrumb"><li><a href="#/dashboard">Home</a></li><li>{{ activePageTitle }}</li></ul>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notifications</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in notifications"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (users[msg.userId].name | profilePicture) )}}"></div><div class="msg-area"><div ng-bind-html="getMessage(msg)"></div><span>{{ msg.time }}</span></div></a></div><a href="">See all notifications</a></div></li><li uib-dropdown=""><a href="" class="msg" uib-dropdown-toggle=""><i class="fa fa-envelope-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Messages</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in messages"><div class="img-area"><img class="photo-msg-item" ng-src="{{::( users[msg.userId].name | profilePicture )}}"></div><div class="msg-area"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href="">See all messages</a></div></li></ul>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a> <a href="#/dashboard" class="al-logo clearfix"><div class="logo-position"><img src="../../../../assets/img/theme/logo.png" width="100%" alt=""></div></a><div class="user-profile clearfix"><a ui-sref="login" class="signout"><i class="fa fa-power-off"></i>Sign out</a></div></div>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');
$templateCache.put('app/pages/charts/amCharts/areaChart/areaChart.html','<div id="areaChart" class="admin-chart" ng-controller="AreaChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/barChart/barChart.html','<div id="barChart" class="admin-chart" ng-controller="BarChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/ganttChart/ganttChart.html','<div id="gnattChart" class="admin-chart" ng-controller="ganttChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/pieChart/pieChart.html','<div id="pieChart" class="admin-chart" ng-controller="PieChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/combinedChart/combinedChart.html','<div id="zoomAxisChart" class="admin-chart" ng-controller="combinedChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/funnelChart/funnelChart.html','<div id="funnelChart" class="admin-chart" ng-controller="FunnelChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/lineChart/lineChart.html','<div id="lineChart" class="admin-chart" ng-controller="LineChartCtrl"></div>');
$templateCache.put('app/pages/sites/list/sitesFilter/sitesFilter.html','<form name="filter" ng-submit="vm.filter()" role="filter"><div class="right-filter col-xlg-2 col-lg-3 col-md-3 col-sm-3 col-xs-3"><nav id="menu" mmenu=""><div id="app"><ul><li id="setting-client"><em class="Counter"><span ng-if="vm.client">{{vm.client.clientName}}</span></em> <span>Client</span><div id="clients"><div class="mm-search"><input type="text" placeholder="Search" ng-model="clientSearch"></div><ul><li class="searchresult" ng-repeat="client in vm.checkpoints | filter:itemSearch" ng-class="{\'selected\':client.selected}"><a href="" ng-click="vm.clienttoggle(client)">{{client.clientName}}</a></li><li class="Divider">&nbsp;</li></ul><div ng-show="(vm.checkpoints | filter:clientSearch).length == 0" class="mm-noresultsmsg">No results found.</div></div></li><li id="setting-site"><em class="Counter"><span ng-if="vm.site">{{vm.site.siteName}}</span></em> <span>Site</span><div id="sites"><div class="mm-search"><input type="text" placeholder="Search" ng-model="siteSearch"></div><ul><li class="searchresult" ng-repeat="site in vm.checkpoints | filter:siteSearch" ng-class="{\'selected\':site.selected}"><a href="" ng-click="vm.sitetoggle(site)">{{site.siteName}}</a></li><li class="Divider">&nbsp;</li></ul><div ng-show="(vm.checkpoints | filter:siteSearch).length == 0" class="mm-noresultsmsg">No results found.</div></div></li><li id="setting-devices"><em class="Counter"><span ng-if="vm.device">{{vm.device.deviceserial}}</span></em> <span>Serial</span><div id="devices"><div class="mm-search"><input type="text" placeholder="Search" ng-model="deviceSearch"></div><ul><li class="searchresult" ng-repeat="device in vm.checkpoints | filter:siteSearch" ng-class="{\'selected\':device.selected}"><a href="" ng-click="vm.devicetoggle(device)">{{site.deviceserial}}</a></li><li class="Divider">&nbsp;</li></ul><div ng-show="(vm.checkpoints | filter:deviceSearch).length == 0" class="mm-noresultsmsg">No results found.</div></div></li><li id="setting-radius"><em class="Counter">5 miles</em> <span>Created date</span><div id="radius"><ul><li><span>0 miles</span> <input type="radio" name="radius" class="Check"></li><li><span>1 mile</span> <input type="radio" name="radius" class="Check"></li><li><span>2 miles</span> <input type="radio" name="radius" class="Check"></li><li><span>5 miles</span> <input type="radio" name="radius" class="Check" checked=""></li><li><span>10 miles</span> <input type="radio" name="radius" class="Check"></li><li><span>15 miles</span> <input type="radio" name="radius" class="Check"></li><li><span>20 miles</span> <input type="radio" name="radius" class="Check"></li></ul><a href="#settings" class="button">Set range</a></div></li><li id="setting-pricerange"><em class="Counter">$100.000 - $200.000</em> <span>Pricerange</span><div id="pricerange"><label for="price-from">Price from</label><div class="date-picker-map"><input date-range-picker="" id="daterange1" name="daterange1" class="form-control date-picker" type="text" ng-model="vm.date" required=""></div><br><a href="#settings" class="button">Set range</a></div></li><li class="Divider Spacer">Type of property</li><li><span>Active</span> <input type="checkbox" class="Toggle"></li><li><span>Apartment</span> <input type="checkbox" class="Toggle"></li><li><span>Unit</span> <input type="checkbox" class="Toggle"></li><li><span>Townhouse</span> <input type="checkbox" class="Toggle"></li></ul><div class="pull-left col-xlg-6 col-lg-6 col-md-12 col-sm-12 col-xs-12"><button type="submit" class="button btn btn-default btn-sub">Search</button></div><div class="pull-right col-xlg-6 col-lg-6 col-md-12 col-sm-12 col-xs-12"><button ng-click="vm.reset()" type="submit" class="button btn btn-default btn-reset pull-right">Reset</button></div></div></nav></div></form>');
$templateCache.put('app/pages/sites/list/sitesList/sitesList.html','<div class="site-inner col-xlg-10 col-lg-9 col-md-9 col-sm-9 col-xs-9 site-panel"><div class="site-body"><div class="panel-content"><div class="header">Site Information</div><div class="row"><div class="bs-component"><table class="table table-striped table-hover"><thead><tr><th>Id</th><th>Site Name</th><th>Client Name</th><th>Site Name</th><th>Device Serial</th><th>Created At</th><th></th></tr></thead><tbody><tr ng-show="vm.sites.length <= 0"><td colspan="5" style="text-align:center;">Loading new data!!</td></tr><tr dir-paginate="site in vm.sites|itemsPerPage:vm.sitesPerPage" class="table-border" total-items="vm.totalSites"><td>{{site.id}}</td><td>{{site.name}}</td><td>{{site.clientName}}</td><td>{{site.siteName}}</td><td>{{site.deviceserial}}</td><td>{{site.createdAt | date:\'dd/MM/yyyy HH:mm:ss\' }}</td><td><div class="btn-group btn-group-sm"><button class="btn btn-info" type="button" ui-sref="main.sites.edit({id: site.id})" app-table-button="pencil"><span class="glyphicon glyphicon-pencil"></span><span class="hidden-xs hidden-sm">&nbsp; {{ \'userlist.edit\' | translate }}</span></button> <button class="btn btn-info" type="button" ui-sref="main.sites.view({id: site.id})" ng-click="displayDataEntries(form)" app-table-button="list"><span class="glyphicon glyphicon-list"></span><span class="hidden-xs hidden-sm">&nbsp;{{ \'userlist.view\' | translate }}</span></button> <button type="button" data-ng-click="vm.deleteSite(row.id, $index)" app-table-button="trash" class="btn btn-info"><span class="glyphicon glyphicon-trash"></span><span class="hidden-xs hidden-sm">&nbsp;{{ \'sitelist.delete\' | translate }}</span></button></div></td></tr></tbody></table><div class="col-xlg- col-lg-6 col-md-6 col-sm-6 col-xs-6"><dir-pagination-controls max-size="8" direction-links="true" boundary-links="true" on-page-change="vm.pageChanged(newPageNumber)"></dir-pagination-controls></div><div class="col-xlg- col-lg-6 col-md-6 col-sm-6 col-xs-6 pull-right"><div class="form-group select-page-size-wrap"><label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="vm.sitesPerPage" ng-options="i for i in [1,10,15,20,25]"></select></label></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/buttonGroups.html','<div class="btn-group-example"><div class="btn-group" role="group" aria-label="Basic example"><button type="button" class="btn btn-danger">Left</button> <button type="button" class="btn btn-danger">Middle</button> <button type="button" class="btn btn-danger">Right</button></div></div><div class="btn-toolbar-example"><div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups"><div class="btn-group" role="group" aria-label="First group"><button type="button" class="btn btn-primary">1</button> <button type="button" class="btn btn-primary">2</button> <button type="button" class="btn btn-primary">3</button> <button type="button" class="btn btn-primary">4</button></div><div class="btn-group" role="group" aria-label="Second group"><button type="button" class="btn btn-primary">5</button> <button type="button" class="btn btn-primary">6</button> <button type="button" class="btn btn-primary">7</button></div><div class="btn-group" role="group" aria-label="Third group"><button type="button" class="btn btn-primary">8</button></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/buttons.html','<div class="basic-btns"><div class="row"><div class="col-md-2"><h5>Default button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5 class="row-sm">Small button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary btn-sm">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default btn-sm">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-sm">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info btn-sm">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning btn-sm">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger btn-sm">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5 class="row-xs">Extra small button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary btn-xs">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default btn-xs">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-xs">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info btn-xs">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning btn-xs">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger btn-xs">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5>Disabled button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary" disabled="disabled">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default" disabled="disabled">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success" disabled="disabled">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info" disabled="disabled">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning" disabled="disabled">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger" disabled="disabled">Danger</button></div></div></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/dropdowns.html','<div class="row btns-row"><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary" uib-dropdown-toggle="">Primary <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-success" uib-dropdown-toggle="">Success <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-info" uib-dropdown-toggle="">Info <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-default" uib-dropdown-toggle="">Default <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-warning" uib-dropdown-toggle="">Warning <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-danger" uib-dropdown-toggle="">Danger <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div></div><h5 class="panel-subtitle">Split button dropdowns</h5><div class="row btns-row"><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary">Primary</button> <button type="button" class="btn btn-primary" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-success">Success</button> <button type="button" class="btn btn-success" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-info">Info</button> <button type="button" class="btn btn-info" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-default">Default</button> <button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-warning">Warning</button> <button type="button" class="btn btn-warning" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-danger">Danger</button> <button type="button" class="btn btn-danger" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/iconButtons.html','<ul class="btn-list clearfix"><li><button type="button" class="btn btn-primary btn-icon"><i class="ion-android-download"></i></button></li><li><button type="button" class="btn btn-default btn-icon"><i class="ion-stats-bars"></i></button></li><li><button type="button" class="btn btn-success btn-icon"><i class="ion-android-checkmark-circle"></i></button></li><li><button type="button" class="btn btn-info btn-icon"><i class="ion-information"></i></button></li><li><button type="button" class="btn btn-warning btn-icon"><i class="ion-android-warning"></i></button></li><li><button type="button" class="btn btn-danger btn-icon"><i class="ion-nuclear"></i></button></li></ul><h5 class="panel-subtitle">Buttons with icons</h5><ul class="btn-list clearfix"><li><button type="button" class="btn btn-primary btn-with-icon"><i class="ion-android-download"></i>Primary</button></li><li><button type="button" class="btn btn-default btn-with-icon"><i class="ion-stats-bars"></i>Default</button></li><li><button type="button" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Success</button></li><li><button type="button" class="btn btn-info btn-with-icon"><i class="ion-information"></i>Info</button></li><li><button type="button" class="btn btn-warning btn-with-icon"><i class="ion-android-warning"></i>Warning</button></li><li><button type="button" class="btn btn-danger btn-with-icon"><i class="ion-nuclear"></i>Danger</button></li></ul>');
$templateCache.put('app/pages/ui/buttons/widgets/largeButtons.html','<div class="row btns-row btns-same-width-lg"><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-primary btn-lg">Primary</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-success btn-lg">Success</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-info btn-lg">Info</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-default btn-lg">Default</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-warning btn-lg">Warning</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-danger btn-lg">Danger</button></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/progressButtons.html','<div class="progress-buttons-container text-center default-text"><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">fill horizontal</span> <button progress-button="progressFunction()" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">fill vertical</span> <button progress-button="progressFunction()" pb-direction="vertical" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">shrink horizontal</span> <button progress-button="progressFunction()" pb-style="shrink" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">shrink vertical</span> <button progress-button="progressFunction()" pb-style="shrink" pb-direction="vertical" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-bottom<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-bottom" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-top<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-top" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-left<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-left" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-right<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-right" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-down<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-down" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-up<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-up" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-left<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-left" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-right<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-right" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-back<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-back" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">flip-open<br>perspective</span> <button progress-button="progressFunction()" pb-style="flip-open" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">slide-down<br>horizontal</span> <button progress-button="progressFunction()" pb-style="slide-down" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">move-up<br>horizontal</span> <button progress-button="progressFunction()" pb-style="move-up" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6"><span class="button-title">top-line<br>horizontal</span> <button progress-button="progressFunction()" pb-style="top-line" class="btn btn-success">Submit</button></section><section class="col-md-6"><span class="button-title">lateral-lines<br>vertical</span> <button progress-button="progressFunction()" pb-style="lateral-lines" class="btn btn-info">Submit</button></section></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/basicModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Error</span></div><div class="modal-body text-center">Your information hasn\'t been saved!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/infoModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Information</span></div><div class="modal-body text-center">You\'ve got a new email!</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/largeModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/smallModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/successModal.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-checkmark modal-icon"></i><span>Success</span></div><div class="modal-body text-center">Your information has been saved successfully</div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/warningModal.html','<div class="modal-content"><div class="modal-header bg-warning"><i class="ion-android-warning modal-icon"></i><span>Warning</span></div><div class="modal-body text-center">Your computer is about to explode!</div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/notifications/notifications.html','<div class="modal-buttons same-width clearfix" ng-controller="NotificationsCtrl"><button type="button" class="btn btn-success" ng-click="showSuccessMsg()">Success Notification</button> <button type="button" class="btn btn-info" ng-click="showInfoMsg()">Info Notification</button> <button type="button" class="btn btn-warning" ng-click="showWarningMsg()">Warning Notification</button> <button type="button" class="btn btn-danger" ng-click="showErrorMsg()">Danger Notification</button></div>');
$templateCache.put('app/pages/ui/modals/progressModal/progressModal.html','<div class="modal-content" ng-controller="ProgressModalCtrl"><div class="modal-body"><progress-bar-round></progress-bar-round></div><div class="modal-footer"></div></div>');
$templateCache.put('app/pages/ui/icons/widgets/fontAwesomeIcons.html','<div class="row icons-list success awesomeIcons"><div class="col-xs-2" ng-repeat="icon in icons.fontAwesomeIcons"><i class="fa {{icon}}"></i></div></div><a href="http://fortawesome.github.io/Font-Awesome/icons/" target="_blank" class="see-all-icons">See all Font Awesome icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/ionicons.html','<div class="row icons-list primary"><div class="col-xs-2" ng-repeat="icon in icons.ionicons"><i class="{{icon}}"></i></div></div><a href="http://ionicons.com/" target="_blank" class="see-all-icons">See all ionicons icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/kameleon.html','<div class="row clearfix"><div class="kameleon-row" ng-repeat="icon in icons.kameleonIcons"><div class="kameleon-icon"><img ng-src="{{:: (icon.img | kameleonImg )}}"><span>{{icon.name}}</span></div></div></div><a href="http://www.kameleon.pics/" target="_blank" class="see-all-icons">See all Kamaleon icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/kameleonRounded.html','<div class="row clearfix"><div class="kameleon-row" ng-repeat="icon in icons.kameleonRoundedIcons"><div class="kameleon-icon with-round-bg {{icon.color}}"><img ng-src="{{::( icon.img | kameleonImg )}}"><span>{{ icon.name }}</span></div></div></div><a href="http://www.kameleon.pics/" target="_blank" class="see-all-icons">See all Kamaleon icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/socicon.html','<div class="row icons-list danger"><div class="col-xs-2" ng-repeat="icon in icons.socicon"><i class="socicon">{{ icon }}</i></div></div><a href="http://www.socicon.com/chart.php" target="_blank" class="see-all-icons">See all Socicon icons</a>');
$templateCache.put('app/pages/ui/progressBars/widgets/animated.html','<div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped active" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning progress-bar-striped active" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger progress-bar-striped active" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/basic.html','<div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/label.html','<div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%">40% Complete (success)</div></div><div class="progress"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%">20% Complete</div></div><div class="progress"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%">60% Complete (warning)</div></div><div class="progress"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%">80% Complete (danger)</div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/stacked.html','<div class="progress"><div class="progress-bar progress-bar-success" style="width: 35%"><span class="sr-only">35% Complete (success)</span></div><div class="progress-bar progress-bar-warning progress-bar-striped" style="width: 20%"><span class="sr-only">20% Complete (warning)</span></div><div class="progress-bar progress-bar-danger" style="width: 10%"><span class="sr-only">10% Complete (danger)</span></div><div class="progress-bar progress-bar-info progress-bar-striped active" style="width: 20%"><span class="sr-only">20% Complete (warning)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/striped.html','<div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info progress-bar-striped" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning progress-bar-striped" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger progress-bar-striped" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/user/list/list/userList.html','<div class="user-inner col-xlg-10 col-lg-9 col-md-9 col-sm-9 col-xs-9 user-panel"><div class="user-body"><div class="panel-content"><div class="header">user Information</div><div class="row"><div class="bs-component"><table class="table table-striped table-hover"><thead><tr><th>Id</th><th>user Name</th><th>Client Name</th><th>Site Name</th><th>Device Serial</th><th>Created At</th><th></th></tr></thead><tbody><tr ng-show="vm.users.length <= 0"><td colspan="5" style="text-align:center;">Loading new data!!</td></tr><tr dir-paginate="user in vm.users|itemsPerPage:vm.usersPerPage" class="table-border" total-items="vm.totalusers"><td>{{user.id}}</td><td>{{user.name}}</td><td>{{user.clientName}}</td><td>{{user.siteName}}</td><td>{{user.deviceserial}}</td><td>{{user.createdAt | date:\'dd/MM/yyyy HH:mm:ss\' }}</td><td><div class="btn-group btn-group-sm"><button class="btn btn-info" type="button" ui-sref="main.users.edit({id: user.id})" app-table-button="pencil"><span class="glyphicon glyphicon-pencil"></span><span class="hidden-xs hidden-sm">&nbsp; {{ \'userlist.edit\' | translate }}</span></button> <button class="btn btn-info" type="button" ui-sref="main.users.view({id: user.id})" ng-click="displayDataEntries(form)" app-table-button="list"><span class="glyphicon glyphicon-list"></span><span class="hidden-xs hidden-sm">&nbsp;{{ \'userlist.view\' | translate }}</span></button> <button type="button" data-ng-click="vm.deleteuser(row.id, $index)" app-table-button="trash" class="btn btn-info"><span class="glyphicon glyphicon-trash"></span><span class="hidden-xs hidden-sm">&nbsp;{{ \'userlist.delete\' | translate }}</span></button></div></td></tr></tbody></table><div class="col-xlg- col-lg-6 col-md-6 col-sm-6 col-xs-6"><dir-pagination-controls max-size="8" direction-links="true" boundary-links="true" on-page-change="vm.pageChanged(newPageNumber)"></dir-pagination-controls></div><div class="col-xlg- col-lg-6 col-md-6 col-sm-6 col-xs-6 pull-right"><div class="form-group select-page-size-wrap"><label><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="vm.usersPerPage" ng-options="i for i in [1,10,15,20,25]"></select></label></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/user/list/filter/userFilter.html','<form name="filter" ng-submit="vm.filter()" role="filter"><div class="right-filter col-xlg-2 col-lg-3 col-md-3 col-sm-3 col-xs-3"><nav id="menu" mmenu=""><div id="app"><ul><li id="setting-client"><em class="Counter"><span ng-if="vm.client">{{vm.client.clientName}}</span></em> <span>Client</span><div id="clients"><div class="mm-search"><input type="text" placeholder="Search" ng-model="clientSearch"></div><ul><li class="searchresult" ng-repeat="client in vm.checkpoints | filter:itemSearch" ng-class="{\'selected\':client.selected}"><a href="" ng-click="vm.clienttoggle(client)">{{client.clientName}}</a></li><li class="Divider">&nbsp;</li></ul><div ng-show="(vm.checkpoints | filter:clientSearch).length == 0" class="mm-noresultsmsg">No results found.</div></div></li><li id="setting-site"><em class="Counter"><span ng-if="vm.site">{{vm.site.siteName}}</span></em> <span>Site</span><div id="sites"><div class="mm-search"><input type="text" placeholder="Search" ng-model="siteSearch"></div><ul><li class="searchresult" ng-repeat="site in vm.checkpoints | filter:siteSearch" ng-class="{\'selected\':site.selected}"><a href="" ng-click="vm.sitetoggle(site)">{{site.siteName}}</a></li><li class="Divider">&nbsp;</li></ul><div ng-show="(vm.checkpoints | filter:siteSearch).length == 0" class="mm-noresultsmsg">No results found.</div></div></li><li id="setting-devices"><em class="Counter"><span ng-if="vm.device">{{vm.device.deviceserial}}</span></em> <span>Serial</span><div id="devices"><div class="mm-search"><input type="text" placeholder="Search" ng-model="deviceSearch"></div><ul><li class="searchresult" ng-repeat="device in vm.checkpoints | filter:siteSearch" ng-class="{\'selected\':device.selected}"><a href="" ng-click="vm.devicetoggle(device)">{{site.deviceserial}}</a></li><li class="Divider">&nbsp;</li></ul><div ng-show="(vm.checkpoints | filter:deviceSearch).length == 0" class="mm-noresultsmsg">No results found.</div></div></li><li id="setting-radius"><em class="Counter">5 miles</em> <span>Created date</span><div id="radius"><ul><li><span>0 miles</span> <input type="radio" name="radius" class="Check"></li><li><span>1 mile</span> <input type="radio" name="radius" class="Check"></li><li><span>2 miles</span> <input type="radio" name="radius" class="Check"></li><li><span>5 miles</span> <input type="radio" name="radius" class="Check" checked=""></li><li><span>10 miles</span> <input type="radio" name="radius" class="Check"></li><li><span>15 miles</span> <input type="radio" name="radius" class="Check"></li><li><span>20 miles</span> <input type="radio" name="radius" class="Check"></li></ul><a href="#settings" class="button">Set range</a></div></li><li id="setting-pricerange"><em class="Counter">$100.000 - $200.000</em> <span>Pricerange</span><div id="pricerange"><label for="price-from">Price from</label><div class="date-picker-map"><input date-range-picker="" id="daterange1" name="daterange1" class="form-control date-picker" type="text" ng-model="vm.date" required=""></div><br><a href="#settings" class="button">Set range</a></div></li><li class="Divider Spacer">Type of property</li><li><span>Active</span> <input type="checkbox" class="Toggle"></li><li><span>Apartment</span> <input type="checkbox" class="Toggle"></li><li><span>Unit</span> <input type="checkbox" class="Toggle"></li><li><span>Townhouse</span> <input type="checkbox" class="Toggle"></li></ul><div class="pull-left col-xlg-6 col-lg-6 col-md-12 col-sm-12 col-xs-12"><button type="submit" class="button btn btn-default btn-sub">Search</button></div><div class="pull-right col-xlg-6 col-lg-6 col-md-12 col-sm-12 col-xs-12"><button ng-click="vm.reset()" type="submit" class="button btn btn-default btn-reset pull-right">Reset</button></div></div></nav></div></form>');}]);